// @ts-nocheck this file is autogenerated and it seem that it doesn't really adhere to strictNullChecks

/**
 * MatrixALM and MatrixQMS REST API
 * Feel free to make a copy of this definition and change the url below to your instance of MatrixALM or MatrixQMS. For the authentication, create  a token for an admin to try out all the methods. Use at your own risks! Any question? ask us on https://support.matrixreq.com
 *
 * OpenAPI spec version: 2.5
 * 
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 
EXCEPT for this:
        projectFileFilenoGet: make it return an ArrayBuffer, and call response.arrayBuffer();
        projectJobJobFilenoGet: make it return an ArrayBuffer, and call response.arrayBuffer();

        projectFilePost: change input parameter to urlIn to avoid name conflict
        projectSignedreportSIGNNPost: change input parameter to urlIn to avoid name conflict
   */
/// <reference types="node" />

import * as url from "url";
import isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";
const btoa = require("btoa");

const BASE_PATH = "https://clouds5.matrixreq.com/1".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(
        configuration?: Configuration,
        protected basePath: string = BASE_PATH,
        protected fetch: FetchAPI = isomorphicFetch,
    ) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name = "RequiredError";
    constructor(
        public field: string,
        msg?: string,
    ) {
        super(msg);
    }
}

/**
 *
 * @export
 * @interface Access
 */
export interface Access {
    /**
     *
     * @type {string}
     * @memberof Access
     */
    startDate8601?: string;
    /**
     *
     * @type {string}
     * @memberof Access
     */
    endDate8601?: string;
    /**
     *
     * @type {number}
     * @memberof Access
     */
    readWrite?: number;
    /**
     *
     * @type {boolean}
     * @memberof Access
     */
    visitorOnly?: boolean;
}
/**
 *
 * @export
 * @interface AddFileAck
 */
export interface AddFileAck {
    /**
     *
     * @type {number}
     * @memberof AddFileAck
     */
    fileId?: number;
    /**
     *
     * @type {string}
     * @memberof AddFileAck
     */
    fileFullPath?: string;
    /**
     *
     * @type {string}
     * @memberof AddFileAck
     */
    key?: string;
}
/**
 *
 * @export
 * @interface AddItemAck
 */
export interface AddItemAck {
    /**
     *
     * @type {number}
     * @memberof AddItemAck
     */
    itemId?: number;
    /**
     *
     * @type {number}
     * @memberof AddItemAck
     */
    serial?: number;
    /**
     *
     * @type {string}
     * @memberof AddItemAck
     */
    originTag?: string;
    /**
     *
     * @type {CleanupFail}
     * @memberof AddItemAck
     */
    cleanupFail?: CleanupFail;
}
/**
 *
 * @export
 * @interface AuthType
 */
export interface AuthType {
    /**
     *
     * @type {string}
     * @memberof AuthType
     */
    reason?: string;
    /**
     *
     * @type {string}
     * @memberof AuthType
     */
    login?: string;
    /**
     *
     * @type {string}
     * @memberof AuthType
     */
    password?: string;
    /**
     *
     * @type {string}
     * @memberof AuthType
     */
    clientIp?: string;
    /**
     *
     * @type {boolean}
     * @memberof AuthType
     */
    internalQuery?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AuthType
     */
    csrfOk?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AuthType
     */
    basicAuth?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AuthType
     */
    oAuth?: boolean;
    /**
     *
     * @type {string}
     * @memberof AuthType
     */
    token?: string;
    /**
     *
     * @type {VerifiedAuth}
     * @memberof AuthType
     */
    verifiedAuth?: VerifiedAuth;
}
/**
 *
 * @export
 * @interface CalendarType
 */
export interface CalendarType {
    /**
     *
     * @type {string}
     * @memberof CalendarType
     */
    dateString?: string;
    /**
     *
     * @type {number}
     * @memberof CalendarType
     */
    auditIdMin?: number;
    /**
     *
     * @type {number}
     * @memberof CalendarType
     */
    auditIdMax?: number;
    /**
     *
     * @type {number}
     * @memberof CalendarType
     */
    nbChanges?: number;
}
/**
 *
 * @export
 * @interface CategoryAndRoot
 */
export interface CategoryAndRoot {
    /**
     *
     * @type {string}
     * @memberof CategoryAndRoot
     */
    category?: string;
    /**
     *
     * @type {string}
     * @memberof CategoryAndRoot
     */
    rootFolder?: string;
}
/**
 *
 * @export
 * @interface CategoryAndSettingListType
 */
export interface CategoryAndSettingListType {
    /**
     *
     * @type {Array<SettingType>}
     * @memberof CategoryAndSettingListType
     */
    settingList?: Array<SettingType>;
    /**
     *
     * @type {number}
     * @memberof CategoryAndSettingListType
     */
    categoryId?: number;
    /**
     *
     * @type {string}
     * @memberof CategoryAndSettingListType
     */
    categoryShort?: string;
}
/**
 *
 * @export
 * @interface CategoryExtendedListType
 */
export interface CategoryExtendedListType {
    /**
     *
     * @type {Array<CategoryExtendedType>}
     * @memberof CategoryExtendedListType
     */
    categoryExtended?: Array<CategoryExtendedType>;
}
/**
 *
 * @export
 * @interface CategoryExtendedType
 */
export interface CategoryExtendedType {
    /**
     *
     * @type {CategoryType}
     * @memberof CategoryExtendedType
     */
    category?: CategoryType;
    /**
     *
     * @type {FieldListType}
     * @memberof CategoryExtendedType
     */
    fieldList?: FieldListType;
    /**
     *
     * @type {Array<string>}
     * @memberof CategoryExtendedType
     */
    enable?: Array<string>;
}
/**
 *
 * @export
 * @interface CategoryFull
 */
export interface CategoryFull {
    /**
     *
     * @type {ProjectType}
     * @memberof CategoryFull
     */
    project?: ProjectType;
    /**
     *
     * @type {CategoryType}
     * @memberof CategoryFull
     */
    categ?: CategoryType;
    /**
     *
     * @type {TrimFolder}
     * @memberof CategoryFull
     */
    folder?: TrimFolder;
    /**
     *
     * @type {Array<RestField>}
     * @memberof CategoryFull
     */
    fieldList?: Array<RestField>;
}
/**
 *
 * @export
 * @interface CategoryType
 */
export interface CategoryType {
    /**
     *
     * @type {number}
     * @memberof CategoryType
     */
    id?: number;
    /**
     *
     * @type {string}
     * @memberof CategoryType
     */
    label?: string;
    /**
     *
     * @type {string}
     * @memberof CategoryType
     */
    shortLabel?: string;
    /**
     *
     * @type {number}
     * @memberof CategoryType
     */
    maxSerial?: number;
}
/**
 *
 * @export
 * @interface CheckPasswordAck
 */
export interface CheckPasswordAck {
    /**
     *
     * @type {string}
     * @memberof CheckPasswordAck
     */
    actualLogin?: string;
    /**
     *
     * @type {number}
     * @memberof CheckPasswordAck
     */
    userId?: number;
    /**
     *
     * @type {UserType}
     * @memberof CheckPasswordAck
     */
    userDetails?: UserType;
    /**
     *
     * @type {number}
     * @memberof CheckPasswordAck
     */
    maxAge?: number;
    /**
     *
     * @type {boolean}
     * @memberof CheckPasswordAck
     */
    singleSignOn?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CheckPasswordAck
     */
    superAdmin?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CheckPasswordAck
     */
    customerAdmin?: boolean;
}
/**
 *
 * @export
 * @interface CleanupFail
 */
export interface CleanupFail {
    /**
     *
     * @type {Array<CleanupField>}
     * @memberof CleanupFail
     */
    fields?: Array<CleanupField>;
    /**
     *
     * @type {boolean}
     * @memberof CleanupFail
     */
    titleCleanedUp?: boolean;
    /**
     *
     * @type {string}
     * @memberof CleanupFail
     */
    titleBeforeCleanup?: string;
    /**
     *
     * @type {string}
     * @memberof CleanupFail
     */
    titleAfterCleanup?: string;
    /**
     *
     * @type {string}
     * @memberof CleanupFail
     */
    itemRef?: string;
}
/**
 *
 * @export
 * @interface CleanupField
 */
export interface CleanupField {
    /**
     *
     * @type {number}
     * @memberof CleanupField
     */
    fieldId?: number;
    /**
     *
     * @type {string}
     * @memberof CleanupField
     */
    fieldLabel?: string;
    /**
     *
     * @type {string}
     * @memberof CleanupField
     */
    fieldType?: string;
    /**
     *
     * @type {string}
     * @memberof CleanupField
     */
    beforeCleanup?: string;
    /**
     *
     * @type {string}
     * @memberof CleanupField
     */
    afterCleanup?: string;
}
/**
 *
 * @export
 * @interface CleanupSetting
 */
export interface CleanupSetting {
    /**
     *
     * @type {string}
     * @memberof CleanupSetting
     */
    logger?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof CleanupSetting
     */
    tags?: Array<string>;
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof CleanupSetting
     */
    attributes?: { [key: string]: any };
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof CleanupSetting
     */
    protocols?: { [key: string]: any };
    /**
     *
     * @type {Array<Protocol>}
     * @memberof CleanupSetting
     */
    protocolAttributes?: Array<Protocol>;
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof CleanupSetting
     */
    enforcedAttributes?: { [key: string]: any };
    /**
     *
     * @type {boolean}
     * @memberof CleanupSetting
     */
    cleanup?: boolean;
    /**
     *
     * @type {string}
     * @memberof CleanupSetting
     */
    JSON_SINGLE_QUOTE?: string;
    /**
     *
     * @type {string}
     * @memberof CleanupSetting
     */
    JSON_NO_CLEAUP_SINGLE_QUOTE?: string;
}
/**
 *
 * @export
 * @interface CopyItemAck
 */
export interface CopyItemAck {
    /**
     *
     * @type {Array<string>}
     * @memberof CopyItemAck
     */
    itemsAndFoldersCreated?: Array<string>;
}
/**
 *
 * @export
 * @interface CreateReportJobAck
 */
export interface CreateReportJobAck {
    /**
     *
     * @type {number}
     * @memberof CreateReportJobAck
     */
    jobId?: number;
}
/**
 *
 * @export
 * @interface CrossProjectLink
 */
export interface CrossProjectLink {
    /**
     *
     * @type {OneItem}
     * @memberof CrossProjectLink
     */
    upItem?: OneItem;
    /**
     *
     * @type {OneItem}
     * @memberof CrossProjectLink
     */
    downItem?: OneItem;
    /**
     *
     * @type {string}
     * @memberof CrossProjectLink
     */
    relation?: string;
    /**
     *
     * @type {string}
     * @memberof CrossProjectLink
     */
    creationDate?: string;
    /**
     *
     * @type {number}
     * @memberof CrossProjectLink
     */
    importHistoryId?: number;
}
/**
 *
 * @export
 * @interface ExceptionItemIso
 */
export interface ExceptionItemIso {
    /**
     *
     * @type {string}
     * @memberof ExceptionItemIso
     */
    date?: string;
    /**
     *
     * @type {string}
     * @memberof ExceptionItemIso
     */
    text?: string;
}
/**
 *
 * @export
 * @interface ExceptionStatus
 */
export interface ExceptionStatus {
    /**
     *
     * @type {number}
     * @memberof ExceptionStatus
     */
    nbExceptionsStillStart?: number;
    /**
     *
     * @type {Array<ExceptionItemIso>}
     * @memberof ExceptionStatus
     */
    lastHourExceptions?: Array<ExceptionItemIso>;
}
/**
 *
 * @export
 * @interface ExecuteParam
 */
export interface ExecuteParam {
    /**
     *
     * @type {Array<string>}
     * @memberof ExecuteParam
     */
    input?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof ExecuteParam
     */
    output?: string;
    /**
     *
     * @type {string}
     * @memberof ExecuteParam
     */
    parentFolder?: string;
    /**
     *
     * @type {string}
     * @memberof ExecuteParam
     */
    reason?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof ExecuteParam
     */
    filter?: Array<string>;
    /**
     *
     * @type {Array<FieldAndValue>}
     * @memberof ExecuteParam
     */
    itemPresets?: Array<FieldAndValue>;
    /**
     *
     * @type {Array<FromTo>}
     * @memberof ExecuteParam
     */
    itemFieldMapping?: Array<FromTo>;
    /**
     *
     * @type {number}
     * @memberof ExecuteParam
     */
    single?: number;
}
/**
 *
 * @export
 * @interface ExecuteTestErrorDetails
 */
export interface ExecuteTestErrorDetails {
    /**
     *
     * @type {string}
     * @memberof ExecuteTestErrorDetails
     */
    key?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof ExecuteTestErrorDetails
     */
    errors?: Array<string>;
}
/**
 *
 * @export
 * @interface ExportItemsAck
 */
export interface ExportItemsAck {
    /**
     *
     * @type {number}
     * @memberof ExportItemsAck
     */
    jobId?: number;
}
/**
 *
 * @export
 * @interface FancyFolder
 */
export interface FancyFolder {
    /**
     *
     * @type {Array<FancyLeaf>}
     * @memberof FancyFolder
     */
    children?: Array<FancyLeaf>;
    /**
     *
     * @type {string}
     * @memberof FancyFolder
     */
    icon?: string;
    /**
     *
     * @type {string}
     * @memberof FancyFolder
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof FancyFolder
     */
    title?: string;
    /**
     *
     * @type {string}
     * @memberof FancyFolder
     */
    type?: string;
    /**
     *
     * @type {number}
     * @memberof FancyFolder
     */
    isUnselected?: number;
    /**
     *
     * @type {string}
     * @memberof FancyFolder
     */
    version?: string;
    /**
     *
     * @type {string}
     * @memberof FancyFolder
     */
    mode?: string;
}
/**
 *
 * @export
 * @interface FancyLeaf
 */
export interface FancyLeaf {
    /**
     *
     * @type {string}
     * @memberof FancyLeaf
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof FancyLeaf
     */
    title?: string;
    /**
     *
     * @type {string}
     * @memberof FancyLeaf
     */
    type?: string;
    /**
     *
     * @type {number}
     * @memberof FancyLeaf
     */
    isUnselected?: number;
    /**
     *
     * @type {string}
     * @memberof FancyLeaf
     */
    version?: string;
    /**
     *
     * @type {string}
     * @memberof FancyLeaf
     */
    mode?: string;
}
/**
 *
 * @export
 * @interface FieldAndValue
 */
export interface FieldAndValue {
    /**
     *
     * @type {number}
     * @memberof FieldAndValue
     */
    field?: number;
    /**
     *
     * @type {string}
     * @memberof FieldAndValue
     */
    value?: string;
}
/**
 *
 * @export
 * @interface FieldListType
 */
export interface FieldListType {
    /**
     *
     * @type {Array<FieldType>}
     * @memberof FieldListType
     */
    field?: Array<FieldType>;
}
/**
 *
 * @export
 * @interface FieldType
 */
export interface FieldType {
    /**
     *
     * @type {number}
     * @memberof FieldType
     */
    id?: number;
    /**
     *
     * @type {number}
     * @memberof FieldType
     */
    order?: number;
    /**
     *
     * @type {string}
     * @memberof FieldType
     */
    fieldType?: string;
    /**
     *
     * @type {string}
     * @memberof FieldType
     */
    parameter?: string;
    /**
     *
     * @type {string}
     * @memberof FieldType
     */
    label?: string;
}
/**
 *
 * @export
 * @interface FieldValListType
 */
export interface FieldValListType {
    /**
     *
     * @type {Array<FieldValType>}
     * @memberof FieldValListType
     */
    fieldVal?: Array<FieldValType>;
}
/**
 *
 * @export
 * @interface FieldValType
 */
export interface FieldValType {
    /**
     *
     * @type {number}
     * @memberof FieldValType
     */
    id?: number;
    /**
     *
     * @type {string}
     * @memberof FieldValType
     */
    value?: string;
    /**
     *
     * @type {number}
     * @memberof FieldValType
     */
    hide?: number;
    /**
     *
     * @type {number}
     * @memberof FieldValType
     */
    restricted?: number;
    /**
     *
     * @type {string}
     * @memberof FieldValType
     */
    fieldName?: string;
    /**
     *
     * @type {string}
     * @memberof FieldValType
     */
    fieldType?: string;
}
/**
 *
 * @export
 * @interface FolderAnswer
 */
export interface FolderAnswer {
    /**
     *
     * @type {string}
     * @memberof FolderAnswer
     */
    folder?: string;
    /**
     *
     * @type {Array<ExecuteTestErrorDetails>}
     * @memberof FolderAnswer
     */
    xtcInError?: Array<ExecuteTestErrorDetails>;
}
/**
 *
 * @export
 * @interface FromTo
 */
export interface FromTo {
    /**
     *
     * @type {number}
     * @memberof FromTo
     */
    fromId?: number;
    /**
     *
     * @type {number}
     * @memberof FromTo
     */
    toId?: number;
}
/**
 *
 * @export
 * @interface FromToString
 */
export interface FromToString {
    /**
     *
     * @type {string}
     * @memberof FromToString
     */
    from?: string;
    /**
     *
     * @type {string}
     * @memberof FromToString
     */
    to?: string;
}
/**
 *
 * @export
 * @interface GetAccessAck
 */
export interface GetAccessAck {
    /**
     *
     * @type {Array<UserPermissionType>}
     * @memberof GetAccessAck
     */
    userPermission?: Array<UserPermissionType>;
    /**
     *
     * @type {Array<GroupPermissionType>}
     * @memberof GetAccessAck
     */
    groupPermission?: Array<GroupPermissionType>;
}
/**
 *
 * @export
 * @interface GetDateAck
 */
export interface GetDateAck {
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    dateIso8601?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    timeUserFormat?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    dateUserFormat?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    timeCustomerFormat?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    dateCustomerFormat?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    dateformat?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    timeformat?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    timeZone?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    timeZoneDesc?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    customerDateformat?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    customerTimeformat?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    customerTimezone?: string;
    /**
     *
     * @type {string}
     * @memberof GetDateAck
     */
    customerTimezoneDesc?: string;
}
/**
 *
 * @export
 * @interface GetGroupListAck
 */
export interface GetGroupListAck {
    /**
     *
     * @type {Array<GroupType>}
     * @memberof GetGroupListAck
     */
    groups?: Array<GroupType>;
}
/**
 *
 * @export
 * @interface GetHmlBlobInput
 */
export interface GetHmlBlobInput {
    /**
     *
     * @type {string}
     * @memberof GetHmlBlobInput
     */
    htmlToClean?: string;
}
/**
 *
 * @export
 * @interface GetHtmlBlob
 */
export interface GetHtmlBlob {
    /**
     *
     * @type {AuthType}
     * @memberof GetHtmlBlob
     */
    auth?: AuthType;
    /**
     *
     * @type {number}
     * @memberof GetHtmlBlob
     */
    projectId?: number;
    /**
     *
     * @type {string}
     * @memberof GetHtmlBlob
     */
    inputHtml?: string;
}
/**
 *
 * @export
 * @interface GetItemListAck
 */
export interface GetItemListAck {
    /**
     *
     * @type {string}
     * @memberof GetItemListAck
     */
    docDateCustomerFormat?: string;
    /**
     *
     * @type {string}
     * @memberof GetItemListAck
     */
    docDate?: string;
    /**
     *
     * @type {Array<ItemSimpleType>}
     * @memberof GetItemListAck
     */
    items?: Array<ItemSimpleType>;
    /**
     *
     * @type {Array<ItemSimpleType>}
     * @memberof GetItemListAck
     */
    secondaryItems?: Array<ItemSimpleType>;
}
/**
 *
 * @export
 * @interface GetMonitorAck
 */
export interface GetMonitorAck {
    /**
     *
     * @type {Array<MonitorAction>}
     * @memberof GetMonitorAck
     */
    reminderActions?: Array<MonitorAction>;
    /**
     *
     * @type {string}
     * @memberof GetMonitorAck
     */
    firstLoginDate?: string;
    /**
     *
     * @type {string}
     * @memberof GetMonitorAck
     */
    lastLoginDate?: string;
}
/**
 *
 * @export
 * @interface GetProjectFileListAck
 */
export interface GetProjectFileListAck {
    /**
     *
     * @type {Array<ProjectFileType>}
     * @memberof GetProjectFileListAck
     */
    projectFile?: Array<ProjectFileType>;
}
/**
 *
 * @export
 * @interface GetProjectSettingAck
 */
export interface GetProjectSettingAck {
    /**
     *
     * @type {Array<SettingType>}
     * @memberof GetProjectSettingAck
     */
    settingList?: Array<SettingType>;
    /**
     *
     * @type {Array<CategoryAndSettingListType>}
     * @memberof GetProjectSettingAck
     */
    categorySettingList?: Array<CategoryAndSettingListType>;
    /**
     *
     * @type {Array<PluginSetting>}
     * @memberof GetProjectSettingAck
     */
    pluginSettingsList?: Array<PluginSetting>;
}
/**
 *
 * @export
 * @interface GetProjectStructAck
 */
export interface GetProjectStructAck {
    /**
     *
     * @type {CategoryExtendedListType}
     * @memberof GetProjectStructAck
     */
    categoryList?: CategoryExtendedListType;
    /**
     *
     * @type {string}
     * @memberof GetProjectStructAck
     */
    label?: string;
    /**
     *
     * @type {string}
     * @memberof GetProjectStructAck
     */
    shortLabel?: string;
    /**
     *
     * @type {string}
     * @memberof GetProjectStructAck
     */
    acl?: string;
    /**
     *
     * @type {string}
     * @memberof GetProjectStructAck
     */
    aclExplanations?: string;
}
/**
 *
 * @export
 * @interface GetReportsAck
 */
export interface GetReportsAck {
    /**
     *
     * @type {Array<ReportType>}
     * @memberof GetReportsAck
     */
    reportList?: Array<ReportType>;
}
/**
 *
 * @export
 * @interface GetSettingAck
 */
export interface GetSettingAck {
    /**
     *
     * @type {Array<SettingType>}
     * @memberof GetSettingAck
     */
    settingList?: Array<SettingType>;
}
/**
 *
 * @export
 * @interface GetTodosAck
 */
export interface GetTodosAck {
    /**
     *
     * @type {Array<Todo>}
     * @memberof GetTodosAck
     */
    todos?: Array<Todo>;
    /**
     *
     * @type {Array<TodoCount>}
     * @memberof GetTodosAck
     */
    todoCounts?: Array<TodoCount>;
}
/**
 *
 * @export
 * @interface GetUserListAck
 */
export interface GetUserListAck {
    /**
     *
     * @type {Array<UserType>}
     * @memberof GetUserListAck
     */
    user?: Array<UserType>;
    /**
     *
     * @type {number}
     * @memberof GetUserListAck
     */
    needDoublePassword?: number;
    /**
     *
     * @type {number}
     * @memberof GetUserListAck
     */
    passwordExpirationDays?: number;
    /**
     *
     * @type {number}
     * @memberof GetUserListAck
     */
    passwordStrength?: number;
    /**
     *
     * @type {number}
     * @memberof GetUserListAck
     */
    maxUsers?: number;
}
/**
 *
 * @export
 * @interface GroupPermissionType
 */
export interface GroupPermissionType {
    /**
     *
     * @type {string}
     * @memberof GroupPermissionType
     */
    groupName?: string;
    /**
     *
     * @type {number}
     * @memberof GroupPermissionType
     */
    permission?: number;
    /**
     *
     * @type {number}
     * @memberof GroupPermissionType
     */
    groupId?: number;
    /**
     *
     * @type {Array<UserTypeSimple>}
     * @memberof GroupPermissionType
     */
    membership?: Array<UserTypeSimple>;
}
/**
 *
 * @export
 * @interface GroupType
 */
export interface GroupType {
    /**
     *
     * @type {string}
     * @memberof GroupType
     */
    groupName?: string;
    /**
     *
     * @type {Array<UserType>}
     * @memberof GroupType
     */
    membership?: Array<UserType>;
    /**
     *
     * @type {Array<ProjectPermissionType>}
     * @memberof GroupType
     */
    permissions?: Array<ProjectPermissionType>;
    /**
     *
     * @type {number}
     * @memberof GroupType
     */
    groupId?: number;
}
/**
 *
 * @export
 * @interface HtmlCompareResult
 */
export interface HtmlCompareResult {
    /**
     *
     * @type {Array<string>}
     * @memberof HtmlCompareResult
     */
    html?: Array<string>;
    /**
     *
     * @type {Array<Array<string>>}
     * @memberof HtmlCompareResult
     */
    htmlMultiple?: Array<Array<string>>;
    /**
     *
     * @type {string}
     * @memberof HtmlCompareResult
     */
    spanElement?: string;
    /**
     *
     * @type {string}
     * @memberof HtmlCompareResult
     */
    addClass?: string;
    /**
     *
     * @type {string}
     * @memberof HtmlCompareResult
     */
    removeClass?: string;
}
/**
 *
 * @export
 * @interface HtmlTestCleanup
 */
export interface HtmlTestCleanup {
    /**
     *
     * @type {Array<CleanupFail>}
     * @memberof HtmlTestCleanup
     */
    cleanups?: Array<CleanupFail>;
}
/**
 *
 * @export
 * @interface IdParent
 */
export interface IdParent {
    /**
     *
     * @type {string}
     * @memberof IdParent
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof IdParent
     */
    parent?: string;
}
/**
 *
 * @export
 * @interface ItemHistoryListType
 */
export interface ItemHistoryListType {
    /**
     *
     * @type {Array<ItemHistoryType>}
     * @memberof ItemHistoryListType
     */
    itemHistory?: Array<ItemHistoryType>;
}
/**
 *
 * @export
 * @interface ItemHistoryType
 */
export interface ItemHistoryType {
    /**
     *
     * @type {number}
     * @memberof ItemHistoryType
     */
    version?: number;
    /**
     *
     * @type {string}
     * @memberof ItemHistoryType
     */
    createdAt?: string;
    /**
     *
     * @type {string}
     * @memberof ItemHistoryType
     */
    createdAtUserFormat?: string;
    /**
     *
     * @type {string}
     * @memberof ItemHistoryType
     */
    deletedAt?: string;
    /**
     *
     * @type {string}
     * @memberof ItemHistoryType
     */
    deletedAtUserFormat?: string;
    /**
     *
     * @type {string}
     * @memberof ItemHistoryType
     */
    title?: string;
    /**
     *
     * @type {number}
     * @memberof ItemHistoryType
     */
    createdByUserId?: number;
    /**
     *
     * @type {string}
     * @memberof ItemHistoryType
     */
    createdByUserLogin?: string;
    /**
     *
     * @type {string}
     * @memberof ItemHistoryType
     */
    reason?: string;
    /**
     *
     * @type {number}
     * @memberof ItemHistoryType
     */
    auditId?: number;
    /**
     *
     * @type {string}
     * @memberof ItemHistoryType
     */
    auditAction?: string;
}
/**
 *
 * @export
 * @interface ItemItemBody
 */
export interface ItemItemBody {
    /**
     * Specify new title for the item -- if not there, keep the old title
     * @type {string}
     * @memberof ItemItemBody
     */
    title?: string;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof ItemItemBody
     */
    itemProperties?: { [key: string]: string };
    /**
     * (optional) List of labels currently applied to this element. If none is specified, will consider there are none. Should be sent as a comma-delimited list of strings
     * @type {string}
     * @memberof ItemItemBody
     */
    labels?: string;
    /**
     * (optional) Specify a new verb for the audit action. Defaults to edit
     * @type {string}
     * @memberof ItemItemBody
     */
    auditAction?: string;
    /**
     * (optional) Name of a new folder to move the item into (exclusive from title and fx arguments)
     * @type {string}
     * @memberof ItemItemBody
     */
    newFolder?: string;
    /**
     * (optional) Indicates a new position within the newfolder. If newFolder is not specified, only changes the position. Exclusive of title and fx arguments. Position is an integer starting at 1
     * @type {number}
     * @memberof ItemItemBody
     */
    newPosition?: number;
    /**
     * The reason why the user is doing this
     * @type {string}
     * @memberof ItemItemBody
     */
    reason: string;
    /**
     * (optional) A filter
     * @type {string}
     * @memberof ItemItemBody
     */
    filter?: string;
    /**
     * (optional) Comma-delimited (%2C)list of references to up items
     * @type {string}
     * @memberof ItemItemBody
     */
    linksUp?: string;
    /**
     * (optional) Comma-delimited (%2C)list of references to down items
     * @type {string}
     * @memberof ItemItemBody
     */
    linksDown?: string;
    /**
     * (optional) will not make the change if the current version is not that one
     * @type {number}
     * @memberof ItemItemBody
     */
    currentVersion?: number;
    /**
     * (optional) when set to 1 says that the only fields to change are those passed
     * @type {number}
     * @memberof ItemItemBody
     */
    onlyThoseFields?: number;
    /**
     * (optional) when set to 1 says that the only labels to change are those passed. To remove a label in this case, prefix it with minus
     * @type {number}
     * @memberof ItemItemBody
     */
    onlyThoseLabels?: number;
    /**
     * (optional) when set to 1 (default) says that the call will fail if any HTML cleanup is involved. With 0 it will clean and not fail
     * @type {number}
     * @memberof ItemItemBody
     */
    failOnCleanup?: number;
    /**
     * (optional) when set to 0 (default) says that linksUp and linksDown only append new links to the existing links in the database
     * @type {number}
     * @memberof ItemItemBody
     */
    linksAreComplete?: number;
}
/**
 *
 * @export
 * @interface ItemSimpleType
 */
export interface ItemSimpleType {
    /**
     *
     * @type {string}
     * @memberof ItemSimpleType
     */
    author?: string;
    /**
     *
     * @type {string}
     * @memberof ItemSimpleType
     */
    birth?: string;
    /**
     *
     * @type {string}
     * @memberof ItemSimpleType
     */
    ref?: string;
    /**
     *
     * @type {string}
     * @memberof ItemSimpleType
     */
    title?: string;
    /**
     *
     * @type {number}
     * @memberof ItemSimpleType
     */
    version?: number;
}
/**
 *
 * @export
 * @interface JobFileWithUrl
 */
export interface JobFileWithUrl {
    /**
     *
     * @type {string}
     * @memberof JobFileWithUrl
     */
    restUrl?: string;
    /**
     *
     * @type {number}
     * @memberof JobFileWithUrl
     */
    jobFileId?: number;
    /**
     *
     * @type {string}
     * @memberof JobFileWithUrl
     */
    visibleName?: string;
    /**
     *
     * @type {string}
     * @memberof JobFileWithUrl
     */
    internalPath?: string;
    /**
     *
     * @type {string}
     * @memberof JobFileWithUrl
     */
    mimeType?: string;
}
/**
 *
 * @export
 * @interface JobWithUrl
 */
export interface JobWithUrl {
    /**
     *
     * @type {string}
     * @memberof JobWithUrl
     */
    getJobUrl?: string;
    /**
     *
     * @type {number}
     * @memberof JobWithUrl
     */
    jobId?: number;
    /**
     *
     * @type {number}
     * @memberof JobWithUrl
     */
    progress?: number;
    /**
     *
     * @type {string}
     * @memberof JobWithUrl
     */
    status?: string;
    /**
     *
     * @type {string}
     * @memberof JobWithUrl
     */
    jobBirth?: string;
    /**
     *
     * @type {string}
     * @memberof JobWithUrl
     */
    jobLastWrite?: string;
    /**
     *
     * @type {string}
     * @memberof JobWithUrl
     */
    project?: string;
}
/**
 *
 * @export
 * @interface JobsStatusWithUrl
 */
export interface JobsStatusWithUrl {
    /**
     *
     * @type {number}
     * @memberof JobsStatusWithUrl
     */
    progress?: number;
    /**
     *
     * @type {string}
     * @memberof JobsStatusWithUrl
     */
    status?: string;
    /**
     *
     * @type {string}
     * @memberof JobsStatusWithUrl
     */
    visibleName?: string;
    /**
     *
     * @type {Array<JobFileWithUrl>}
     * @memberof JobsStatusWithUrl
     */
    jobFile?: Array<JobFileWithUrl>;
}
/**
 *
 * @export
 * @interface JobsWithUrl
 */
export interface JobsWithUrl {
    /**
     *
     * @type {number}
     * @memberof JobsWithUrl
     */
    runningJobs?: number;
    /**
     *
     * @type {number}
     * @memberof JobsWithUrl
     */
    maxRunningJobs?: number;
    /**
     *
     * @type {Array<JobWithUrl>}
     * @memberof JobsWithUrl
     */
    jobs?: Array<JobWithUrl>;
}
/**
 *
 * @export
 * @interface LabelChange
 */
export interface LabelChange {
    /**
     *
     * @type {string}
     * @memberof LabelChange
     */
    label?: string;
    /**
     *
     * @type {Array<LabelChangeDetail>}
     * @memberof LabelChange
     */
    set?: Array<LabelChangeDetail>;
    /**
     *
     * @type {Array<LabelChangeDetail>}
     * @memberof LabelChange
     */
    reset?: Array<LabelChangeDetail>;
}
/**
 *
 * @export
 * @interface LabelChangeDetail
 */
export interface LabelChangeDetail {
    /**
     *
     * @type {number}
     * @memberof LabelChangeDetail
     */
    version?: number;
    /**
     *
     * @type {string}
     * @memberof LabelChangeDetail
     */
    dateIso?: string;
    /**
     *
     * @type {string}
     * @memberof LabelChangeDetail
     */
    dateUser?: string;
}
/**
 *
 * @export
 * @interface LabelEntry
 */
export interface LabelEntry {
    /**
     *
     * @type {string}
     * @memberof LabelEntry
     */
    itemRef?: string;
    /**
     *
     * @type {Array<LabelChange>}
     * @memberof LabelEntry
     */
    labels?: Array<LabelChange>;
}
/**
 *
 * @export
 * @interface LabelHistory
 */
export interface LabelHistory {
    /**
     *
     * @type {Array<LabelEntry>}
     * @memberof LabelHistory
     */
    entries?: Array<LabelEntry>;
}
/**
 *
 * @export
 * @interface LicenseStatus
 */
export interface LicenseStatus {
    /**
     *
     * @type {Array<string>}
     * @memberof LicenseStatus
     */
    modules?: Array<string>;
    /**
     *
     * @type {number}
     * @memberof LicenseStatus
     */
    maxUsers?: number;
    /**
     *
     * @type {number}
     * @memberof LicenseStatus
     */
    currentRWUsers?: number;
    /**
     *
     * @type {Array<LicenseUser>}
     * @memberof LicenseStatus
     */
    licenseUsers?: Array<LicenseUser>;
}
/**
 *
 * @export
 * @interface LicenseUser
 */
export interface LicenseUser {
    /**
     *
     * @type {number}
     * @memberof LicenseUser
     */
    userId?: number;
    /**
     *
     * @type {string}
     * @memberof LicenseUser
     */
    login?: string;
    /**
     *
     * @type {string}
     * @memberof LicenseUser
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof LicenseUser
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof LicenseUser
     */
    level?: string;
}
/**
 *
 * @export
 * @interface ListProjectAndSettings
 */
export interface ListProjectAndSettings {
    /**
     *
     * @type {string}
     * @memberof ListProjectAndSettings
     */
    currentUser?: string;
    /**
     *
     * @type {number}
     * @memberof ListProjectAndSettings
     */
    customerAdmin?: number;
    /**
     *
     * @type {number}
     * @memberof ListProjectAndSettings
     */
    superAdmin?: number;
    /**
     *
     * @type {GetDateAck}
     * @memberof ListProjectAndSettings
     */
    dateInfo?: GetDateAck;
    /**
     *
     * @type {Array<SettingType>}
     * @memberof ListProjectAndSettings
     */
    customerSettings?: Array<SettingType>;
    /**
     *
     * @type {MatrixLicense}
     * @memberof ListProjectAndSettings
     */
    license?: MatrixLicense;
    /**
     *
     * @type {Array<string>}
     * @memberof ListProjectAndSettings
     */
    readWriteUsers?: Array<string>;
    /**
     *
     * @type {Array<UserType>}
     * @memberof ListProjectAndSettings
     */
    allUsers?: Array<UserType>;
    /**
     *
     * @type {string}
     * @memberof ListProjectAndSettings
     */
    licenseStatus?: string;
    /**
     *
     * @type {Array<TodoCount>}
     * @memberof ListProjectAndSettings
     */
    todoCounts?: Array<TodoCount>;
    /**
     *
     * @type {Array<Todo>}
     * @memberof ListProjectAndSettings
     */
    allTodos?: Array<Todo>;
    /**
     *
     * @type {Array<SettingType>}
     * @memberof ListProjectAndSettings
     */
    currentUserSettings?: Array<SettingType>;
    /**
     *
     * @type {Array<MainAndBranch>}
     * @memberof ListProjectAndSettings
     */
    branches?: Array<MainAndBranch>;
    /**
     *
     * @type {string}
     * @memberof ListProjectAndSettings
     */
    serviceEmail?: string;
    /**
     *
     * @type {Array<ProjectType>}
     * @memberof ListProjectAndSettings
     */
    project?: Array<ProjectType>;
    /**
     *
     * @type {string}
     * @memberof ListProjectAndSettings
     */
    serverVersion?: string;
    /**
     *
     * @type {string}
     * @memberof ListProjectAndSettings
     */
    baseUrl?: string;
    /**
     *
     * @type {string}
     * @memberof ListProjectAndSettings
     */
    restUrl?: string;
}
/**
 *
 * @export
 * @interface LogLevel
 */
export interface LogLevel {
    /**
     *
     * @type {string}
     * @memberof LogLevel
     */
    level?: string;
}
/**
 *
 * @export
 * @interface MainAndBranch
 */
export interface MainAndBranch {
    /**
     *
     * @type {string}
     * @memberof MainAndBranch
     */
    mainline?: string;
    /**
     *
     * @type {string}
     * @memberof MainAndBranch
     */
    branch?: string;
    /**
     *
     * @type {string}
     * @memberof MainAndBranch
     */
    user?: string;
    /**
     *
     * @type {string}
     * @memberof MainAndBranch
     */
    branchDateTime?: string;
    /**
     *
     * @type {string}
     * @memberof MainAndBranch
     */
    branchDateTimeUser?: string;
    /**
     *
     * @type {number}
     * @memberof MainAndBranch
     */
    withHistory?: number;
    /**
     *
     * @type {string}
     * @memberof MainAndBranch
     */
    branchUntilTag?: string;
    /**
     *
     * @type {string}
     * @memberof MainAndBranch
     */
    lastMergeDatetime?: string;
    /**
     *
     * @type {string}
     * @memberof MainAndBranch
     */
    lastMergeDatetimeUser?: string;
    /**
     *
     * @type {string}
     * @memberof MainAndBranch
     */
    lastMergeUser?: string;
}
/**
 *
 * @export
 * @interface MatrixLicense
 */
export interface MatrixLicense {
    /**
     *
     * @type {string}
     * @memberof MatrixLicense
     */
    logger?: string;
    /**
     *
     * @type {number}
     * @memberof MatrixLicense
     */
    licenseVersion?: number;
    /**
     *
     * @type {string}
     * @memberof MatrixLicense
     */
    customerName?: string;
    /**
     *
     * @type {number}
     * @memberof MatrixLicense
     */
    customerId?: number;
    /**
     *
     * @type {number}
     * @memberof MatrixLicense
     */
    customerEcommerceId?: number;
    /**
     *
     * @type {string}
     * @memberof MatrixLicense
     */
    customerEmail?: string;
    /**
     *
     * @type {string}
     * @memberof MatrixLicense
     */
    customerPhone?: string;
    /**
     *
     * @type {number}
     * @memberof MatrixLicense
     */
    maxReadWrite?: number;
    /**
     *
     * @type {number}
     * @memberof MatrixLicense
     */
    maxReadOnly?: number;
    /**
     *
     * @type {number}
     * @memberof MatrixLicense
     */
    maxVisitors?: number;
    /**
     *
     * @type {number}
     * @memberof MatrixLicense
     */
    maxTotalUsers?: number;
    /**
     *
     * @type {string}
     * @memberof MatrixLicense
     */
    validTo?: string;
    /**
     *
     * @type {string}
     * @memberof MatrixLicense
     */
    productName?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof MatrixLicense
     */
    options?: Array<string>;
    /**
     *
     * @type {number}
     * @memberof MatrixLicense
     */
    VERSION?: number;
    /**
     *
     * @type {number}
     * @memberof MatrixLicense
     */
    MAX_USERS?: number;
}
/**
 *
 * @export
 * @interface MergeAction
 */
export interface MergeAction {
    /**
     *
     * @type {string}
     * @memberof MergeAction
     */
    action?: string;
    /**
     *
     * @type {string}
     * @memberof MergeAction
     */
    branchItem?: string;
    /**
     *
     * @type {string}
     * @memberof MergeAction
     */
    branchItem2?: string;
    /**
     *
     * @type {string}
     * @memberof MergeAction
     */
    mainlineItem?: string;
    /**
     *
     * @type {string}
     * @memberof MergeAction
     */
    mainlineItem2?: string;
    /**
     *
     * @type {string}
     * @memberof MergeAction
     */
    mainlineFolder?: string;
    /**
     *
     * @type {string}
     * @memberof MergeAction
     */
    request?: string;
    /**
     *
     * @type {string}
     * @memberof MergeAction
     */
    error?: string;
}
/**
 *
 * @export
 * @interface MergeEntry
 */
export interface MergeEntry {
    /**
     *
     * @type {number}
     * @memberof MergeEntry
     */
    id?: number;
    /**
     *
     * @type {string}
     * @memberof MergeEntry
     */
    user?: string;
    /**
     *
     * @type {string}
     * @memberof MergeEntry
     */
    mainlineProject?: string;
    /**
     *
     * @type {string}
     * @memberof MergeEntry
     */
    branchProject?: string;
    /**
     *
     * @type {string}
     * @memberof MergeEntry
     */
    date?: string;
    /**
     *
     * @type {string}
     * @memberof MergeEntry
     */
    dateUser?: string;
    /**
     *
     * @type {string}
     * @memberof MergeEntry
     */
    comments?: string;
    /**
     *
     * @type {number}
     * @memberof MergeEntry
     */
    mainlineProjectId?: number;
    /**
     *
     * @type {number}
     * @memberof MergeEntry
     */
    branchProjectId?: number;
    /**
     *
     * @type {Array<MergeAction>}
     * @memberof MergeEntry
     */
    details?: Array<MergeAction>;
}
/**
 *
 * @export
 * @interface MergeHistory
 */
export interface MergeHistory {
    /**
     *
     * @type {Array<MergeEntry>}
     * @memberof MergeHistory
     */
    entries?: Array<MergeEntry>;
}
/**
 *
 * @export
 * @interface MergeInfo
 */
export interface MergeInfo {
    /**
     *
     * @type {MergeInfoPoint}
     * @memberof MergeInfo
     */
    branchBase?: MergeInfoPoint;
    /**
     *
     * @type {MergeInfoPoint}
     * @memberof MergeInfo
     */
    branchNow?: MergeInfoPoint;
    /**
     *
     * @type {MergeInfoPoint}
     * @memberof MergeInfo
     */
    mainlineBase?: MergeInfoPoint;
    /**
     *
     * @type {MergeInfoPoint}
     * @memberof MergeInfo
     */
    mainlineNow?: MergeInfoPoint;
    /**
     *
     * @type {Array<MergeItemLink>}
     * @memberof MergeInfo
     */
    linksAdded?: Array<MergeItemLink>;
    /**
     *
     * @type {Array<MergeItemLink>}
     * @memberof MergeInfo
     */
    linksDifferent?: Array<MergeItemLink>;
    /**
     *
     * @type {Array<MergeItemLink>}
     * @memberof MergeInfo
     */
    linksDeleted?: Array<MergeItemLink>;
}
/**
 *
 * @export
 * @interface MergeInfoPoint
 */
export interface MergeInfoPoint {
    /**
     *
     * @type {string}
     * @memberof MergeInfoPoint
     */
    project?: string;
    /**
     *
     * @type {string}
     * @memberof MergeInfoPoint
     */
    date?: string;
    /**
     *
     * @type {Array<MergeItem>}
     * @memberof MergeInfoPoint
     */
    items?: Array<MergeItem>;
}
/**
 *
 * @export
 * @interface MergeItem
 */
export interface MergeItem {
    /**
     *
     * @type {string}
     * @memberof MergeItem
     */
    itemRef?: string;
    /**
     *
     * @type {number}
     * @memberof MergeItem
     */
    version?: number;
    /**
     *
     * @type {string}
     * @memberof MergeItem
     */
    title?: string;
    /**
     *
     * @type {string}
     * @memberof MergeItem
     */
    parentFolder?: string;
    /**
     *
     * @type {number}
     * @memberof MergeItem
     */
    nbMoveSinceV1?: number;
    /**
     *
     * @type {number}
     * @memberof MergeItem
     */
    itemId?: number;
}
/**
 *
 * @export
 * @interface MergeItemLink
 */
export interface MergeItemLink {
    /**
     *
     * @type {string}
     * @memberof MergeItemLink
     */
    upItemRef?: string;
    /**
     *
     * @type {string}
     * @memberof MergeItemLink
     */
    downItemRef?: string;
}
/**
 *
 * @export
 * @interface MergeParam
 */
export interface MergeParam {
    /**
     *
     * @type {Array<string>}
     * @memberof MergeParam
     */
    copy?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof MergeParam
     */
    conflicted?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof MergeParam
     */
    _delete?: Array<string>;
    /**
     *
     * @type {Array<FromToString>}
     * @memberof MergeParam
     */
    addLinks?: Array<FromToString>;
    /**
     *
     * @type {Array<FromToString>}
     * @memberof MergeParam
     */
    removeLinks?: Array<FromToString>;
    /**
     *
     * @type {Array<IdParent>}
     * @memberof MergeParam
     */
    move?: Array<IdParent>;
    /**
     *
     * @type {number}
     * @memberof MergeParam
     */
    push?: number;
}
/**
 *
 * @export
 * @interface Metric
 */
export interface Metric {
    /**
     *
     * @type {string}
     * @memberof Metric
     */
    key?: string;
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof Metric
     */
    values?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface MonitorAction
 */
export interface MonitorAction {
    /**
     *
     * @type {string}
     * @memberof MonitorAction
     */
    action?: string;
    /**
     *
     * @type {boolean}
     * @memberof MonitorAction
     */
    done?: boolean;
}
/**
 *
 * @export
 * @interface OneItem
 */
export interface OneItem {
    /**
     *
     * @type {number}
     * @memberof OneItem
     */
    itemId?: number;
    /**
     *
     * @type {number}
     * @memberof OneItem
     */
    version?: number;
    /**
     *
     * @type {string}
     * @memberof OneItem
     */
    projectShort?: string;
    /**
     *
     * @type {string}
     * @memberof OneItem
     */
    itemRefWithVersion?: string;
    /**
     *
     * @type {string}
     * @memberof OneItem
     */
    itemTitle?: string;
}
/**
 *
 * @export
 * @interface PluginCapabilities
 */
export interface PluginCapabilities {
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    canCreate?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    canFind?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    needSetup?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    handleAsLink?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    one2OneMapping?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    hasMeta?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    canCreateBacklinks?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    messaging?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    restToken?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    impersonate?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    extendedSettings?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PluginCapabilities
     */
    hideInProjectSettings?: boolean;
}
/**
 *
 * @export
 * @interface PluginSetting
 */
export interface PluginSetting {
    /**
     *
     * @type {number}
     * @memberof PluginSetting
     */
    pluginId?: number;
    /**
     *
     * @type {string}
     * @memberof PluginSetting
     */
    pluginLongName?: string;
    /**
     *
     * @type {string}
     * @memberof PluginSetting
     */
    pluginShortName?: string;
    /**
     *
     * @type {Array<SettingAndValue>}
     * @memberof PluginSetting
     */
    settings?: Array<SettingAndValue>;
    /**
     *
     * @type {Array<SettingAndValue>}
     * @memberof PluginSetting
     */
    computedSettings?: Array<SettingAndValue>;
    /**
     *
     * @type {PluginCapabilities}
     * @memberof PluginSetting
     */
    capabilities?: PluginCapabilities;
}
/**
 *
 * @export
 * @interface ProjectAndAccess
 */
export interface ProjectAndAccess {
    /**
     *
     * @type {number}
     * @memberof ProjectAndAccess
     */
    projectId?: number;
    /**
     *
     * @type {string}
     * @memberof ProjectAndAccess
     */
    projectShort?: string;
    /**
     *
     * @type {string}
     * @memberof ProjectAndAccess
     */
    projectLabel?: string;
    /**
     *
     * @type {Array<Access>}
     * @memberof ProjectAndAccess
     */
    accesses?: Array<Access>;
}
/**
 *
 * @export
 * @interface ProjectFileType
 */
export interface ProjectFileType {
    /**
     *
     * @type {number}
     * @memberof ProjectFileType
     */
    fileId?: number;
    /**
     *
     * @type {string}
     * @memberof ProjectFileType
     */
    localName?: string;
    /**
     *
     * @type {string}
     * @memberof ProjectFileType
     */
    fullPath?: string;
    /**
     *
     * @type {string}
     * @memberof ProjectFileType
     */
    mimeType?: string;
    /**
     *
     * @type {string}
     * @memberof ProjectFileType
     */
    key?: string;
}
/**
 *
 * @export
 * @interface ProjectInfo
 */
export interface ProjectInfo {
    /**
     *
     * @type {Array<UserPermissionType>}
     * @memberof ProjectInfo
     */
    userPermission?: Array<UserPermissionType>;
    /**
     *
     * @type {Array<GroupPermissionType>}
     * @memberof ProjectInfo
     */
    groupPermission?: Array<GroupPermissionType>;
    /**
     *
     * @type {CategoryExtendedListType}
     * @memberof ProjectInfo
     */
    categoryList?: CategoryExtendedListType;
    /**
     *
     * @type {string}
     * @memberof ProjectInfo
     */
    label?: string;
    /**
     *
     * @type {string}
     * @memberof ProjectInfo
     */
    shortLabel?: string;
    /**
     *
     * @type {string}
     * @memberof ProjectInfo
     */
    acl?: string;
    /**
     *
     * @type {string}
     * @memberof ProjectInfo
     */
    aclExplanations?: string;
    /**
     *
     * @type {Array<SettingType>}
     * @memberof ProjectInfo
     */
    settingList?: Array<SettingType>;
    /**
     *
     * @type {Array<CategoryAndSettingListType>}
     * @memberof ProjectInfo
     */
    categorySettingList?: Array<CategoryAndSettingListType>;
    /**
     *
     * @type {Array<PluginSetting>}
     * @memberof ProjectInfo
     */
    pluginSettingsList?: Array<PluginSetting>;
    /**
     *
     * @type {Array<Todo>}
     * @memberof ProjectInfo
     */
    todos?: Array<Todo>;
}
/**
 *
 * @export
 * @interface ProjectItemBody
 */
export interface ProjectItemBody {
    /**
     * Item title
     * @type {string}
     * @memberof ProjectItemBody
     */
    title: string;
    /**
     * Reference of the folder (F-categ-serial)
     * @type {string}
     * @memberof ProjectItemBody
     */
    folder: string;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof ProjectItemBody
     */
    itemProperties?: { [key: string]: string };
    /**
     * (optional) List of labels currently applied to this element. If none is specified, will consider there are none. Should be sent as a comma-delimited list of strings
     * @type {string}
     * @memberof ProjectItemBody
     */
    labels?: string;
    /**
     * The author (login name) - only works when superadmin is issuing this
     * @type {string}
     * @memberof ProjectItemBody
     */
    author?: string;
    /**
     * The reason why the user is doing this
     * @type {string}
     * @memberof ProjectItemBody
     */
    reason: string;
    /**
     * Comma-delimited (%2C)list of references to up items
     * @type {string}
     * @memberof ProjectItemBody
     */
    linksUp: string;
    /**
     * Comma-delimited (%2C)list of references to down items
     * @type {string}
     * @memberof ProjectItemBody
     */
    linksDown: string;
    /**
     * (optional) when set to 1 (default) says that the call will fail if any HTML cleanup is involved. With 0 it will clean and not fail
     * @type {number}
     * @memberof ProjectItemBody
     */
    failOnCleanup?: number;
}
/**
 *
 * @export
 * @interface ProjectNeedleBody
 */
export interface ProjectNeedleBody {
    /**
     * search term
     * @type {string}
     * @memberof ProjectNeedleBody
     */
    search: string;
    /**
     * search id. Used by MatrixJira js to match queries with answers. Is returned in the output structure
     * @type {string}
     * @memberof ProjectNeedleBody
     */
    id?: string;
    /**
     * (optional) applies a filter, can be negative
     * @type {string}
     * @memberof ProjectNeedleBody
     */
    filter?: string;
    /**
     * (optional) comma-delimited list of fields to return. e.g 101,102 - or * for all
     * @type {string}
     * @memberof ProjectNeedleBody
     */
    fieldsOut?: string;
    /**
     * (optional) set to 1 to return labels in the output
     * @type {number}
     * @memberof ProjectNeedleBody
     */
    labels?: number;
    /**
     * (optional) set to 1 to return items in tree order (otherwise it's project,category,serial)
     * @type {number}
     * @memberof ProjectNeedleBody
     */
    treeOrder?: number;
    /**
     * (optional) set to up,down to return up and down items, or only up or only down
     * @type {string}
     * @memberof ProjectNeedleBody
     */
    links?: string;
}
/**
 *
 * @export
 * @interface ProjectNeedleminimalBody
 */
export interface ProjectNeedleminimalBody {
    /**
     * search term
     * @type {string}
     * @memberof ProjectNeedleminimalBody
     */
    search: string;
    /**
     * (optional) applies a filter, can be negative
     * @type {string}
     * @memberof ProjectNeedleminimalBody
     */
    filter?: string;
}
/**
 *
 * @export
 * @interface ProjectPermissionType
 */
export interface ProjectPermissionType {
    /**
     *
     * @type {ProjectType}
     * @memberof ProjectPermissionType
     */
    project?: ProjectType;
    /**
     *
     * @type {Access}
     * @memberof ProjectPermissionType
     */
    access?: Access;
}
/**
 *
 * @export
 * @interface ProjectType
 */
export interface ProjectType {
    /**
     *
     * @type {number}
     * @memberof ProjectType
     */
    id?: number;
    /**
     *
     * @type {string}
     * @memberof ProjectType
     */
    label?: string;
    /**
     *
     * @type {string}
     * @memberof ProjectType
     */
    shortLabel?: string;
    /**
     *
     * @type {string}
     * @memberof ProjectType
     */
    projectLogo?: string;
    /**
     *
     * @type {boolean}
     * @memberof ProjectType
     */
    qmsProject?: boolean;
    /**
     *
     * @type {string}
     * @memberof ProjectType
     */
    accessType?: string;
    /**
     *
     * @type {boolean}
     * @memberof ProjectType
     */
    uniqueIds?: boolean;
}
/**
 *
 * @export
 * @interface Protocol
 */
export interface Protocol {
    /**
     *
     * @type {string}
     * @memberof Protocol
     */
    element?: string;
    /**
     *
     * @type {string}
     * @memberof Protocol
     */
    attribute?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof Protocol
     */
    protocols?: Array<string>;
}
/**
 *
 * @export
 * @interface ReportTarget
 */
export interface ReportTarget {
    /**
     *
     * @type {string}
     * @memberof ReportTarget
     */
    targetId?: string;
    /**
     *
     * @type {string}
     * @memberof ReportTarget
     */
    targetText?: string;
}
/**
 *
 * @export
 * @interface ReportType
 */
export interface ReportType {
    /**
     *
     * @type {string}
     * @memberof ReportType
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof ReportType
     */
    label?: string;
    /**
     *
     * @type {string}
     * @memberof ReportType
     */
    group?: string;
    /**
     *
     * @type {string}
     * @memberof ReportType
     */
    description?: string;
    /**
     *
     * @type {boolean}
     * @memberof ReportType
     */
    custom?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ReportType
     */
    guiItems?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof ReportType
     */
    requireSubtreeType?: string;
    /**
     *
     * @type {string}
     * @memberof ReportType
     */
    requireSubtree?: string;
    /**
     *
     * @type {string}
     * @memberof ReportType
     */
    selectSubtreeType?: string;
    /**
     *
     * @type {string}
     * @memberof ReportType
     */
    selectSubtree?: string;
    /**
     *
     * @type {Array<ReportTarget>}
     * @memberof ReportType
     */
    targets?: Array<ReportTarget>;
}
/**
 *
 * @export
 * @interface RestField
 */
export interface RestField {
    /**
     *
     * @type {number}
     * @memberof RestField
     */
    id?: number;
    /**
     *
     * @type {string}
     * @memberof RestField
     */
    label?: string;
    /**
     *
     * @type {string}
     * @memberof RestField
     */
    fieldType?: string;
    /**
     *
     * @type {string}
     * @memberof RestField
     */
    fieldParam?: string;
    /**
     *
     * @type {string}
     * @memberof RestField
     */
    testParam?: string;
    /**
     *
     * @type {string}
     * @memberof RestField
     */
    testExecParam?: string;
}
/**
 *
 * @export
 * @interface SendmailParam
 */
export interface SendmailParam {
    /**
     *
     * @type {string}
     * @memberof SendmailParam
     */
    subject?: string;
    /**
     *
     * @type {string}
     * @memberof SendmailParam
     */
    htmlbody?: string;
    /**
     *
     * @type {string}
     * @memberof SendmailParam
     */
    textbody?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof SendmailParam
     */
    to?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof SendmailParam
     */
    cc?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof SendmailParam
     */
    bcc?: Array<string>;
}
/**
 *
 * @export
 * @interface ServerStatus
 */
export interface ServerStatus {
    /**
     *
     * @type {ExceptionStatus}
     * @memberof ServerStatus
     */
    exceptionStatus?: ExceptionStatus;
    /**
     *
     * @type {string}
     * @memberof ServerStatus
     */
    version?: string;
    /**
     *
     * @type {string}
     * @memberof ServerStatus
     */
    publicUrl?: string;
}
/**
 *
 * @export
 * @interface ServiceDeskParam
 */
export interface ServiceDeskParam {
    /**
     *
     * @type {string}
     * @memberof ServiceDeskParam
     */
    summary?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceDeskParam
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceDeskParam
     */
    matrixProject?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceDeskParam
     */
    matrixItem?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceDeskParam
     */
    browser?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceDeskParam
     */
    log?: string;
}
/**
 *
 * @export
 * @interface SettingAndValue
 */
export interface SettingAndValue {
    /**
     *
     * @type {string}
     * @memberof SettingAndValue
     */
    setting?: string;
    /**
     *
     * @type {string}
     * @memberof SettingAndValue
     */
    value?: string;
    /**
     *
     * @type {boolean}
     * @memberof SettingAndValue
     */
    encrypted?: boolean;
}
/**
 *
 * @export
 * @interface SettingType
 */
export interface SettingType {
    /**
     *
     * @type {string}
     * @memberof SettingType
     */
    value?: string;
    /**
     *
     * @type {string}
     * @memberof SettingType
     */
    key?: string;
    /**
     *
     * @type {boolean}
     * @memberof SettingType
     */
    secret?: boolean;
}
/**
 *
 * @export
 * @interface SignItemAck
 */
export interface SignItemAck {
    /**
     *
     * @type {string}
     * @memberof SignItemAck
     */
    result?: string;
    /**
     *
     * @type {boolean}
     * @memberof SignItemAck
     */
    ok?: boolean;
}
/**
 *
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     *
     * @type {number}
     * @memberof Tag
     */
    id?: number;
    /**
     *
     * @type {number}
     * @memberof Tag
     */
    auditId?: number;
    /**
     *
     * @type {string}
     * @memberof Tag
     */
    auditTime?: string;
    /**
     *
     * @type {string}
     * @memberof Tag
     */
    label?: string;
    /**
     *
     * @type {string}
     * @memberof Tag
     */
    comments?: string;
    /**
     *
     * @type {string}
     * @memberof Tag
     */
    tagType?: string;
    /**
     *
     * @type {string}
     * @memberof Tag
     */
    tagCreation?: string;
    /**
     *
     * @type {string}
     * @memberof Tag
     */
    userLogin?: string;
    /**
     *
     * @type {number}
     * @memberof Tag
     */
    baseProjectId?: number;
    /**
     *
     * @type {string}
     * @memberof Tag
     */
    baseProjectName?: string;
    /**
     *
     * @type {string}
     * @memberof Tag
     */
    baseProjectTag?: string;
    /**
     *
     * @type {string}
     * @memberof Tag
     */
    baseAuditCreation?: string;
    /**
     *
     * @type {number}
     * @memberof Tag
     */
    baseAuditId?: number;
}
/**
 *
 * @export
 * @interface TechAuditType
 */
export interface TechAuditType {
    /**
     *
     * @type {number}
     * @memberof TechAuditType
     */
    id?: number;
    /**
     *
     * @type {string}
     * @memberof TechAuditType
     */
    operation?: string;
    /**
     *
     * @type {string}
     * @memberof TechAuditType
     */
    table?: string;
    /**
     *
     * @type {number}
     * @memberof TechAuditType
     */
    index?: number;
    /**
     *
     * @type {string}
     * @memberof TechAuditType
     */
    ref?: string;
}
/**
 *
 * @export
 * @interface Todo
 */
export interface Todo {
    /**
     *
     * @type {number}
     * @memberof Todo
     */
    todoId?: number;
    /**
     *
     * @type {number}
     * @memberof Todo
     */
    userId?: number;
    /**
     *
     * @type {string}
     * @memberof Todo
     */
    login?: string;
    /**
     *
     * @type {string}
     * @memberof Todo
     */
    projectShort?: string;
    /**
     *
     * @type {string}
     * @memberof Todo
     */
    itemRef?: string;
    /**
     *
     * @type {string}
     * @memberof Todo
     */
    fieldLabel?: string;
    /**
     *
     * @type {number}
     * @memberof Todo
     */
    fieldId?: number;
    /**
     *
     * @type {boolean}
     * @memberof Todo
     */
    auto?: boolean;
    /**
     *
     * @type {number}
     * @memberof Todo
     */
    originatorUserId?: number;
    /**
     *
     * @type {string}
     * @memberof Todo
     */
    originatorLogin?: string;
    /**
     *
     * @type {TodoAction}
     * @memberof Todo
     */
    action?: TodoAction;
    /**
     *
     * @type {string}
     * @memberof Todo
     */
    createdAt?: string;
    /**
     *
     * @type {string}
     * @memberof Todo
     */
    closedAt?: string;
    /**
     *
     * @type {string}
     * @memberof Todo
     */
    createdAtUserFormat?: string;
    /**
     *
     * @type {string}
     * @memberof Todo
     */
    closedAtUserFormat?: string;
    /**
     *
     * @type {boolean}
     * @memberof Todo
     */
    future?: boolean;
    /**
     *
     * @type {number}
     * @memberof Todo
     */
    projectId?: number;
}
/**
 *
 * @export
 * @interface TodoAction
 */
export interface TodoAction {
    /**
     *
     * @type {string}
     * @memberof TodoAction
     */
    text?: string;
    /**
     *
     * @type {string}
     * @memberof TodoAction
     */
    todoType?: string;
}
/**
 *
 * @export
 * @interface TodoCount
 */
export interface TodoCount {
    /**
     *
     * @type {number}
     * @memberof TodoCount
     */
    userId?: number;
    /**
     *
     * @type {string}
     * @memberof TodoCount
     */
    login?: string;
    /**
     *
     * @type {number}
     * @memberof TodoCount
     */
    projectId?: number;
    /**
     *
     * @type {string}
     * @memberof TodoCount
     */
    projectShort?: string;
    /**
     *
     * @type {number}
     * @memberof TodoCount
     */
    nbTodos?: number;
    /**
     *
     * @type {Array<Todo>}
     * @memberof TodoCount
     */
    firstTodos?: Array<Todo>;
}
/**
 *
 * @export
 * @interface TokenType
 */
export interface TokenType {
    /**
     *
     * @type {number}
     * @memberof TokenType
     */
    userId?: number;
    /**
     *
     * @type {number}
     * @memberof TokenType
     */
    tokenId?: number;
    /**
     *
     * @type {string}
     * @memberof TokenType
     */
    purpose?: string;
    /**
     *
     * @type {string}
     * @memberof TokenType
     */
    reason?: string;
    /**
     *
     * @type {string}
     * @memberof TokenType
     */
    value?: string;
    /**
     *
     * @type {string}
     * @memberof TokenType
     */
    validTo?: string;
    /**
     *
     * @type {string}
     * @memberof TokenType
     */
    validToUserFormat?: string;
}
/**
 *
 * @export
 * @interface TrimAudit
 */
export interface TrimAudit {
    /**
     *
     * @type {string}
     * @memberof TrimAudit
     */
    userLogin?: string;
    /**
     *
     * @type {string}
     * @memberof TrimAudit
     */
    dateTime?: string;
    /**
     *
     * @type {string}
     * @memberof TrimAudit
     */
    dateTimeUserFormat?: string;
    /**
     *
     * @type {string}
     * @memberof TrimAudit
     */
    action?: string;
    /**
     *
     * @type {string}
     * @memberof TrimAudit
     */
    entity?: string;
    /**
     *
     * @type {string}
     * @memberof TrimAudit
     */
    reason?: string;
    /**
     *
     * @type {string}
     * @memberof TrimAudit
     */
    projectLabel?: string;
    /**
     *
     * @type {string}
     * @memberof TrimAudit
     */
    reportRef?: string;
    /**
     *
     * @type {string}
     * @memberof TrimAudit
     */
    reportTitle?: string;
    /**
     *
     * @type {number}
     * @memberof TrimAudit
     */
    reportJobId?: number;
    /**
     *
     * @type {TrimNeedleItem}
     * @memberof TrimAudit
     */
    itemBefore?: TrimNeedleItem;
    /**
     *
     * @type {TrimNeedleItem}
     * @memberof TrimAudit
     */
    itemAfter?: TrimNeedleItem;
    /**
     *
     * @type {TrimNeedleItem}
     * @memberof TrimAudit
     */
    itemUp?: TrimNeedleItem;
    /**
     *
     * @type {TrimNeedleItem}
     * @memberof TrimAudit
     */
    itemDown?: TrimNeedleItem;
    /**
     *
     * @type {number}
     * @memberof TrimAudit
     */
    auditId?: number;
    /**
     *
     * @type {Array<TechAuditType>}
     * @memberof TrimAudit
     */
    techAudit?: Array<TechAuditType>;
    /**
     *
     * @type {Array<Tag>}
     * @memberof TrimAudit
     */
    tags?: Array<Tag>;
    /**
     *
     * @type {Array<ItemSimpleType>}
     * @memberof TrimAudit
     */
    itemsDeletedByMerge?: Array<ItemSimpleType>;
}
/**
 *
 * @export
 * @interface TrimAuditList
 */
export interface TrimAuditList {
    /**
     *
     * @type {number}
     * @memberof TrimAuditList
     */
    startAt?: number;
    /**
     *
     * @type {number}
     * @memberof TrimAuditList
     */
    maxResults?: number;
    /**
     *
     * @type {number}
     * @memberof TrimAuditList
     */
    totalResults?: number;
    /**
     *
     * @type {Array<TrimAudit>}
     * @memberof TrimAuditList
     */
    audit?: Array<TrimAudit>;
}
/**
 *
 * @export
 * @interface TrimFolder
 */
export interface TrimFolder {
    /**
     *
     * @type {string}
     * @memberof TrimFolder
     */
    itemRef?: string;
    /**
     *
     * @type {string}
     * @memberof TrimFolder
     */
    title?: string;
    /**
     *
     * @type {number}
     * @memberof TrimFolder
     */
    partial?: number;
    /**
     *
     * @type {Array<TrimFolder>}
     * @memberof TrimFolder
     */
    itemList?: Array<TrimFolder>;
    /**
     *
     * @type {FieldValListType}
     * @memberof TrimFolder
     */
    fieldValList?: FieldValListType;
    /**
     *
     * @type {number}
     * @memberof TrimFolder
     */
    isFolder?: number;
    /**
     *
     * @type {number}
     * @memberof TrimFolder
     */
    isUnselected?: number;
    /**
     *
     * @type {ItemHistoryListType}
     * @memberof TrimFolder
     */
    itemHistoryList?: ItemHistoryListType;
    /**
     *
     * @type {number}
     * @memberof TrimFolder
     */
    maxVersion?: number;
    /**
     *
     * @type {string}
     * @memberof TrimFolder
     */
    modDate?: string;
    /**
     *
     * @type {string}
     * @memberof TrimFolder
     */
    modDateUserFormat?: string;
    /**
     *
     * @type {number}
     * @memberof TrimFolder
     */
    itemId?: number;
    /**
     *
     * @type {number}
     * @memberof TrimFolder
     */
    disabled?: number;
    /**
     *
     * @type {FancyLeaf}
     * @memberof TrimFolder
     */
    contextTree?: FancyLeaf;
    /**
     *
     * @type {Array<CrossProjectLink>}
     * @memberof TrimFolder
     */
    crossLinks?: Array<CrossProjectLink>;
}
/**
 *
 * @export
 * @interface TrimItem
 */
export interface TrimItem {
    /**
     *
     * @type {string}
     * @memberof TrimItem
     */
    title?: string;
    /**
     *
     * @type {string}
     * @memberof TrimItem
     */
    itemRef?: string;
    /**
     *
     * @type {string}
     * @memberof TrimItem
     */
    folderRef?: string;
    /**
     *
     * @type {Array<TrimLink>}
     * @memberof TrimItem
     */
    upLinkList?: Array<TrimLink>;
    /**
     *
     * @type {Array<TrimLink>}
     * @memberof TrimItem
     */
    downLinkList?: Array<TrimLink>;
    /**
     *
     * @type {FieldValListType}
     * @memberof TrimItem
     */
    fieldValList?: FieldValListType;
    /**
     *
     * @type {Array<string>}
     * @memberof TrimItem
     */
    labels?: Array<string>;
    /**
     *
     * @type {ItemHistoryListType}
     * @memberof TrimItem
     */
    itemHistoryList?: ItemHistoryListType;
    /**
     *
     * @type {number}
     * @memberof TrimItem
     */
    maxVersion?: number;
    /**
     *
     * @type {number}
     * @memberof TrimItem
     */
    disabled?: number;
    /**
     *
     * @type {number}
     * @memberof TrimItem
     */
    isFolder?: number;
    /**
     *
     * @type {Array<string>}
     * @memberof TrimItem
     */
    availableFormats?: Array<string>;
    /**
     *
     * @type {number}
     * @memberof TrimItem
     */
    itemId?: number;
    /**
     *
     * @type {string}
     * @memberof TrimItem
     */
    modDate?: string;
    /**
     *
     * @type {string}
     * @memberof TrimItem
     */
    modDateUserFormat?: string;
    /**
     *
     * @type {Array<CategoryAndRoot>}
     * @memberof TrimItem
     */
    requireSubTree?: Array<CategoryAndRoot>;
    /**
     *
     * @type {Array<CategoryAndRoot>}
     * @memberof TrimItem
     */
    selectSubTree?: Array<CategoryAndRoot>;
    /**
     *
     * @type {number}
     * @memberof TrimItem
     */
    isUnselected?: number;
    /**
     *
     * @type {Array<UserAndTime>}
     * @memberof TrimItem
     */
    downloads?: Array<UserAndTime>;
    /**
     *
     * @type {boolean}
     * @memberof TrimItem
     */
    docHasPackage?: boolean;
    /**
     *
     * @type {CleanupFail}
     * @memberof TrimItem
     */
    cleanupFail?: CleanupFail;
    /**
     *
     * @type {FancyLeaf}
     * @memberof TrimItem
     */
    contextTree?: FancyLeaf;
    /**
     *
     * @type {Array<CrossProjectLink>}
     * @memberof TrimItem
     */
    crossLinks?: Array<CrossProjectLink>;
}
/**
 *
 * @export
 * @interface TrimLink
 */
export interface TrimLink {
    /**
     *
     * @type {Array<TrimLink>}
     * @memberof TrimLink
     */
    upLinkList?: Array<TrimLink>;
    /**
     *
     * @type {Array<TrimLink>}
     * @memberof TrimLink
     */
    downLinkList?: Array<TrimLink>;
    /**
     *
     * @type {string}
     * @memberof TrimLink
     */
    itemRef?: string;
    /**
     *
     * @type {string}
     * @memberof TrimLink
     */
    title?: string;
    /**
     *
     * @type {string}
     * @memberof TrimLink
     */
    modDate?: string;
    /**
     *
     * @type {string}
     * @memberof TrimLink
     */
    modDateUserFormat?: string;
}
/**
 *
 * @export
 * @interface TrimNeedle
 */
export interface TrimNeedle {
    /**
     *
     * @type {number}
     * @memberof TrimNeedle
     */
    startAt?: number;
    /**
     *
     * @type {number}
     * @memberof TrimNeedle
     */
    maxResults?: number;
    /**
     *
     * @type {number}
     * @memberof TrimNeedle
     */
    totalResults?: number;
    /**
     *
     * @type {string}
     * @memberof TrimNeedle
     */
    searchId?: string;
    /**
     *
     * @type {Array<TrimNeedleItem>}
     * @memberof TrimNeedle
     */
    needles?: Array<TrimNeedleItem>;
}
/**
 *
 * @export
 * @interface TrimNeedleItem
 */
export interface TrimNeedleItem {
    /**
     *
     * @type {string}
     * @memberof TrimNeedleItem
     */
    itemOrFolderRef?: string;
    /**
     *
     * @type {string}
     * @memberof TrimNeedleItem
     */
    title?: string;
    /**
     *
     * @type {string}
     * @memberof TrimNeedleItem
     */
    project?: string;
    /**
     *
     * @type {Array<FieldValType>}
     * @memberof TrimNeedleItem
     */
    fieldVal?: Array<FieldValType>;
    /**
     *
     * @type {string}
     * @memberof TrimNeedleItem
     */
    labels?: string;
    /**
     *
     * @type {string}
     * @memberof TrimNeedleItem
     */
    lastModDate?: string;
    /**
     *
     * @type {string}
     * @memberof TrimNeedleItem
     */
    creationDate?: string;
    /**
     *
     * @type {Array<TrimLink>}
     * @memberof TrimNeedleItem
     */
    upLinkList?: Array<TrimLink>;
    /**
     *
     * @type {Array<TrimLink>}
     * @memberof TrimNeedleItem
     */
    downLinkList?: Array<TrimLink>;
}
/**
 *
 * @export
 * @interface UndeleteAnswer
 */
export interface UndeleteAnswer {
    /**
     *
     * @type {string}
     * @memberof UndeleteAnswer
     */
    newParent?: string;
    /**
     *
     * @type {number}
     * @memberof UndeleteAnswer
     */
    newOrder?: number;
}
/**
 *
 * @export
 * @interface UserAndTime
 */
export interface UserAndTime {
    /**
     *
     * @type {number}
     * @memberof UserAndTime
     */
    userId?: number;
    /**
     *
     * @type {string}
     * @memberof UserAndTime
     */
    login?: string;
    /**
     *
     * @type {string}
     * @memberof UserAndTime
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof UserAndTime
     */
    lastName?: string;
    /**
     *
     * @type {string}
     * @memberof UserAndTime
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof UserAndTime
     */
    date?: string;
    /**
     *
     * @type {string}
     * @memberof UserAndTime
     */
    dateUserFormat?: string;
}
/**
 *
 * @export
 * @interface UserDetails
 */
export interface UserDetails {
    /**
     *
     * @type {string}
     * @memberof UserDetails
     */
    login?: string;
    /**
     *
     * @type {number}
     * @memberof UserDetails
     */
    nbReadWriteProjectsNow?: number;
    /**
     *
     * @type {Array<ProjectAndAccess>}
     * @memberof UserDetails
     */
    projects?: Array<ProjectAndAccess>;
    /**
     *
     * @type {Array<UserInfo>}
     * @memberof UserDetails
     */
    infoUpdates?: Array<UserInfo>;
    /**
     *
     * @type {number}
     * @memberof UserDetails
     */
    admin?: number;
    /**
     *
     * @type {number}
     * @memberof UserDetails
     */
    superAdmin?: number;
    /**
     *
     * @type {string}
     * @memberof UserDetails
     */
    userStatus?: string;
}
/**
 *
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    startDate8601?: string;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    endDate8601?: string;
    /**
     *
     * @type {boolean}
     * @memberof UserInfo
     */
    hasKey?: boolean;
    /**
     *
     * @type {number}
     * @memberof UserInfo
     */
    userId?: number;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    login?: string;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    lastName?: string;
}
/**
 *
 * @export
 * @interface UserPermissionType
 */
export interface UserPermissionType {
    /**
     *
     * @type {number}
     * @memberof UserPermissionType
     */
    id?: number;
    /**
     *
     * @type {string}
     * @memberof UserPermissionType
     */
    login?: string;
    /**
     *
     * @type {string}
     * @memberof UserPermissionType
     */
    email?: string;
    /**
     *
     * @type {number}
     * @memberof UserPermissionType
     */
    permission?: number;
    /**
     *
     * @type {string}
     * @memberof UserPermissionType
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof UserPermissionType
     */
    lastName?: string;
}
/**
 *
 * @export
 * @interface UserType
 */
export interface UserType {
    /**
     *
     * @type {number}
     * @memberof UserType
     */
    id?: number;
    /**
     *
     * @type {string}
     * @memberof UserType
     */
    login?: string;
    /**
     *
     * @type {string}
     * @memberof UserType
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof UserType
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof UserType
     */
    lastName?: string;
    /**
     *
     * @type {string}
     * @memberof UserType
     */
    signatureImage?: string;
    /**
     *
     * @type {string}
     * @memberof UserType
     */
    signaturePassword?: string;
    /**
     *
     * @type {number}
     * @memberof UserType
     */
    customerAdmin?: number;
    /**
     *
     * @type {number}
     * @memberof UserType
     */
    passwordAgeInDays?: number;
    /**
     *
     * @type {number}
     * @memberof UserType
     */
    badLogins?: number;
    /**
     *
     * @type {number}
     * @memberof UserType
     */
    badLoginsBefore?: number;
    /**
     *
     * @type {number}
     * @memberof UserType
     */
    superAdmin?: number;
    /**
     *
     * @type {string}
     * @memberof UserType
     */
    userStatus?: string;
    /**
     *
     * @type {Array<SettingType>}
     * @memberof UserType
     */
    userSettingsList?: Array<SettingType>;
    /**
     *
     * @type {Array<TokenType>}
     * @memberof UserType
     */
    tokenList?: Array<TokenType>;
    /**
     *
     * @type {Array<number>}
     * @memberof UserType
     */
    groupList?: Array<number>;
}
/**
 *
 * @export
 * @interface UserTypeSimple
 */
export interface UserTypeSimple {
    /**
     *
     * @type {number}
     * @memberof UserTypeSimple
     */
    userId?: number;
    /**
     *
     * @type {string}
     * @memberof UserTypeSimple
     */
    login?: string;
    /**
     *
     * @type {string}
     * @memberof UserTypeSimple
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof UserTypeSimple
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof UserTypeSimple
     */
    lastName?: string;
}
/**
 *
 * @export
 * @interface VerifiedAuth
 */
export interface VerifiedAuth {
    /**
     *
     * @type {string}
     * @memberof VerifiedAuth
     */
    logger?: string;
    /**
     *
     * @type {string}
     * @memberof VerifiedAuth
     */
    VERIFIED_AUTH_SESSION_ATTRIBUTE?: string;
    /**
     *
     * @type {string}
     * @memberof VerifiedAuth
     */
    AUTH_SOURCE_SESSION?: string;
    /**
     *
     * @type {string}
     * @memberof VerifiedAuth
     */
    AUTH_SOURCE_SINGLE_SIGNON?: string;
    /**
     *
     * @type {string}
     * @memberof VerifiedAuth
     */
    login?: string;
    /**
     *
     * @type {number}
     * @memberof VerifiedAuth
     */
    userId?: number;
    /**
     *
     * @type {string}
     * @memberof VerifiedAuth
     */
    authSource?: string;
    /**
     *
     * @type {boolean}
     * @memberof VerifiedAuth
     */
    superAdmin?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof VerifiedAuth
     */
    customerAdmin?: boolean;
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof VerifiedAuth
     */
    projectMap?: { [key: string]: any };
}
/**
 * DefaultApi - fetch parameter creator
 * @export
 */
export const DefaultApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Asks for the difference between A and B html exerpts, and produce the B html with annotations
         * @param {string} [arg] json object with the arguments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCompareHtmlPost(arg?: string, options: any = {}): FetchArgs {
            const localVarPath = `/all/compareHtml`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (arg !== undefined) {
                localVarQueryParameter["arg"] = arg;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Returns all info about a date
         * @param {string} [date] (optional) an input date formatted as iso8601. If not present, current date/time is used
         * @param {string} [dateformat] (optional) a date formatter. If not present, current date format is used
         * @param {string} [timeformat] (optional) a date-time formatter. If not present, current date/time format is used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allDateGet(date?: string, dateformat?: string, timeformat?: string, options: any = {}): FetchArgs {
            const localVarPath = `/all/date`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (date !== undefined) {
                localVarQueryParameter["date"] = date;
            }

            if (dateformat !== undefined) {
                localVarQueryParameter["dateformat"] = dateformat;
            }

            if (timeformat !== undefined) {
                localVarQueryParameter["timeformat"] = timeformat;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have the right key to download the file. Valid from version 2.1
         * @summary Retrieve one customer file. The fileno is a simple fileId. This request returns the actual file
         * @param {number} fileno file number
         * @param {string} key The key of the file
         * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFileFilenoGet(fileno: number, key: string, disposition?: string, options: any = {}): FetchArgs {
            // verify required parameter 'fileno' is not null or undefined
            if (fileno === null || fileno === undefined) {
                throw new RequiredError(
                    "fileno",
                    "Required parameter fileno was null or undefined when calling allFileFilenoGet.",
                );
            }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError(
                    "key",
                    "Required parameter key was null or undefined when calling allFileFilenoGet.",
                );
            }
            const localVarPath = `/all/file/{fileno}`.replace(`{${"fileno"}}`, encodeURIComponent(String(fileno)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (key !== undefined) {
                localVarQueryParameter["key"] = key;
            }

            if (disposition !== undefined) {
                localVarQueryParameter["disposition"] = disposition;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Retrieve list of all customer-wide files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFileGet(options: any = {}): FetchArgs {
            const localVarPath = `/all/file`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Creates a new customer-wide file - the file should be uploaded as payload. Its mime type should be sent through the HTTP protocol.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFilePost(options: any = {}): FetchArgs {
            const localVarPath = `/all/file`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Retrieve license status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allLicenseGet(options: any = {}): FetchArgs {
            const localVarPath = `/all/license`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Adds a log entry (server side).
         * @param {string} message Message to log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allLogPost(message: string, options: any = {}): FetchArgs {
            // verify required parameter 'message' is not null or undefined
            if (message === null || message === undefined) {
                throw new RequiredError(
                    "message",
                    "Required parameter message was null or undefined when calling allLogPost.",
                );
            }
            const localVarPath = `/all/log`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (message !== undefined) {
                localVarQueryParameter["message"] = message;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.4
         * @summary Update matrix instance log level.
         * @param {LogLevel} [body] Payload containing the log level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allLoglevelPut(body?: LogLevel, options: any = {}): FetchArgs {
            const localVarPath = `/all/loglevel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"LogLevel" !== "string" || localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.5
         * @summary Add metrics entry.
         * @param {Metric} [body] Payload containing the metric data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allMetricsPut(body?: Metric, options: any = {}): FetchArgs {
            const localVarPath = `/all/metrics`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"Metric" !== "string" || localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Monitoring object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allMonitorGet(options: any = {}): FetchArgs {
            const localVarPath = `/all/monitor`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.2
         * @summary The OpenAPI 3.0 definition of our REST API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allOpenapiGet(options: any = {}): FetchArgs {
            const localVarPath = `/all/openapi`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Lists all reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allReportsGet(options: any = {}): FetchArgs {
            const localVarPath = `/all/reports`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Sends an email. Non-optional parameters are sent as a POST JSON payload.
         * @param {SendmailParam} [body] Necessary information to send a mail
         * @param {number} [system] (optional) if set to 1 makes it a system email (not sent by the actual user)
         * @param {number} [noreply] (optional) if set to 1 makes it a no-reply email (not sent by the actual user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSendmailPost(body?: SendmailParam, system?: number, noreply?: number, options: any = {}): FetchArgs {
            const localVarPath = `/all/sendmail`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (system !== undefined) {
                localVarQueryParameter["system"] = system;
            }

            if (noreply !== undefined) {
                localVarQueryParameter["noreply"] = noreply;
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"SendmailParam" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Creates a service desk issue. The parameters are sent as a POST JSON payload.
         * @param {ServiceDeskParam} [body] Necessary information to send a mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServicedeskPost(body?: ServiceDeskParam, options: any = {}): FetchArgs {
            const localVarPath = `/all/servicedesk`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"ServiceDeskParam" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all settings of a customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSettingGet(options: any = {}): FetchArgs {
            const localVarPath = `/all/setting`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds or changes a customer setting. If the value is empty, the setting will be deleted.
         * @param {string} key setting key
         * @param {string} value value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSettingPost(key: string, value: string, options: any = {}): FetchArgs {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError(
                    "key",
                    "Required parameter key was null or undefined when calling allSettingPost.",
                );
            }
            // verify required parameter 'value' is not null or undefined
            if (value === null || value === undefined) {
                throw new RequiredError(
                    "value",
                    "Required parameter value was null or undefined when calling allSettingPost.",
                );
            }
            const localVarPath = `/all/setting`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (key !== undefined) {
                localVarQueryParameter["key"] = key;
            }

            if (value !== undefined) {
                localVarQueryParameter["value"] = value;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get instance status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allStatusGet(options: any = {}): FetchArgs {
            const localVarPath = `/all/status`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Returns all accepted time zones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTimezoneGet(options: any = {}): FetchArgs {
            const localVarPath = `/all/timezone`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
         * @summary Get all todos for the current user, for all projects
         * @param {number} [includeDone] (optional) set to 1 to include done todos and todo&#x27;s created by the user
         * @param {number} [includeFuture] (optional) set to 1 to include future todos as well (defaults to 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTodoGet(includeDone?: number, includeFuture?: number, options: any = {}): FetchArgs {
            const localVarPath = `/all/todo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (includeDone !== undefined) {
                localVarQueryParameter["includeDone"] = includeDone;
            }

            if (includeFuture !== undefined) {
                localVarQueryParameter["includeFuture"] = includeFuture;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary WebHook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allWebhookPost(options: any = {}): FetchArgs {
            const localVarPath = `/all/webhook`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.2
         * @summary Retrieves the group list
         * @param {number} [details] (optional) -  if set to 1 returns all details -- in this case user needs to be ADMIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGet(details?: number, options: any = {}): FetchArgs {
            const localVarPath = `/group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (details !== undefined) {
                localVarQueryParameter["details"] = details;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Removes a group
         * @param {string} groupId group Id
         * @param {string} confirm Needs to be yes for the method to be executed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdDelete(groupId: string, confirm: string, options: any = {}): FetchArgs {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new RequiredError(
                    "groupId",
                    "Required parameter groupId was null or undefined when calling groupGroupIdDelete.",
                );
            }
            // verify required parameter 'confirm' is not null or undefined
            if (confirm === null || confirm === undefined) {
                throw new RequiredError(
                    "confirm",
                    "Required parameter confirm was null or undefined when calling groupGroupIdDelete.",
                );
            }
            const localVarPath = `/group/{groupId}`.replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (confirm !== undefined) {
                localVarQueryParameter["confirm"] = confirm;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.2
         * @summary Retrieves details of a group
         * @param {string} groupId group Id
         * @param {number} [details] (optional) -  if set to 1 returns all details -- in this case user needs to be ADMIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdGet(groupId: string, details?: number, options: any = {}): FetchArgs {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new RequiredError(
                    "groupId",
                    "Required parameter groupId was null or undefined when calling groupGroupIdGet.",
                );
            }
            const localVarPath = `/group/{groupId}`.replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (details !== undefined) {
                localVarQueryParameter["details"] = details;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Adds a group to a project (or removes it)
         * @param {string} groupId group Id
         * @param {string} project Project short label
         * @param {number} [permission] Specify the (new) permission for that group in that project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdProjectProjectPost(
            groupId: string,
            project: string,
            permission?: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new RequiredError(
                    "groupId",
                    "Required parameter groupId was null or undefined when calling groupGroupIdProjectProjectPost.",
                );
            }
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling groupGroupIdProjectProjectPost.",
                );
            }
            const localVarPath = `/group/{groupId}/project/{project}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (permission !== undefined) {
                localVarQueryParameter["permission"] = permission;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Renames a group
         * @param {string} groupId group Id
         * @param {string} newName The new group name. Cannot be one of the existing. Must start with &#x27;group.&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdRenamePut(groupId: string, newName: string, options: any = {}): FetchArgs {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new RequiredError(
                    "groupId",
                    "Required parameter groupId was null or undefined when calling groupGroupIdRenamePut.",
                );
            }
            // verify required parameter 'newName' is not null or undefined
            if (newName === null || newName === undefined) {
                throw new RequiredError(
                    "newName",
                    "Required parameter newName was null or undefined when calling groupGroupIdRenamePut.",
                );
            }
            const localVarPath = `/group/{groupId}/rename`.replace(
                `{${"groupId"}}`,
                encodeURIComponent(String(groupId)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (newName !== undefined) {
                localVarQueryParameter["newName"] = newName;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.2
         * @summary Adds a user to a group
         * @param {string} groupId group Id
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdUserUserPut(groupId: string, user: string, options: any = {}): FetchArgs {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new RequiredError(
                    "groupId",
                    "Required parameter groupId was null or undefined when calling groupGroupIdUserUserPut.",
                );
            }
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling groupGroupIdUserUserPut.",
                );
            }
            const localVarPath = `/group/{groupId}/user/{user}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Sets all users of a group (replacing potential former content)
         * @param {string} groupId group Id
         * @param {string} users List of all users members of that group, commas-separated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdUserlistPut(groupId: string, users: string, options: any = {}): FetchArgs {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new RequiredError(
                    "groupId",
                    "Required parameter groupId was null or undefined when calling groupGroupIdUserlistPut.",
                );
            }
            // verify required parameter 'users' is not null or undefined
            if (users === null || users === undefined) {
                throw new RequiredError(
                    "users",
                    "Required parameter users was null or undefined when calling groupGroupIdUserlistPut.",
                );
            }
            const localVarPath = `/group/{groupId}/userlist`.replace(
                `{${"groupId"}}`,
                encodeURIComponent(String(groupId)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (users !== undefined) {
                localVarQueryParameter["users"] = users;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Removes a user from a group
         * @param {string} groupName group name
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupNameUserUserDelete(groupName: string, user: string, options: any = {}): FetchArgs {
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new RequiredError(
                    "groupName",
                    "Required parameter groupName was null or undefined when calling groupGroupNameUserUserDelete.",
                );
            }
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling groupGroupNameUserUserDelete.",
                );
            }
            const localVarPath = `/group/{groupName}/user/{user}`
                .replace(`{${"groupName"}}`, encodeURIComponent(String(groupName)))
                .replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Creates a new group
         * @param {string} groupLabel The name of the group to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupPost(groupLabel: string, options: any = {}): FetchArgs {
            // verify required parameter 'groupLabel' is not null or undefined
            if (groupLabel === null || groupLabel === undefined) {
                throw new RequiredError(
                    "groupLabel",
                    "Required parameter groupLabel was null or undefined when calling groupPost.",
                );
            }
            const localVarPath = `/group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (groupLabel !== undefined) {
                localVarQueryParameter["groupLabel"] = groupLabel;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.3
         * @summary Merge branch into mainline. First project is the mainline, second is the branch. The payload must contain a json object with a list of actions to perform.
         * @param {string} mainproject mainproject
         * @param {string} branchproject branchproject
         * @param {string} reason The reason why the user is doing this
         * @param {MergeParam} [body] Actions to perform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainprojectMergeBranchprojectPost(
            mainproject: string,
            branchproject: string,
            reason: string,
            body?: MergeParam,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'mainproject' is not null or undefined
            if (mainproject === null || mainproject === undefined) {
                throw new RequiredError(
                    "mainproject",
                    "Required parameter mainproject was null or undefined when calling mainprojectMergeBranchprojectPost.",
                );
            }
            // verify required parameter 'branchproject' is not null or undefined
            if (branchproject === null || branchproject === undefined) {
                throw new RequiredError(
                    "branchproject",
                    "Required parameter branchproject was null or undefined when calling mainprojectMergeBranchprojectPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling mainprojectMergeBranchprojectPost.",
                );
            }
            const localVarPath = `/{mainproject}/merge/{branchproject}`
                .replace(`{${"mainproject"}}`, encodeURIComponent(String(mainproject)))
                .replace(`{${"branchproject"}}`, encodeURIComponent(String(branchproject)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"MergeParam" !== "string" || localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have QMS viewer access (or higher) to the project. Valid from version 2.2
         * @summary Retrieves all accesses in a project (list of groups and users who have access)
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectAccessGet(project: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectAccessGet.",
                );
            }
            const localVarPath = `/{project}/access`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Retrieves all changes in a project
         * @param {string} project Project short label
         * @param {number} [startAt] (optional) Pagination -  starts the audit after N records
         * @param {number} [maxResults] (optional) Pagination -  Retrieve N results per page
         * @param {string} [deleteOnly] (optional) if set to yes, only returns actions of type delete
         * @param {string} [tech] (optional) if set to yes, returns the underneath changes
         * @param {number} [auditIdMin] (optional) sets a minimum ID for audits, as returned by GET calendar
         * @param {number} [auditIdMax] (optional) sets a maximum ID for audits
         * @param {number} [noReport] (optional) set to 1 to avoid having reports
         * @param {number} [noImport] (optional) set to 1 to avoid having imports
         * @param {string} [include] (optional) set to a list of actions to include (delete,undelete,add,edit,...)
         * @param {number} [resolveRef] (optional) set to 1 to resolve item IDs into refs
         * @param {string} [itemRef] (optional) restrict the audit to only those mentionning this item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectAuditGet(
            project: string,
            startAt?: number,
            maxResults?: number,
            deleteOnly?: string,
            tech?: string,
            auditIdMin?: number,
            auditIdMax?: number,
            noReport?: number,
            noImport?: number,
            include?: string,
            resolveRef?: number,
            itemRef?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectAuditGet.",
                );
            }
            const localVarPath = `/{project}/audit`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (startAt !== undefined) {
                localVarQueryParameter["startAt"] = startAt;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter["maxResults"] = maxResults;
            }

            if (deleteOnly !== undefined) {
                localVarQueryParameter["deleteOnly"] = deleteOnly;
            }

            if (tech !== undefined) {
                localVarQueryParameter["tech"] = tech;
            }

            if (auditIdMin !== undefined) {
                localVarQueryParameter["auditIdMin"] = auditIdMin;
            }

            if (auditIdMax !== undefined) {
                localVarQueryParameter["auditIdMax"] = auditIdMax;
            }

            if (noReport !== undefined) {
                localVarQueryParameter["noReport"] = noReport;
            }

            if (noImport !== undefined) {
                localVarQueryParameter["noImport"] = noImport;
            }

            if (include !== undefined) {
                localVarQueryParameter["include"] = include;
            }

            if (resolveRef !== undefined) {
                localVarQueryParameter["resolveRef"] = resolveRef;
            }

            if (itemRef !== undefined) {
                localVarQueryParameter["itemRef"] = itemRef;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.3
         * @summary Launches a server-side branch or clone - needs the 'merge' module if actual branching
         * @param {string} project Project short label
         * @param {string} label Branch project label
         * @param {string} shortLabel Branch project short label
         * @param {number} keepPermissions 1 or 0. Defaults to 0 (with 0 the project doesn&#x27;t have any permission after branching)
         * @param {number} keepContent 1 or 0. Defaults to 1. 0 only works without branch and without history
         * @param {number} [branch] (optional) Set to 1 to branch (default), 0 to just copy/clone
         * @param {number} [history] (optional) Set to 1 to branch or copy with history, defaults to 0
         * @param {string} [tagToCreate] (optional) specify a tag (by default auto-generated)
         * @param {string} [branchInThePastTag] (optional) specify a tag to branch in the past (needs history&#x3D;1)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectBranchPost(
            project: string,
            label: string,
            shortLabel: string,
            keepPermissions: number,
            keepContent: number,
            branch?: number,
            history?: number,
            tagToCreate?: string,
            branchInThePastTag?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectBranchPost.",
                );
            }
            // verify required parameter 'label' is not null or undefined
            if (label === null || label === undefined) {
                throw new RequiredError(
                    "label",
                    "Required parameter label was null or undefined when calling projectBranchPost.",
                );
            }
            // verify required parameter 'shortLabel' is not null or undefined
            if (shortLabel === null || shortLabel === undefined) {
                throw new RequiredError(
                    "shortLabel",
                    "Required parameter shortLabel was null or undefined when calling projectBranchPost.",
                );
            }
            // verify required parameter 'keepPermissions' is not null or undefined
            if (keepPermissions === null || keepPermissions === undefined) {
                throw new RequiredError(
                    "keepPermissions",
                    "Required parameter keepPermissions was null or undefined when calling projectBranchPost.",
                );
            }
            // verify required parameter 'keepContent' is not null or undefined
            if (keepContent === null || keepContent === undefined) {
                throw new RequiredError(
                    "keepContent",
                    "Required parameter keepContent was null or undefined when calling projectBranchPost.",
                );
            }
            const localVarPath = `/{project}/branch`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (label !== undefined) {
                localVarQueryParameter["label"] = label;
            }

            if (shortLabel !== undefined) {
                localVarQueryParameter["shortLabel"] = shortLabel;
            }

            if (branch !== undefined) {
                localVarQueryParameter["branch"] = branch;
            }

            if (history !== undefined) {
                localVarQueryParameter["history"] = history;
            }

            if (tagToCreate !== undefined) {
                localVarQueryParameter["tagToCreate"] = tagToCreate;
            }

            if (branchInThePastTag !== undefined) {
                localVarQueryParameter["branchInThePastTag"] = branchInThePastTag;
            }

            if (keepPermissions !== undefined) {
                localVarQueryParameter["keepPermissions"] = keepPermissions;
            }

            if (keepContent !== undefined) {
                localVarQueryParameter["keepContent"] = keepContent;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all dates at which a project has been modified
         * @param {string} project Project short label
         * @param {string} [deleteOnly] (optional) if set to yes, only report actions of type delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCalendarGet(project: string, deleteOnly?: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCalendarGet.",
                );
            }
            const localVarPath = `/{project}/calendar`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (deleteOnly !== undefined) {
                localVarQueryParameter["deleteOnly"] = deleteOnly;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Removes (inactivate) a category. Will fail on REPORT and FOLDER categories
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategoryDelete(project: string, category: string, reason: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCatCategoryDelete.",
                );
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError(
                    "category",
                    "Required parameter category was null or undefined when calling projectCatCategoryDelete.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectCatCategoryDelete.",
                );
            }
            const localVarPath = `/{project}/cat/{category}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get details of a category
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {string} [filter] (optional) specify a filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategoryGet(project: string, category: string, filter?: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCatCategoryGet.",
                );
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError(
                    "category",
                    "Required parameter category was null or undefined when calling projectCatCategoryGet.",
                );
            }
            const localVarPath = `/{project}/cat/{category}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Modifies a categorie's labels, and fix the project's settings to reflect that change, OR modifies a category's order.
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {number} order The new order (for reordering)
         * @param {string} shortLabel The new short label for that category (for renaming)
         * @param {string} label The new long label for that category (for renaming)
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategoryPut(
            project: string,
            category: string,
            order: number,
            shortLabel: string,
            label: string,
            reason: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCatCategoryPut.",
                );
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError(
                    "category",
                    "Required parameter category was null or undefined when calling projectCatCategoryPut.",
                );
            }
            // verify required parameter 'order' is not null or undefined
            if (order === null || order === undefined) {
                throw new RequiredError(
                    "order",
                    "Required parameter order was null or undefined when calling projectCatCategoryPut.",
                );
            }
            // verify required parameter 'shortLabel' is not null or undefined
            if (shortLabel === null || shortLabel === undefined) {
                throw new RequiredError(
                    "shortLabel",
                    "Required parameter shortLabel was null or undefined when calling projectCatCategoryPut.",
                );
            }
            // verify required parameter 'label' is not null or undefined
            if (label === null || label === undefined) {
                throw new RequiredError(
                    "label",
                    "Required parameter label was null or undefined when calling projectCatCategoryPut.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectCatCategoryPut.",
                );
            }
            const localVarPath = `/{project}/cat/{category}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (order !== undefined) {
                localVarQueryParameter["order"] = order;
            }

            if (shortLabel !== undefined) {
                localVarQueryParameter["shortLabel"] = shortLabel;
            }

            if (label !== undefined) {
                localVarQueryParameter["label"] = label;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all settings of a category
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategorySettingGet(project: string, category: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCatCategorySettingGet.",
                );
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError(
                    "category",
                    "Required parameter category was null or undefined when calling projectCatCategorySettingGet.",
                );
            }
            const localVarPath = `/{project}/cat/{category}/setting`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds or changes a category setting. If the value is empty, the setting will be deleted
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {string} key setting key
         * @param {string} value value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategorySettingPost(
            project: string,
            category: string,
            key: string,
            value: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCatCategorySettingPost.",
                );
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError(
                    "category",
                    "Required parameter category was null or undefined when calling projectCatCategorySettingPost.",
                );
            }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError(
                    "key",
                    "Required parameter key was null or undefined when calling projectCatCategorySettingPost.",
                );
            }
            // verify required parameter 'value' is not null or undefined
            if (value === null || value === undefined) {
                throw new RequiredError(
                    "value",
                    "Required parameter value was null or undefined when calling projectCatCategorySettingPost.",
                );
            }
            const localVarPath = `/{project}/cat/{category}/setting`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (key !== undefined) {
                localVarQueryParameter["key"] = key;
            }

            if (value !== undefined) {
                localVarQueryParameter["value"] = value;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all categories of a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatGet(project: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCatGet.",
                );
            }
            const localVarPath = `/{project}/cat`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds a fields in a category
         * @param {string} project Project short label
         * @param {string} label Field label
         * @param {string} category Category short label
         * @param {string} fieldType Type of field
         * @param {string} fieldParam Parameter for the field
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatPost(
            project: string,
            label: string,
            category: string,
            fieldType: string,
            fieldParam: string,
            reason: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCatPost.",
                );
            }
            // verify required parameter 'label' is not null or undefined
            if (label === null || label === undefined) {
                throw new RequiredError(
                    "label",
                    "Required parameter label was null or undefined when calling projectCatPost.",
                );
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError(
                    "category",
                    "Required parameter category was null or undefined when calling projectCatPost.",
                );
            }
            // verify required parameter 'fieldType' is not null or undefined
            if (fieldType === null || fieldType === undefined) {
                throw new RequiredError(
                    "fieldType",
                    "Required parameter fieldType was null or undefined when calling projectCatPost.",
                );
            }
            // verify required parameter 'fieldParam' is not null or undefined
            if (fieldParam === null || fieldParam === undefined) {
                throw new RequiredError(
                    "fieldParam",
                    "Required parameter fieldParam was null or undefined when calling projectCatPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectCatPost.",
                );
            }
            const localVarPath = `/{project}/cat`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (label !== undefined) {
                localVarQueryParameter["label"] = label;
            }

            if (category !== undefined) {
                localVarQueryParameter["category"] = category;
            }

            if (fieldType !== undefined) {
                localVarQueryParameter["fieldType"] = fieldType;
            }

            if (fieldParam !== undefined) {
                localVarQueryParameter["fieldParam"] = fieldParam;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Clones a project
         * @param {string} project Project short label
         * @param {string} label Project label
         * @param {string} shortLabel Project short label
         * @param {number} keepHistory 1 or 0. Defaults to 0
         * @param {number} keepContent 1 or 0. Defaults to 0 (only the REPORT part is kept, make sense only if keepHistory is 0)
         * @param {number} keepPermissions 1 or 0. Defaults to 0 (with 0 the project doesn&#x27;t have any permission after cloning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectClonePost(
            project: string,
            label: string,
            shortLabel: string,
            keepHistory: number,
            keepContent: number,
            keepPermissions: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectClonePost.",
                );
            }
            // verify required parameter 'label' is not null or undefined
            if (label === null || label === undefined) {
                throw new RequiredError(
                    "label",
                    "Required parameter label was null or undefined when calling projectClonePost.",
                );
            }
            // verify required parameter 'shortLabel' is not null or undefined
            if (shortLabel === null || shortLabel === undefined) {
                throw new RequiredError(
                    "shortLabel",
                    "Required parameter shortLabel was null or undefined when calling projectClonePost.",
                );
            }
            // verify required parameter 'keepHistory' is not null or undefined
            if (keepHistory === null || keepHistory === undefined) {
                throw new RequiredError(
                    "keepHistory",
                    "Required parameter keepHistory was null or undefined when calling projectClonePost.",
                );
            }
            // verify required parameter 'keepContent' is not null or undefined
            if (keepContent === null || keepContent === undefined) {
                throw new RequiredError(
                    "keepContent",
                    "Required parameter keepContent was null or undefined when calling projectClonePost.",
                );
            }
            // verify required parameter 'keepPermissions' is not null or undefined
            if (keepPermissions === null || keepPermissions === undefined) {
                throw new RequiredError(
                    "keepPermissions",
                    "Required parameter keepPermissions was null or undefined when calling projectClonePost.",
                );
            }
            const localVarPath = `/{project}/clone`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (label !== undefined) {
                localVarQueryParameter["label"] = label;
            }

            if (shortLabel !== undefined) {
                localVarQueryParameter["shortLabel"] = shortLabel;
            }

            if (keepHistory !== undefined) {
                localVarQueryParameter["keepHistory"] = keepHistory;
            }

            if (keepContent !== undefined) {
                localVarQueryParameter["keepContent"] = keepContent;
            }

            if (keepPermissions !== undefined) {
                localVarQueryParameter["keepPermissions"] = keepPermissions;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Asks for the difference between 2 signed documents, as a Word document. The job ID is returned as answer
         * @param {string} project Project short label
         * @param {string} signitem1 SIGN-xx for the first SIGN document to compare
         * @param {string} signitem2 SIGN-xx for the 2nd SIGN document to compare
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCompareSignitem1Signitem2Post(
            project: string,
            signitem1: string,
            signitem2: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCompareSignitem1Signitem2Post.",
                );
            }
            // verify required parameter 'signitem1' is not null or undefined
            if (signitem1 === null || signitem1 === undefined) {
                throw new RequiredError(
                    "signitem1",
                    "Required parameter signitem1 was null or undefined when calling projectCompareSignitem1Signitem2Post.",
                );
            }
            // verify required parameter 'signitem2' is not null or undefined
            if (signitem2 === null || signitem2 === undefined) {
                throw new RequiredError(
                    "signitem2",
                    "Required parameter signitem2 was null or undefined when calling projectCompareSignitem1Signitem2Post.",
                );
            }
            const localVarPath = `/{project}/compare/{signitem1}/{signitem2}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"signitem1"}}`, encodeURIComponent(String(signitem1)))
                .replace(`{${"signitem2"}}`, encodeURIComponent(String(signitem2)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a project's schema
         * @param {string} [excludeCategories] (optional) comma-separated list of categories to exclude, like DOC,SIGN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectConfigcheckGet(excludeCategories?: string, options: any = {}): FetchArgs {
            const localVarPath = `/project/configcheck`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (excludeCategories !== undefined) {
                localVarQueryParameter["excludeCategories"] = excludeCategories;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.2
         * @summary Copy items from a folder to another one
         * @param {string} project Project short label
         * @param {string} itemOrFolder Item reference (XXX-nn) or folder (F-XXX-nn)
         * @param {string} targetFolder Reference of the target folder (F-categ-serial)
         * @param {string} reason The reason why the user is doing this
         * @param {string} [targetProject] (optional) project to copy into (by default, same project)
         * @param {number} [copyLabels] (optional) 0 or 1. Defaults to 0
         * @param {string} [map] (optional) mapN&#x3D;M -  map field N in source to field M in target
         * @param {string} [ignoreLabels] (optional) can contain a comma-delimited list of labels NOT to copy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCopyItemOrFolderPost(
            project: string,
            itemOrFolder: string,
            targetFolder: string,
            reason: string,
            targetProject?: string,
            copyLabels?: number,
            map?: string,
            ignoreLabels?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCopyItemOrFolderPost.",
                );
            }
            // verify required parameter 'itemOrFolder' is not null or undefined
            if (itemOrFolder === null || itemOrFolder === undefined) {
                throw new RequiredError(
                    "itemOrFolder",
                    "Required parameter itemOrFolder was null or undefined when calling projectCopyItemOrFolderPost.",
                );
            }
            // verify required parameter 'targetFolder' is not null or undefined
            if (targetFolder === null || targetFolder === undefined) {
                throw new RequiredError(
                    "targetFolder",
                    "Required parameter targetFolder was null or undefined when calling projectCopyItemOrFolderPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectCopyItemOrFolderPost.",
                );
            }
            const localVarPath = `/{project}/copy/{itemOrFolder}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"itemOrFolder"}}`, encodeURIComponent(String(itemOrFolder)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (targetFolder !== undefined) {
                localVarQueryParameter["targetFolder"] = targetFolder;
            }

            if (targetProject !== undefined) {
                localVarQueryParameter["targetProject"] = targetProject;
            }

            if (copyLabels !== undefined) {
                localVarQueryParameter["copyLabels"] = copyLabels;
            }

            if (map !== undefined) {
                localVarQueryParameter["map"] = map;
            }

            if (ignoreLabels !== undefined) {
                localVarQueryParameter["ignoreLabels"] = ignoreLabels;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get cross project links
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCrossprojectlinkGet(project: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectCrossprojectlinkGet.",
                );
            }
            const localVarPath = `/{project}/crossprojectlink`.replace(
                `{${"project"}}`,
                encodeURIComponent(String(project)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.1
         * @summary Removes completely a project (only used for unit testing). This is an actual DELETE in the database.
         * @param {string} project Project short label
         * @param {string} confirm Needs to be yes for the method to be executed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectDelete(project: string, confirm: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectDelete.",
                );
            }
            // verify required parameter 'confirm' is not null or undefined
            if (confirm === null || confirm === undefined) {
                throw new RequiredError(
                    "confirm",
                    "Required parameter confirm was null or undefined when calling projectDelete.",
                );
            }
            const localVarPath = `/{project}`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (confirm !== undefined) {
                localVarQueryParameter["confirm"] = confirm;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Converts an excel file (xls, xlsx) into a XML version that we send straight back as an XML payload.
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectExcelxmlPost(project: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectExcelxmlPost.",
                );
            }
            const localVarPath = `/{project}/excelxml`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Executes UC or TC into XTC items
         * @param {string} project Project short label
         * @param {ExecuteParam} [body] There must be a JSON as a payload. It includes all parameters AND the reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectExecutePost(project: string, body?: ExecuteParam, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectExecutePost.",
                );
            }
            const localVarPath = `/{project}/execute`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"ExecuteParam" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Asks for an export of some items. The job ID is returned as answer
         * @param {string} project Project short label
         * @param {string} itemList Mandatory list of items to export.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectExportGet(project: string, itemList: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectExportGet.",
                );
            }
            // verify required parameter 'itemList' is not null or undefined
            if (itemList === null || itemList === undefined) {
                throw new RequiredError(
                    "itemList",
                    "Required parameter itemList was null or undefined when calling projectExportGet.",
                );
            }
            const localVarPath = `/{project}/export`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (itemList !== undefined) {
                localVarQueryParameter["itemList"] = itemList;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Removes (inactivate) a field.
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {number} field The field number (like field&#x3D;502)
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFieldCategoryDelete(
            project: string,
            category: string,
            field: number,
            reason: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectFieldCategoryDelete.",
                );
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError(
                    "category",
                    "Required parameter category was null or undefined when calling projectFieldCategoryDelete.",
                );
            }
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError(
                    "field",
                    "Required parameter field was null or undefined when calling projectFieldCategoryDelete.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectFieldCategoryDelete.",
                );
            }
            const localVarPath = `/{project}/field/{category}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (field !== undefined) {
                localVarQueryParameter["field"] = field;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get 1 field of an item. {item} has the form CATEG-number.
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} field Mandatory. Field number (faster) OR field label
         * @param {string} [format] Optional. Format for the return. Can be text, json, html, xml or xslt. Defaults to html
         * @param {number} [download] Optional. 1 to have in download, 0 as direct result. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFieldItemGet(
            project: string,
            item: string,
            field: string,
            format?: string,
            download?: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectFieldItemGet.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectFieldItemGet.",
                );
            }
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError(
                    "field",
                    "Required parameter field was null or undefined when calling projectFieldItemGet.",
                );
            }
            const localVarPath = `/{project}/field/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (field !== undefined) {
                localVarQueryParameter["field"] = field;
            }

            if (format !== undefined) {
                localVarQueryParameter["format"] = format;
            }

            if (download !== undefined) {
                localVarQueryParameter["download"] = download;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Modifies a field's label and parameter OR modifies a field's order.
         * @param {string} project Project short label
         * @param {number} field The field number (like field&#x3D;502)
         * @param {string} label The new label (for renaming)
         * @param {string} fieldParam The new parameter (for renaming)
         * @param {number} order The new order (for reordering)
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFieldPut(
            project: string,
            field: number,
            label: string,
            fieldParam: string,
            order: number,
            reason: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectFieldPut.",
                );
            }
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError(
                    "field",
                    "Required parameter field was null or undefined when calling projectFieldPut.",
                );
            }
            // verify required parameter 'label' is not null or undefined
            if (label === null || label === undefined) {
                throw new RequiredError(
                    "label",
                    "Required parameter label was null or undefined when calling projectFieldPut.",
                );
            }
            // verify required parameter 'fieldParam' is not null or undefined
            if (fieldParam === null || fieldParam === undefined) {
                throw new RequiredError(
                    "fieldParam",
                    "Required parameter fieldParam was null or undefined when calling projectFieldPut.",
                );
            }
            // verify required parameter 'order' is not null or undefined
            if (order === null || order === undefined) {
                throw new RequiredError(
                    "order",
                    "Required parameter order was null or undefined when calling projectFieldPut.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectFieldPut.",
                );
            }
            const localVarPath = `/{project}/field`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (field !== undefined) {
                localVarQueryParameter["field"] = field;
            }

            if (label !== undefined) {
                localVarQueryParameter["label"] = label;
            }

            if (fieldParam !== undefined) {
                localVarQueryParameter["fieldParam"] = fieldParam;
            }

            if (order !== undefined) {
                localVarQueryParameter["order"] = order;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have the right key to download the file. Valid from version 2.1
         * @summary Retrieve one project file. The fileno is a simple fileId. This request returns the actual file
         * @param {string} project Project short label
         * @param {number} fileno file number
         * @param {string} key The key of the file
         * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFileFilenoGet(
            project: string,
            fileno: number,
            key: string,
            disposition?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectFileFilenoGet.",
                );
            }
            // verify required parameter 'fileno' is not null or undefined
            if (fileno === null || fileno === undefined) {
                throw new RequiredError(
                    "fileno",
                    "Required parameter fileno was null or undefined when calling projectFileFilenoGet.",
                );
            }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError(
                    "key",
                    "Required parameter key was null or undefined when calling projectFileFilenoGet.",
                );
            }
            const localVarPath = `/{project}/file/{fileno}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"fileno"}}`, encodeURIComponent(String(fileno)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (key !== undefined) {
                localVarQueryParameter["key"] = key;
            }

            if (disposition !== undefined) {
                localVarQueryParameter["disposition"] = disposition;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Retrieve list of all files owned by a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFileGet(project: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectFileGet.",
                );
            }
            const localVarPath = `/{project}/file`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Creates a new file - the file should be uploaded as payload (or through the url argument as an alternative). It's mime type should be sent through the HTTP protocol.
         * @param {string} project Project short label
         * @param {string} [url] Optional argument -  the file could also come from an external URL. In this case there will be an error if we can&#x27;t retrieve it on the server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFilePost(project: string, urlIn?: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectFilePost.",
                );
            }
            const localVarPath = `/{project}/file`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (urlIn !== undefined) {
                localVarQueryParameter["url"] = urlIn;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.1
         * @summary Creates a new folder
         * @param {string} project Project short label
         * @param {string} parent Reference of the parent folder in the form F-CATEG-serial (example -  F-SPEC-17)
         * @param {string} label folder label
         * @param {string} reason The reason why the user is doing this
         * @param {string} [fxField] (optional) Add one of each of these to set folder&#x27;s fields. fx is followed by the field ID (a number)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFolderPost(
            project: string,
            parent: string,
            label: string,
            reason: string,
            fxField?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectFolderPost.",
                );
            }
            // verify required parameter 'parent' is not null or undefined
            if (parent === null || parent === undefined) {
                throw new RequiredError(
                    "parent",
                    "Required parameter parent was null or undefined when calling projectFolderPost.",
                );
            }
            // verify required parameter 'label' is not null or undefined
            if (label === null || label === undefined) {
                throw new RequiredError(
                    "label",
                    "Required parameter label was null or undefined when calling projectFolderPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectFolderPost.",
                );
            }
            const localVarPath = `/{project}/folder`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (parent !== undefined) {
                localVarQueryParameter["parent"] = parent;
            }

            if (label !== undefined) {
                localVarQueryParameter["label"] = label;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            if (fxField !== undefined) {
                localVarQueryParameter["fxField"] = fxField;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get list of project info -  users, settings, categories
         * @param {string} project Project short label
         * @param {number} [adminUI] (optional) set to adminUI&#x3D;1 to have this project data even if you are not assigned to, as an admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectGet(project: string, adminUI?: number, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectGet.",
                );
            }
            const localVarPath = `/{project}`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (adminUI !== undefined) {
                localVarQueryParameter["adminUI"] = adminUI;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Hides a project
         * @param {string} project Project short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHidePut(project: string, reason: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectHidePut.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectHidePut.",
                );
            }
            const localVarPath = `/{project}/hide`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.2
         * @summary Launches a server-side hook
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} hook name of the hook
         * @param {string} [body] Payload for the hook, treated as a string.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHookItemPost(project: string, item: string, hook: string, body?: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectHookItemPost.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectHookItemPost.",
                );
            }
            // verify required parameter 'hook' is not null or undefined
            if (hook === null || hook === undefined) {
                throw new RequiredError(
                    "hook",
                    "Required parameter hook was null or undefined when calling projectHookItemPost.",
                );
            }
            const localVarPath = `/{project}/hook/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (hook !== undefined) {
                localVarQueryParameter["hook"] = hook;
            }

            localVarHeaderParameter["Content-Type"] = "text/plain";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"string" !== "string" || localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Cleans up an input html blob according to the current html cleanup rules. The blob is passed in the POST payload. The payload must be a json object with {\"htmlToClean\" - \"x\"}
         * @param {string} project Project short label
         * @param {GetHmlBlobInput} [body] Payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHtmlCleanupBlobPost(project: string, body?: GetHmlBlobInput, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectHtmlCleanupBlobPost.",
                );
            }
            const localVarPath = `/{project}/htmlCleanupBlob`.replace(
                `{${"project"}}`,
                encodeURIComponent(String(project)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"GetHmlBlobInput" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the list of items that would be changed if we applied html cleanup. You can pass a cleanup setting in the payload of the POST. If it's not there we take the customer (global) setting and force the cleanup to true
         * @param {string} project Project short label
         * @param {CleanupSetting} [body] Cleanup setting (optional)
         * @param {string} [categories] (optional) list of comma-delimited categories to go through, all by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHtmlCleanupTestPost(
            project: string,
            body?: CleanupSetting,
            categories?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectHtmlCleanupTestPost.",
                );
            }
            const localVarPath = `/{project}/htmlCleanupTest`.replace(
                `{${"project"}}`,
                encodeURIComponent(String(project)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (categories !== undefined) {
                localVarQueryParameter["categories"] = categories;
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"CleanupSetting" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - ?. Valid from version 2.1
         * @summary Removes an import
         * @param {string} project Project short label
         * @param {string} id id
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectImportIdDelete(project: string, id: string, reason: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectImportIdDelete.",
                );
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError(
                    "id",
                    "Required parameter id was null or undefined when calling projectImportIdDelete.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectImportIdDelete.",
                );
            }
            const localVarPath = `/{project}/import/{id}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Imports some items into a project
         * @param {string} project Project short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectImportPost(project: string, reason: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectImportPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectImportPost.",
                );
            }
            const localVarPath = `/{project}/import`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
         * @summary Get the history of a import in a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectImportinfoGet(project: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectImportinfoGet.",
                );
            }
            const localVarPath = `/{project}/importinfo`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get details of a folder. {folder} has the form F-CATEG-number[-vN].
         * @param {string} project Project short label
         * @param {string} folder Folder reference (F-XXX-nn)
         * @param {number} [history] (optional) set history&#x3D;1 to retrieve list of all versions
         * @param {string} [filter] (optional) specify a filter
         * @param {string} [children] (optional) set to yes if you need the children as well (recursively).
         * @param {string} [atDate] (optional) retrieves the item at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z. Not compatible with the version query -vN
         * @param {number} [fields] (optional) set fields&#x3D;1 to retrieve list of all fields, even the empty ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemFolderGet(
            project: string,
            folder: string,
            history?: number,
            filter?: string,
            children?: string,
            atDate?: string,
            fields?: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectItemFolderGet.",
                );
            }
            // verify required parameter 'folder' is not null or undefined
            if (folder === null || folder === undefined) {
                throw new RequiredError(
                    "folder",
                    "Required parameter folder was null or undefined when calling projectItemFolderGet.",
                );
            }
            const localVarPath = `/{project}/item/{folder}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"folder"}}`, encodeURIComponent(String(folder)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (history !== undefined) {
                localVarQueryParameter["history"] = history;
            }

            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }

            if (children !== undefined) {
                localVarQueryParameter["children"] = children;
            }

            if (atDate !== undefined) {
                localVarQueryParameter["atDate"] = atDate;
            }

            if (fields !== undefined) {
                localVarQueryParameter["fields"] = fields;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Removes (inactivate) an item (or a folder). Item has the form (F-)CATEG-number. Will fail on non-empty folders
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} confirm Needs to be yes for the method to be executed IF it is a non-empty folder
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemDelete(
            project: string,
            item: string,
            confirm: string,
            reason: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectItemItemDelete.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectItemItemDelete.",
                );
            }
            // verify required parameter 'confirm' is not null or undefined
            if (confirm === null || confirm === undefined) {
                throw new RequiredError(
                    "confirm",
                    "Required parameter confirm was null or undefined when calling projectItemItemDelete.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectItemItemDelete.",
                );
            }
            const localVarPath = `/{project}/item/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (confirm !== undefined) {
                localVarQueryParameter["confirm"] = confirm;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get details of an item. {item} has the form CATEG-number[-vN].
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {number} [history] (optional) set history&#x3D;1 to retrieve list of all versions
         * @param {number} [fields] (optional) set fields&#x3D;1 to retrieve list of all fields, even the empty ones
         * @param {string} [filter] (optional) specify a filter
         * @param {string} [atDate] (optional) retrieves the item at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z. Not compatible with the version query -vN
         * @param {number} [withTree] (optional) retrieves the context tree if set to 1, in the field contextTree. Exclusive to filter and atDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemGet(
            project: string,
            item: string,
            history?: number,
            fields?: number,
            filter?: string,
            atDate?: string,
            withTree?: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectItemItemGet.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectItemItemGet.",
                );
            }
            const localVarPath = `/{project}/item/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (history !== undefined) {
                localVarQueryParameter["history"] = history;
            }

            if (fields !== undefined) {
                localVarQueryParameter["fields"] = fields;
            }

            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }

            if (atDate !== undefined) {
                localVarQueryParameter["atDate"] = atDate;
            }

            if (withTree !== undefined) {
                localVarQueryParameter["withTree"] = withTree;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Restores an item. Item has the form CATEG-number
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} reason The reason why the user is doing this
         * @param {number} [at] (optional) If set, specifies that the item should be restored as it was in that version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemPost(project: string, item: string, reason: string, at?: number, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectItemItemPost.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectItemItemPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectItemItemPost.",
                );
            }
            const localVarPath = `/{project}/item/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (at !== undefined) {
                localVarQueryParameter["at"] = at;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Modifies an item or a folder. Item has the form CATEG-number, folders -  F-CATEG-number
         * @param {ItemItemBody} body
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemPut(body: ItemItemBody, project: string, item: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError(
                    "body",
                    "Required parameter body was null or undefined when calling projectItemItemPut.",
                );
            }
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectItemItemPut.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectItemItemPut.",
                );
            }
            const localVarPath = `/{project}/item/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"ItemItemBody" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.1
         * @summary Adds an item in a folder
         * @param {ProjectItemBody} body
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemPost(body: ProjectItemBody, project: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError(
                    "body",
                    "Required parameter body was null or undefined when calling projectItemPost.",
                );
            }
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectItemPost.",
                );
            }
            const localVarPath = `/{project}/item`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"ProjectItemBody" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - ?. Valid from version 2.1
         * @summary Removes (inactivate) a link between 2 items. Items are in the form CATEG-number
         * @param {string} project Project short label
         * @param {string} upitem Item reference (XXX-nn) for the UP item
         * @param {string} downitem Item reference (XXX-nn) for the DOWN item
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemlinkUpitemDownitemDelete(
            project: string,
            upitem: string,
            downitem: string,
            reason: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectItemlinkUpitemDownitemDelete.",
                );
            }
            // verify required parameter 'upitem' is not null or undefined
            if (upitem === null || upitem === undefined) {
                throw new RequiredError(
                    "upitem",
                    "Required parameter upitem was null or undefined when calling projectItemlinkUpitemDownitemDelete.",
                );
            }
            // verify required parameter 'downitem' is not null or undefined
            if (downitem === null || downitem === undefined) {
                throw new RequiredError(
                    "downitem",
                    "Required parameter downitem was null or undefined when calling projectItemlinkUpitemDownitemDelete.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectItemlinkUpitemDownitemDelete.",
                );
            }
            const localVarPath = `/{project}/itemlink/{upitem}/{downitem}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"upitem"}}`, encodeURIComponent(String(upitem)))
                .replace(`{${"downitem"}}`, encodeURIComponent(String(downitem)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Adds a link between 2 items. Both items are in the form CATEG-number
         * @param {string} project Project short label
         * @param {string} upitem Item reference (XXX-nn) for the UP item
         * @param {string} downitem Item reference (XXX-nn) for the DOWN item
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemlinkUpitemDownitemPost(
            project: string,
            upitem: string,
            downitem: string,
            reason: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectItemlinkUpitemDownitemPost.",
                );
            }
            // verify required parameter 'upitem' is not null or undefined
            if (upitem === null || upitem === undefined) {
                throw new RequiredError(
                    "upitem",
                    "Required parameter upitem was null or undefined when calling projectItemlinkUpitemDownitemPost.",
                );
            }
            // verify required parameter 'downitem' is not null or undefined
            if (downitem === null || downitem === undefined) {
                throw new RequiredError(
                    "downitem",
                    "Required parameter downitem was null or undefined when calling projectItemlinkUpitemDownitemPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectItemlinkUpitemDownitemPost.",
                );
            }
            const localVarPath = `/{project}/itemlink/{upitem}/{downitem}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"upitem"}}`, encodeURIComponent(String(upitem)))
                .replace(`{${"downitem"}}`, encodeURIComponent(String(downitem)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get the list of items that are detailed in a DOC/SIGN item.
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {number} [detailed] Optional. When set to 1 adds a secondaryItems list in the answer. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemlistItemGet(project: string, item: string, detailed?: number, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectItemlistItemGet.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectItemlistItemGet.",
                );
            }
            const localVarPath = `/{project}/itemlist/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (detailed !== undefined) {
                localVarQueryParameter["detailed"] = detailed;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Retrieve list of all jobs in a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobGet(project: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectJobGet.",
                );
            }
            const localVarPath = `/{project}/job`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.3
         * @summary Aborts a job.
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobDelete(project: string, job: number, reason: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectJobJobDelete.",
                );
            }
            // verify required parameter 'job' is not null or undefined
            if (job === null || job === undefined) {
                throw new RequiredError(
                    "job",
                    "Required parameter job was null or undefined when calling projectJobJobDelete.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectJobJobDelete.",
                );
            }
            const localVarPath = `/{project}/job/{job}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"job"}}`, encodeURIComponent(String(job)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a job file. The job part is the jobID (a number) and the file is the fileID (a number)
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {number} fileno file number
         * @param {string} [mode] (optional) set to mode&#x3D;direct to get the output in the response output instead of as a download file. This assumes the file is HTML
         * @param {string} [format] (optional) set to format&#x3D;json to get a json output instead of XML
         * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobFilenoGet(
            project: string,
            job: number,
            fileno: number,
            mode?: string,
            format?: string,
            disposition?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectJobJobFilenoGet.",
                );
            }
            // verify required parameter 'job' is not null or undefined
            if (job === null || job === undefined) {
                throw new RequiredError(
                    "job",
                    "Required parameter job was null or undefined when calling projectJobJobFilenoGet.",
                );
            }
            // verify required parameter 'fileno' is not null or undefined
            if (fileno === null || fileno === undefined) {
                throw new RequiredError(
                    "fileno",
                    "Required parameter fileno was null or undefined when calling projectJobJobFilenoGet.",
                );
            }
            const localVarPath = `/{project}/job/{job}/{fileno}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"job"}}`, encodeURIComponent(String(job)))
                .replace(`{${"fileno"}}`, encodeURIComponent(String(fileno)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (mode !== undefined) {
                localVarQueryParameter["mode"] = mode;
            }

            if (format !== undefined) {
                localVarQueryParameter["format"] = format;
            }

            if (disposition !== undefined) {
                localVarQueryParameter["disposition"] = disposition;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a job status, including generated files. The variable part is the jobID (a number)
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobGet(project: string, job: number, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectJobJobGet.",
                );
            }
            // verify required parameter 'job' is not null or undefined
            if (job === null || job === undefined) {
                throw new RequiredError(
                    "job",
                    "Required parameter job was null or undefined when calling projectJobJobGet.",
                );
            }
            const localVarPath = `/{project}/job/{job}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"job"}}`, encodeURIComponent(String(job)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.2
         * @summary Sets the progress of a job
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {number} progress progress (0 to 100, 200 for error)
         * @param {string} [status] (optional( status text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobPost(
            project: string,
            job: number,
            progress: number,
            status?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectJobJobPost.",
                );
            }
            // verify required parameter 'job' is not null or undefined
            if (job === null || job === undefined) {
                throw new RequiredError(
                    "job",
                    "Required parameter job was null or undefined when calling projectJobJobPost.",
                );
            }
            // verify required parameter 'progress' is not null or undefined
            if (progress === null || progress === undefined) {
                throw new RequiredError(
                    "progress",
                    "Required parameter progress was null or undefined when calling projectJobJobPost.",
                );
            }
            const localVarPath = `/{project}/job/{job}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"job"}}`, encodeURIComponent(String(job)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (progress !== undefined) {
                localVarQueryParameter["progress"] = progress;
            }

            if (status !== undefined) {
                localVarQueryParameter["status"] = status;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the label history of a project -  list of all label changes for all items
         * @param {string} project Project short label
         * @param {string} [itemRef] (optional) ask for just one item (the return structure is still an array in that case)
         * @param {string} [from] (optional) date from
         * @param {string} [to] (optional) date to - works only if you only specified a from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectLabelhistoryGet(
            project: string,
            itemRef?: string,
            from?: string,
            to?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectLabelhistoryGet.",
                );
            }
            const localVarPath = `/{project}/labelhistory`.replace(
                `{${"project"}}`,
                encodeURIComponent(String(project)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (itemRef !== undefined) {
                localVarQueryParameter["itemRef"] = itemRef;
            }

            if (from !== undefined) {
                localVarQueryParameter["from"] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter["to"] = to;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the merge history of a project - needs the 'merge' module
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMergehistoryGet(project: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectMergehistoryGet.",
                );
            }
            const localVarPath = `/{project}/mergehistory`.replace(
                `{${"project"}}`,
                encodeURIComponent(String(project)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the merge information - needs the 'merge' module
         * @param {string} project Project short label
         * @param {string} [excludeCategories] (optional) comma-delimited list of categories to exclude
         * @param {string} [fromDate] (optional) date from which we consider the merges. ISO8601 format -- this parameter was introduced in v 2.3.4
         * @param {number} [push] (optional) set to 1 if you inquire about a push, not a merge -- this parameter was introduced in v 2.3.4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMergeinfoGet(
            project: string,
            excludeCategories?: string,
            fromDate?: string,
            push?: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectMergeinfoGet.",
                );
            }
            const localVarPath = `/{project}/mergeinfo`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (excludeCategories !== undefined) {
                localVarQueryParameter["excludeCategories"] = excludeCategories;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter["fromDate"] = fromDate;
            }

            if (push !== undefined) {
                localVarQueryParameter["push"] = push;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Imports some folders from a project to another as a module. Only available is you have the compose module licensed
         * @param {string} project Project short label
         * @param {string} mode Import mode -  can be include or copy
         * @param {string} sourceProject Source project
         * @param {string} sourceSelection A selection of folders and items to import
         * @param {string} reason The reason why the user is doing this
         * @param {string} [update] Update mode -  can be simple, update or rebase. If not defined, simple assumed
         * @param {string} [oldSourceProject] Old source project (if update&#x3D;rebase
         * @param {string} [lockLabel] An optional label that this operation will set on all items
         * @param {string} [itemParentMode] Default &#x27;orphan&#x27;. Specify &#x27;preserve&#x27; to include all parent folders to the root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectModuleimportPost(
            project: string,
            mode: string,
            sourceProject: string,
            sourceSelection: string,
            reason: string,
            update?: string,
            oldSourceProject?: string,
            lockLabel?: string,
            itemParentMode?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectModuleimportPost.",
                );
            }
            // verify required parameter 'mode' is not null or undefined
            if (mode === null || mode === undefined) {
                throw new RequiredError(
                    "mode",
                    "Required parameter mode was null or undefined when calling projectModuleimportPost.",
                );
            }
            // verify required parameter 'sourceProject' is not null or undefined
            if (sourceProject === null || sourceProject === undefined) {
                throw new RequiredError(
                    "sourceProject",
                    "Required parameter sourceProject was null or undefined when calling projectModuleimportPost.",
                );
            }
            // verify required parameter 'sourceSelection' is not null or undefined
            if (sourceSelection === null || sourceSelection === undefined) {
                throw new RequiredError(
                    "sourceSelection",
                    "Required parameter sourceSelection was null or undefined when calling projectModuleimportPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectModuleimportPost.",
                );
            }
            const localVarPath = `/{project}/moduleimport`.replace(
                `{${"project"}}`,
                encodeURIComponent(String(project)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (mode !== undefined) {
                localVarQueryParameter["mode"] = mode;
            }

            if (update !== undefined) {
                localVarQueryParameter["update"] = update;
            }

            if (sourceProject !== undefined) {
                localVarQueryParameter["sourceProject"] = sourceProject;
            }

            if (oldSourceProject !== undefined) {
                localVarQueryParameter["oldSourceProject"] = oldSourceProject;
            }

            if (sourceSelection !== undefined) {
                localVarQueryParameter["sourceSelection"] = sourceSelection;
            }

            if (lockLabel !== undefined) {
                localVarQueryParameter["lockLabel"] = lockLabel;
            }

            if (itemParentMode !== undefined) {
                localVarQueryParameter["itemParentMode"] = itemParentMode;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Move items into this folder
         * @param {string} project Project short label
         * @param {string} folder Folder reference (F-XXX-nn)
         * @param {string} reason The reason why the user is doing this
         * @param {string} [items] List of items to move in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMoveinFolderPost(
            project: string,
            folder: string,
            reason: string,
            items?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectMoveinFolderPost.",
                );
            }
            // verify required parameter 'folder' is not null or undefined
            if (folder === null || folder === undefined) {
                throw new RequiredError(
                    "folder",
                    "Required parameter folder was null or undefined when calling projectMoveinFolderPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectMoveinFolderPost.",
                );
            }
            const localVarPath = `/{project}/movein/{folder}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"folder"}}`, encodeURIComponent(String(folder)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (items !== undefined) {
                localVarQueryParameter["items"] = items;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Use POST verb instead. Find items based on a search string in one project
         * @param {string} project Project short label
         * @param {string} id search id. Used by MatrixJira js to match queries with answers. Is returned in the output structure
         * @param {string} [search] search term
         * @param {string} [filter] (optional) applies a filter, can be negative
         * @param {string} [fieldsOut] (optional) comma-delimited list of fields to return -  101,102 - or * for all
         * @param {number} [labels] (optional) set to 1 to return labels in the output
         * @param {number} [treeOrder] (optional) set to 1 to return items in tree order (otherwise it&#x27;s project,category,serial)
         * @param {string} [links] (optional) set to up,down to return up and down items, or only up or only down
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedleGet(
            project: string,
            id: string,
            search?: string,
            filter?: string,
            fieldsOut?: string,
            labels?: number,
            treeOrder?: number,
            links?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectNeedleGet.",
                );
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError(
                    "id",
                    "Required parameter id was null or undefined when calling projectNeedleGet.",
                );
            }
            const localVarPath = `/{project}/needle`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (search !== undefined) {
                localVarQueryParameter["search"] = search;
            }

            if (id !== undefined) {
                localVarQueryParameter["id"] = id;
            }

            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }

            if (fieldsOut !== undefined) {
                localVarQueryParameter["fieldsOut"] = fieldsOut;
            }

            if (labels !== undefined) {
                localVarQueryParameter["labels"] = labels;
            }

            if (treeOrder !== undefined) {
                localVarQueryParameter["treeOrder"] = treeOrder;
            }

            if (links !== undefined) {
                localVarQueryParameter["links"] = links;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
         * @summary Find items based on a search string in one project
         * @param {ProjectNeedleBody} body
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedlePost(body: ProjectNeedleBody, project: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError(
                    "body",
                    "Required parameter body was null or undefined when calling projectNeedlePost.",
                );
            }
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectNeedlePost.",
                );
            }
            const localVarPath = `/{project}/needle`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"ProjectNeedleBody" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Find item ids based on a search string in one project
         * @param {string} project Project short label
         * @param {string} search search term
         * @param {string} [filter] (optional) applies a filter, can be negative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedleminimalGet(project: string, search: string, filter?: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectNeedleminimalGet.",
                );
            }
            // verify required parameter 'search' is not null or undefined
            if (search === null || search === undefined) {
                throw new RequiredError(
                    "search",
                    "Required parameter search was null or undefined when calling projectNeedleminimalGet.",
                );
            }
            const localVarPath = `/{project}/needleminimal`.replace(
                `{${"project"}}`,
                encodeURIComponent(String(project)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (search !== undefined) {
                localVarQueryParameter["search"] = search;
            }

            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
         * @summary Find item ids based on a search string in one project
         * @param {ProjectNeedleminimalBody} body
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedleminimalPost(body: ProjectNeedleminimalBody, project: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError(
                    "body",
                    "Required parameter body was null or undefined when calling projectNeedleminimalPost.",
                );
            }
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectNeedleminimalPost.",
                );
            }
            const localVarPath = `/{project}/needleminimal`.replace(
                `{${"project"}}`,
                encodeURIComponent(String(project)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization =
                <any>"ProjectNeedleminimalBody" !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds a category to a project
         * @param {string} project Project short label
         * @param {string} label Category label
         * @param {string} shortLabel Category short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectPost(project: string, label: string, shortLabel: string, reason: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectPost.",
                );
            }
            // verify required parameter 'label' is not null or undefined
            if (label === null || label === undefined) {
                throw new RequiredError(
                    "label",
                    "Required parameter label was null or undefined when calling projectPost.",
                );
            }
            // verify required parameter 'shortLabel' is not null or undefined
            if (shortLabel === null || shortLabel === undefined) {
                throw new RequiredError(
                    "shortLabel",
                    "Required parameter shortLabel was null or undefined when calling projectPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectPost.",
                );
            }
            const localVarPath = `/{project}`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (label !== undefined) {
                localVarQueryParameter["label"] = label;
            }

            if (shortLabel !== undefined) {
                localVarQueryParameter["shortLabel"] = shortLabel;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Publishes an item. Item has the form PUB-nnn
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} reason reason for the publication
         * @param {string} [trainingFor] (optional) list of items for which we need to add training. If list is not there, all trainings will be generated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectPublishItemPost(
            project: string,
            item: string,
            reason: string,
            trainingFor?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectPublishItemPost.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectPublishItemPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectPublishItemPost.",
                );
            }
            const localVarPath = `/{project}/publish/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            if (trainingFor !== undefined) {
                localVarQueryParameter["trainingFor"] = trainingFor;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have QMS viewer access (or higher) to the project. Valid from version 2.3
         * @summary Find a string in the QMS published items
         * @param {string} project Project short label
         * @param {string} [search] (optional) search term. Return an empty array on PUB &lt; 2.3.1 and et the list of all pub if not specified.
         * @param {string} [pubItem] (optional) PUB-x item if you want to search in another than the last one for that project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectQmsfindGet(project: string, search?: string, pubItem?: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectQmsfindGet.",
                );
            }
            const localVarPath = `/{project}/qmsfind`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (search !== undefined) {
                localVarQueryParameter["search"] = search;
            }

            if (pubItem !== undefined) {
                localVarQueryParameter["pubItem"] = pubItem;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) for the reports, read/write for the signed reports. Valid from version 2.1
         * @summary Asks for a new report. The job ID is returned as answer. {report} can be REPORT-n, DOC-n, SIGN-n or a report name.To follow the progress of the job, the GET /{project}/job/{jobid} can be called
         * @param {string} project Project short label
         * @param {string} report name of the report
         * @param {string} isSignedReport If set to true, means the report needs to generate a signed record
         * @param {string} includeSignatures List of comma separated users who need to sign
         * @param {string} newTitle New title for the SIGN- item that is generated (only valid for isSignedReport)
         * @param {string} copyFields List of from-to fields (123,456),(124,457) that we can use to generate the fields in the SIGN record (only valid for isSignedReport)
         * @param {string} [itemList] (optional) list of items to use in the report. By default all categories are used
         * @param {string} [url] (optional) url to generate in the filter
         * @param {string} [resturl] (optional) REST url to generate in the filter
         * @param {string} [format] (optional) format -  html (default), pdf, docx, odt, xml, zipdocx, zippdf or package (from 2.2), or mf (since 2.3)
         * @param {string} [filter] (optional) specify a comma-delimited filter list. Can be negative filters (with minus before)
         * @param {number} [useOld] (optional) ask to use the old report engine (pre 1.11) if set to 1.
         * @param {string} [atDate] (optional) generates the report at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z
         * @param {string} [reportNameOverride] (optional) Allow to override the reportName of the provided document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectReportReportPost(
            project: string,
            report: string,
            isSignedReport: string,
            includeSignatures: string,
            newTitle: string,
            copyFields: string,
            itemList?: string,
            urlIn?: string,
            resturl?: string,
            format?: string,
            filter?: string,
            useOld?: number,
            atDate?: string,
            reportNameOverride?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectReportReportPost.",
                );
            }
            // verify required parameter 'report' is not null or undefined
            if (report === null || report === undefined) {
                throw new RequiredError(
                    "report",
                    "Required parameter report was null or undefined when calling projectReportReportPost.",
                );
            }
            // verify required parameter 'isSignedReport' is not null or undefined
            if (isSignedReport === null || isSignedReport === undefined) {
                throw new RequiredError(
                    "isSignedReport",
                    "Required parameter isSignedReport was null or undefined when calling projectReportReportPost.",
                );
            }
            // verify required parameter 'includeSignatures' is not null or undefined
            if (includeSignatures === null || includeSignatures === undefined) {
                throw new RequiredError(
                    "includeSignatures",
                    "Required parameter includeSignatures was null or undefined when calling projectReportReportPost.",
                );
            }
            // verify required parameter 'newTitle' is not null or undefined
            if (newTitle === null || newTitle === undefined) {
                throw new RequiredError(
                    "newTitle",
                    "Required parameter newTitle was null or undefined when calling projectReportReportPost.",
                );
            }
            // verify required parameter 'copyFields' is not null or undefined
            if (copyFields === null || copyFields === undefined) {
                throw new RequiredError(
                    "copyFields",
                    "Required parameter copyFields was null or undefined when calling projectReportReportPost.",
                );
            }
            const localVarPath = `/{project}/report/{report}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"report"}}`, encodeURIComponent(String(report)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (itemList !== undefined) {
                localVarQueryParameter["itemList"] = itemList;
            }

            if (urlIn !== undefined) {
                localVarQueryParameter["url"] = urlIn;
            }

            if (resturl !== undefined) {
                localVarQueryParameter["resturl"] = resturl;
            }

            if (format !== undefined) {
                localVarQueryParameter["format"] = format;
            }

            if (isSignedReport !== undefined) {
                localVarQueryParameter["isSignedReport"] = isSignedReport;
            }

            if (includeSignatures !== undefined) {
                localVarQueryParameter["includeSignatures"] = includeSignatures;
            }

            if (newTitle !== undefined) {
                localVarQueryParameter["newTitle"] = newTitle;
            }

            if (copyFields !== undefined) {
                localVarQueryParameter["copyFields"] = copyFields;
            }

            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }

            if (useOld !== undefined) {
                localVarQueryParameter["useOld"] = useOld;
            }

            if (atDate !== undefined) {
                localVarQueryParameter["atDate"] = atDate;
            }

            if (reportNameOverride !== undefined) {
                localVarQueryParameter["reportNameOverride"] = reportNameOverride;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a project's schema
         * @param {string} project Project short label
         * @param {number} [simple] (optional) set to simple&#x3D;1 to have a simpler output (no fields, round shape)
         * @param {string} [excludeCategories] (optional) comma-separated list of categories to exclude, like DOC,SIGN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSchemaGet(project: string, simple?: number, excludeCategories?: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectSchemaGet.",
                );
            }
            const localVarPath = `/{project}/schema`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (simple !== undefined) {
                localVarQueryParameter["simple"] = simple;
            }

            if (excludeCategories !== undefined) {
                localVarQueryParameter["excludeCategories"] = excludeCategories;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Get all settings of a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSettingGet(project: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectSettingGet.",
                );
            }
            const localVarPath = `/{project}/setting`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Adds or changes a project setting. If the value is empty, the setting will be deleted.
         * @param {string} project Project short label
         * @param {string} key setting key
         * @param {string} value value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSettingPost(project: string, key: string, value: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectSettingPost.",
                );
            }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError(
                    "key",
                    "Required parameter key was null or undefined when calling projectSettingPost.",
                );
            }
            // verify required parameter 'value' is not null or undefined
            if (value === null || value === undefined) {
                throw new RequiredError(
                    "value",
                    "Required parameter value was null or undefined when calling projectSettingPost.",
                );
            }
            const localVarPath = `/{project}/setting`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (key !== undefined) {
                localVarQueryParameter["key"] = key;
            }

            if (value !== undefined) {
                localVarQueryParameter["value"] = value;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Signs an item. Item has the form SIGN-nnn
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} password signature password - the user who is signing is the one who is logged in
         * @param {string} [acceptComments] (optional) adds an acceptance comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSignItemPost(
            project: string,
            item: string,
            password: string,
            acceptComments?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectSignItemPost.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectSignItemPost.",
                );
            }
            // verify required parameter 'password' is not null or undefined
            if (password === null || password === undefined) {
                throw new RequiredError(
                    "password",
                    "Required parameter password was null or undefined when calling projectSignItemPost.",
                );
            }
            const localVarPath = `/{project}/sign/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (password !== undefined) {
                localVarQueryParameter["password"] = password;
            }

            if (acceptComments !== undefined) {
                localVarQueryParameter["acceptComments"] = acceptComments;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Edit the signature parts
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} rejectSign The reason why the user is rejecting the signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSignItemPut(project: string, item: string, rejectSign: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectSignItemPut.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectSignItemPut.",
                );
            }
            // verify required parameter 'rejectSign' is not null or undefined
            if (rejectSign === null || rejectSign === undefined) {
                throw new RequiredError(
                    "rejectSign",
                    "Required parameter rejectSign was null or undefined when calling projectSignItemPut.",
                );
            }
            const localVarPath = `/{project}/sign/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (rejectSign !== undefined) {
                localVarQueryParameter["rejectSign"] = rejectSign;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Asks for a new report. The job ID is returned as answer
         * @param {string} project Project short label
         * @param {string} [url] (optional) url to generate in the filter
         * @param {string} [resturl] (optional) REST url to generate in the filter
         * @param {string} [format] (optional) format -  html (default), pdf, docx, odt, xml, zipdocx or zippdf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSignedreportSIGNNPost(
            project: string,
            urlIn?: string,
            resturl?: string,
            format?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectSignedreportSIGNNPost.",
                );
            }
            const localVarPath = `/{project}/signedreport/SIGN-n`.replace(
                `{${"project"}}`,
                encodeURIComponent(String(project)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (urlIn !== undefined) {
                localVarQueryParameter["url"] = urlIn;
            }

            if (resturl !== undefined) {
                localVarQueryParameter["resturl"] = resturl;
            }

            if (format !== undefined) {
                localVarQueryParameter["format"] = format;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Get all tags of a project. Works on any project if user is admin
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTagGet(project: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectTagGet.",
                );
            }
            const localVarPath = `/{project}/tag`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Adds a tag to a project
         * @param {string} project Project short label
         * @param {string} label Tag label. Must be unique within a project
         * @param {number} auditId Id of the audit this tag is based on
         * @param {string} type Type of tag (default -  tag)
         * @param {string} comments Free optional comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTagPost(
            project: string,
            label: string,
            auditId: number,
            type: string,
            comments: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectTagPost.",
                );
            }
            // verify required parameter 'label' is not null or undefined
            if (label === null || label === undefined) {
                throw new RequiredError(
                    "label",
                    "Required parameter label was null or undefined when calling projectTagPost.",
                );
            }
            // verify required parameter 'auditId' is not null or undefined
            if (auditId === null || auditId === undefined) {
                throw new RequiredError(
                    "auditId",
                    "Required parameter auditId was null or undefined when calling projectTagPost.",
                );
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError(
                    "type",
                    "Required parameter type was null or undefined when calling projectTagPost.",
                );
            }
            // verify required parameter 'comments' is not null or undefined
            if (comments === null || comments === undefined) {
                throw new RequiredError(
                    "comments",
                    "Required parameter comments was null or undefined when calling projectTagPost.",
                );
            }
            const localVarPath = `/{project}/tag`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (label !== undefined) {
                localVarQueryParameter["label"] = label;
            }

            if (auditId !== undefined) {
                localVarQueryParameter["auditId"] = auditId;
            }

            if (type !== undefined) {
                localVarQueryParameter["type"] = type;
            }

            if (comments !== undefined) {
                localVarQueryParameter["comments"] = comments;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
         * @summary Get all todos for the current user, for oneproject
         * @param {string} project Project short label
         * @param {string} [itemRef] (optional) set to an item to have all todos linked to an item, regardless of the user
         * @param {number} [includeDone] (optional) set to 1 to include done todos and todo&#x27;s created by the user
         * @param {number} [includeAllUsers] (optional) set to 1 to include all todos for all users
         * @param {number} [includeFuture] (optional) set to 1 to include future todos as well (defaults to 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTodoGet(
            project: string,
            itemRef?: string,
            includeDone?: number,
            includeAllUsers?: number,
            includeFuture?: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectTodoGet.",
                );
            }
            const localVarPath = `/{project}/todo`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (itemRef !== undefined) {
                localVarQueryParameter["itemRef"] = itemRef;
            }

            if (includeDone !== undefined) {
                localVarQueryParameter["includeDone"] = includeDone;
            }

            if (includeAllUsers !== undefined) {
                localVarQueryParameter["includeAllUsers"] = includeAllUsers;
            }

            if (includeFuture !== undefined) {
                localVarQueryParameter["includeFuture"] = includeFuture;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
         * @summary Creates a todo on an item (note that you only need read access for this POST method) for you or others
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} text The todo reason
         * @param {number} [fieldId] (optional) If set, specifies that the todo is related to that field (review, ...)
         * @param {string} [logins] (optional) If set, a list of user logins or groups to which these todo apply
         * @param {string} [todoType] (optional) The todo type -  &#x27;user&#x27; by default
         * @param {string} [atDate] (optional) a date in the future for reminders
         * @param {number} [auto] (optional) set to 1 to create an auto-notification (0 by default)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTodoItemPost(
            project: string,
            item: string,
            text: string,
            fieldId?: number,
            logins?: string,
            todoType?: string,
            atDate?: string,
            auto?: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectTodoItemPost.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectTodoItemPost.",
                );
            }
            // verify required parameter 'text' is not null or undefined
            if (text === null || text === undefined) {
                throw new RequiredError(
                    "text",
                    "Required parameter text was null or undefined when calling projectTodoItemPost.",
                );
            }
            const localVarPath = `/{project}/todo/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (fieldId !== undefined) {
                localVarQueryParameter["fieldId"] = fieldId;
            }

            if (logins !== undefined) {
                localVarQueryParameter["logins"] = logins;
            }

            if (text !== undefined) {
                localVarQueryParameter["text"] = text;
            }

            if (todoType !== undefined) {
                localVarQueryParameter["todoType"] = todoType;
            }

            if (atDate !== undefined) {
                localVarQueryParameter["atDate"] = atDate;
            }

            if (auto !== undefined) {
                localVarQueryParameter["auto"] = auto;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.2
         * @summary Removes (mark as done) a todo.
         * @param {string} project Project short label
         * @param {string} todoid todoid
         * @param {string} hardDelete Set to yes to actually remove the record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTodoTodoidDelete(project: string, todoid: string, hardDelete: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectTodoTodoidDelete.",
                );
            }
            // verify required parameter 'todoid' is not null or undefined
            if (todoid === null || todoid === undefined) {
                throw new RequiredError(
                    "todoid",
                    "Required parameter todoid was null or undefined when calling projectTodoTodoidDelete.",
                );
            }
            // verify required parameter 'hardDelete' is not null or undefined
            if (hardDelete === null || hardDelete === undefined) {
                throw new RequiredError(
                    "hardDelete",
                    "Required parameter hardDelete was null or undefined when calling projectTodoTodoidDelete.",
                );
            }
            const localVarPath = `/{project}/todo/{todoid}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"todoid"}}`, encodeURIComponent(String(todoid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (hardDelete !== undefined) {
                localVarQueryParameter["hardDelete"] = hardDelete;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Touches (set to same date) an item or folder
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} reason The reason why the user is doing this
         * @param {number} [nbLayers] (optional) Number of layers -- 1 by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTouchItemPut(
            project: string,
            item: string,
            reason: string,
            nbLayers?: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectTouchItemPut.",
                );
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError(
                    "item",
                    "Required parameter item was null or undefined when calling projectTouchItemPut.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectTouchItemPut.",
                );
            }
            const localVarPath = `/{project}/touch/{item}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"item"}}`, encodeURIComponent(String(item)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            if (nbLayers !== undefined) {
                localVarQueryParameter["nbLayers"] = nbLayers;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get full tree
         * @param {string} project Project short label
         * @param {string} [fancy] (optional) returns a fancy tree
         * @param {string} [filter] (optional) applies a filter
         * @param {string} [atDate] (optional) generates the tree at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTreeGet(
            project: string,
            fancy?: string,
            filter?: string,
            atDate?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectTreeGet.",
                );
            }
            const localVarPath = `/{project}/tree`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (fancy !== undefined) {
                localVarQueryParameter["fancy"] = fancy;
            }

            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }

            if (atDate !== undefined) {
                localVarQueryParameter["atDate"] = atDate;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Unhides a project.
         * @param {string} project Project short label
         * @param {string} newShort The new project short name to use
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectUnhidePut(project: string, newShort: string, reason: string, options: any = {}): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectUnhidePut.",
                );
            }
            // verify required parameter 'newShort' is not null or undefined
            if (newShort === null || newShort === undefined) {
                throw new RequiredError(
                    "newShort",
                    "Required parameter newShort was null or undefined when calling projectUnhidePut.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectUnhidePut.",
                );
            }
            const localVarPath = `/{project}/unhide`.replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (newShort !== undefined) {
                localVarQueryParameter["newShort"] = newShort;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Converts a word document to an HTML, with images pointing to uploaded files on the server
         * @param {string} project Project short label
         * @param {string} reason The reason why the user is doing this
         * @param {number} [fileNo] If specified, means that the conversion is from an already uploaded file. Otherwise the file must be uploaded as body of this call
         * @param {string} [targetDocumentFolder] target document folder (in this case creates a document)
         * @param {number} [useAsField] set to 1 to have this docx used as a field. In this case the return value is the html equivalent, with some meta
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectWordconvertPost(
            project: string,
            reason: string,
            fileNo?: number,
            targetDocumentFolder?: string,
            useAsField?: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling projectWordconvertPost.",
                );
            }
            // verify required parameter 'reason' is not null or undefined
            if (reason === null || reason === undefined) {
                throw new RequiredError(
                    "reason",
                    "Required parameter reason was null or undefined when calling projectWordconvertPost.",
                );
            }
            const localVarPath = `/{project}/wordconvert`.replace(
                `{${"project"}}`,
                encodeURIComponent(String(project)),
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (fileNo !== undefined) {
                localVarQueryParameter["fileNo"] = fileNo;
            }

            if (targetDocumentFolder !== undefined) {
                localVarQueryParameter["targetDocumentFolder"] = targetDocumentFolder;
            }

            if (useAsField !== undefined) {
                localVarQueryParameter["useAsField"] = useAsField;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Get list of all projects, all settings and current user, all todos and JIRA meta create object
         * @param {number} [adminUI] (optional) set to adminUI&#x3D;1 to have all projects even the ones you are not assigned to, as an admin
         * @param {string} [output] (optional) comma-delimited list of requested output fields. Returns all fields if parameter is not present
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootGet(adminUI?: number, output?: string, options: any = {}): FetchArgs {
            const localVarPath = `/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (adminUI !== undefined) {
                localVarQueryParameter["adminUI"] = adminUI;
            }

            if (output !== undefined) {
                localVarQueryParameter["output"] = output;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Creates a new project. Either the full project is sent as XML payload, or the label and shortLabel are given. If uploading data for a whole project, label and shortLabel are optional but overwrite the XML content if present. Branching can be done with an audit report as payload, and branch* must be defined in that case
         * @param {string} label Project label
         * @param {string} shortLabel Project short label
         * @param {string} [overwrite] Must be set to yes if you&#x27;re overwriting an existing project
         * @param {string} [importUsers] Must be set to yes if you want to import users. false by default
         * @param {string} [branchLabel] Must be set to branch (optional)
         * @param {string} [branchTag] Must be set to branch, and match a tag in the audit export (optional)
         * @param {string} [branchComment] Comment for the branch (optional)
         * @param {string} [branchBaseProjectLabel] Label of the base Project (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootPost(
            label: string,
            shortLabel: string,
            overwrite?: string,
            importUsers?: string,
            branchLabel?: string,
            branchTag?: string,
            branchComment?: string,
            branchBaseProjectLabel?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'label' is not null or undefined
            if (label === null || label === undefined) {
                throw new RequiredError(
                    "label",
                    "Required parameter label was null or undefined when calling rootPost.",
                );
            }
            // verify required parameter 'shortLabel' is not null or undefined
            if (shortLabel === null || shortLabel === undefined) {
                throw new RequiredError(
                    "shortLabel",
                    "Required parameter shortLabel was null or undefined when calling rootPost.",
                );
            }
            const localVarPath = `/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (label !== undefined) {
                localVarQueryParameter["label"] = label;
            }

            if (shortLabel !== undefined) {
                localVarQueryParameter["shortLabel"] = shortLabel;
            }

            if (overwrite !== undefined) {
                localVarQueryParameter["overwrite"] = overwrite;
            }

            if (importUsers !== undefined) {
                localVarQueryParameter["importUsers"] = importUsers;
            }

            if (branchLabel !== undefined) {
                localVarQueryParameter["branchLabel"] = branchLabel;
            }

            if (branchTag !== undefined) {
                localVarQueryParameter["branchTag"] = branchTag;
            }

            if (branchComment !== undefined) {
                localVarQueryParameter["branchComment"] = branchComment;
            }

            if (branchBaseProjectLabel !== undefined) {
                localVarQueryParameter["branchBaseProjectLabel"] = branchBaseProjectLabel;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Retrieves the user list
         * @param {string} details (optional) -  if set to 1 returns all details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGet(details: string, options: any = {}): FetchArgs {
            // verify required parameter 'details' is not null or undefined
            if (details === null || details === undefined) {
                throw new RequiredError(
                    "details",
                    "Required parameter details was null or undefined when calling userGet.",
                );
            }
            const localVarPath = `/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (details !== undefined) {
                localVarQueryParameter["details"] = details;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Creates a new user. Arguments are either a set of arguments or json
         * @param {string} login User login name
         * @param {string} email User email
         * @param {string} password User password in clear
         * @param {string} json A json struct with login, email, password, first, last, signatureImage(int), signaturePassword, admin(int)
         * @param {string} [first] User first name (optional)
         * @param {string} [last] User last name (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPost(
            login: string,
            email: string,
            password: string,
            json: string,
            first?: string,
            last?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError(
                    "login",
                    "Required parameter login was null or undefined when calling userPost.",
                );
            }
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError(
                    "email",
                    "Required parameter email was null or undefined when calling userPost.",
                );
            }
            // verify required parameter 'password' is not null or undefined
            if (password === null || password === undefined) {
                throw new RequiredError(
                    "password",
                    "Required parameter password was null or undefined when calling userPost.",
                );
            }
            // verify required parameter 'json' is not null or undefined
            if (json === null || json === undefined) {
                throw new RequiredError("json", "Required parameter json was null or undefined when calling userPost.");
            }
            const localVarPath = `/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (login !== undefined) {
                localVarQueryParameter["login"] = login;
            }

            if (email !== undefined) {
                localVarQueryParameter["email"] = email;
            }

            if (password !== undefined) {
                localVarQueryParameter["password"] = password;
            }

            if (first !== undefined) {
                localVarQueryParameter["first"] = first;
            }

            if (last !== undefined) {
                localVarQueryParameter["last"] = last;
            }

            if (json !== undefined) {
                localVarQueryParameter["json"] = json;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Retrieves all actions of a user
         * @param {string} user user login name
         * @param {number} [startAt] (optional) Pagination -  starts the audit after N records
         * @param {number} [maxResults] (optional) Pagination -  Retrieve N results per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserAuditGet(user: string, startAt?: number, maxResults?: number, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserAuditGet.",
                );
            }
            const localVarPath = `/user/{user}/audit`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (startAt !== undefined) {
                localVarQueryParameter["startAt"] = startAt;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter["maxResults"] = maxResults;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Check a user's password
         * @param {string} user user login name
         * @param {string} password Asks for a check of the password1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserCheckGet(user: string, password: string, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserCheckGet.",
                );
            }
            // verify required parameter 'password' is not null or undefined
            if (password === null || password === undefined) {
                throw new RequiredError(
                    "password",
                    "Required parameter password was null or undefined when calling userUserCheckGet.",
                );
            }
            const localVarPath = `/user/{user}/check`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (password !== undefined) {
                localVarQueryParameter["password"] = password;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Check a user's password
         * @param {string} user user login name
         * @param {string} password Asks for a check of the password1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserCheckPost(user: string, password: string, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserCheckPost.",
                );
            }
            // verify required parameter 'password' is not null or undefined
            if (password === null || password === undefined) {
                throw new RequiredError(
                    "password",
                    "Required parameter password was null or undefined when calling userUserCheckPost.",
                );
            }
            const localVarPath = `/user/{user}/check`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (password !== undefined) {
                localVarQueryParameter["password"] = password;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.1
         * @summary Removes a user completely.
         * @param {string} user user login name
         * @param {string} confirm Needs to be yes for the method to be executed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserDelete(user: string, confirm: string, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserDelete.",
                );
            }
            // verify required parameter 'confirm' is not null or undefined
            if (confirm === null || confirm === undefined) {
                throw new RequiredError(
                    "confirm",
                    "Required parameter confirm was null or undefined when calling userUserDelete.",
                );
            }
            const localVarPath = `/user/{user}`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (confirm !== undefined) {
                localVarQueryParameter["confirm"] = confirm;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Retrieves all projects a user has access to
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserDetailsGet(user: string, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserDetailsGet.",
                );
            }
            const localVarPath = `/user/{user}/details`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Retrieves full details of a user
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserGet(user: string, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserGet.",
                );
            }
            const localVarPath = `/user/{user}`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "GET" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Login
         * @param {string} user user login name
         * @param {string} password password in clear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserLoginPost(user: string, password: string, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserLoginPost.",
                );
            }
            // verify required parameter 'password' is not null or undefined
            if (password === null || password === undefined) {
                throw new RequiredError(
                    "password",
                    "Required parameter password was null or undefined when calling userUserLoginPost.",
                );
            }
            const localVarPath = `/user/{user}/login`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (password !== undefined) {
                localVarQueryParameter["password"] = password;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Logout
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserLogoutPost(user: string, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserLogoutPost.",
                );
            }
            const localVarPath = `/user/{user}/logout`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Sets a new password for an account that has a password_reset token in place (the {user} in the URL doesn't matter)
         * @param {string} user user login name
         * @param {string} token password_reset token
         * @param {string} password New password to use from now on
         * @param {string} [signaturePassword] (optional) New password to use from now on for signatures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserPasswordResetPost(
            user: string,
            token: string,
            password: string,
            signaturePassword?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserPasswordResetPost.",
                );
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError(
                    "token",
                    "Required parameter token was null or undefined when calling userUserPasswordResetPost.",
                );
            }
            // verify required parameter 'password' is not null or undefined
            if (password === null || password === undefined) {
                throw new RequiredError(
                    "password",
                    "Required parameter password was null or undefined when calling userUserPasswordResetPost.",
                );
            }
            const localVarPath = `/user/{user}/password_reset`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (token !== undefined) {
                localVarQueryParameter["token"] = token;
            }

            if (password !== undefined) {
                localVarQueryParameter["password"] = password;
            }

            if (signaturePassword !== undefined) {
                localVarQueryParameter["signature_password"] = signaturePassword;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds a user to a project
         * @param {string} user user login name
         * @param {string} project Project short label
         * @param {number} permission 0 for no access, 1 for readonly, 2 for read/write (default), 3 for admin, 4 for visitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserProjectPost(user: string, project: string, permission: number, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserProjectPost.",
                );
            }
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling userUserProjectPost.",
                );
            }
            // verify required parameter 'permission' is not null or undefined
            if (permission === null || permission === undefined) {
                throw new RequiredError(
                    "permission",
                    "Required parameter permission was null or undefined when calling userUserProjectPost.",
                );
            }
            const localVarPath = `/user/{user}/{project}`
                .replace(`{${"user"}}`, encodeURIComponent(String(user)))
                .replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (permission !== undefined) {
                localVarQueryParameter["permission"] = permission;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Edits the user permissions in a project. If permission is 0, it means the user has no longer access (but we retain its records for audit purposes)
         * @param {string} user user login name
         * @param {string} project Project short label
         * @param {number} permission 0 for no access, 1 for readonly, 2 for read/write (default), 3 for admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserProjectPut(user: string, project: string, permission: number, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserProjectPut.",
                );
            }
            // verify required parameter 'project' is not null or undefined
            if (project === null || project === undefined) {
                throw new RequiredError(
                    "project",
                    "Required parameter project was null or undefined when calling userUserProjectPut.",
                );
            }
            // verify required parameter 'permission' is not null or undefined
            if (permission === null || permission === undefined) {
                throw new RequiredError(
                    "permission",
                    "Required parameter permission was null or undefined when calling userUserProjectPut.",
                );
            }
            const localVarPath = `/user/{user}/{project}`
                .replace(`{${"user"}}`, encodeURIComponent(String(user)))
                .replace(`{${"project"}}`, encodeURIComponent(String(project)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (permission !== undefined) {
                localVarQueryParameter["permission"] = permission;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Edits the user details. Arguments are all separated or a single json argument. Regular users can only change their signature and passwords.
         * @param {string} user user login name
         * @param {string} email User new email
         * @param {string} password User new password in clear
         * @param {string} json A json struct with login, email, password, first, last, signatureImage(int), signaturePassword, admin(int)
         * @param {string} [first] User first name (optional)
         * @param {string} [last] User last name (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserPut(
            user: string,
            email: string,
            password: string,
            json: string,
            first?: string,
            last?: string,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserPut.",
                );
            }
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError(
                    "email",
                    "Required parameter email was null or undefined when calling userUserPut.",
                );
            }
            // verify required parameter 'password' is not null or undefined
            if (password === null || password === undefined) {
                throw new RequiredError(
                    "password",
                    "Required parameter password was null or undefined when calling userUserPut.",
                );
            }
            // verify required parameter 'json' is not null or undefined
            if (json === null || json === undefined) {
                throw new RequiredError(
                    "json",
                    "Required parameter json was null or undefined when calling userUserPut.",
                );
            }
            const localVarPath = `/user/{user}`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (email !== undefined) {
                localVarQueryParameter["email"] = email;
            }

            if (password !== undefined) {
                localVarQueryParameter["password"] = password;
            }

            if (first !== undefined) {
                localVarQueryParameter["first"] = first;
            }

            if (last !== undefined) {
                localVarQueryParameter["last"] = last;
            }

            if (json !== undefined) {
                localVarQueryParameter["json"] = json;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Renames a user login
         * @param {string} user user login name
         * @param {string} newLogin The new login name. Cannot be one of the existing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserRenamePut(user: string, newLogin: string, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserRenamePut.",
                );
            }
            // verify required parameter 'newLogin' is not null or undefined
            if (newLogin === null || newLogin === undefined) {
                throw new RequiredError(
                    "newLogin",
                    "Required parameter newLogin was null or undefined when calling userUserRenamePut.",
                );
            }
            const localVarPath = `/user/{user}/rename`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (newLogin !== undefined) {
                localVarQueryParameter["newLogin"] = newLogin;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Adds or deletes a user setting.
         * @param {string} user user login name
         * @param {string} key Name of the setting
         * @param {string} value Value of the setting. If empty, deletes the setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserSettingPost(user: string, key: string, value: string, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserSettingPost.",
                );
            }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError(
                    "key",
                    "Required parameter key was null or undefined when calling userUserSettingPost.",
                );
            }
            // verify required parameter 'value' is not null or undefined
            if (value === null || value === undefined) {
                throw new RequiredError(
                    "value",
                    "Required parameter value was null or undefined when calling userUserSettingPost.",
                );
            }
            const localVarPath = `/user/{user}/setting`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (key !== undefined) {
                localVarQueryParameter["key"] = key;
            }

            if (value !== undefined) {
                localVarQueryParameter["value"] = value;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Sets the new status of the user. Can be normal,blocked or deleted
         * @param {string} user user login name
         * @param {string} status Can be normal,blocked or deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserStatusPut(user: string, status: string, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserStatusPut.",
                );
            }
            // verify required parameter 'status' is not null or undefined
            if (status === null || status === undefined) {
                throw new RequiredError(
                    "status",
                    "Required parameter status was null or undefined when calling userUserStatusPut.",
                );
            }
            const localVarPath = `/user/{user}/status`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (status !== undefined) {
                localVarQueryParameter["status"] = status;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Removes a user token
         * @param {string} user user login name
         * @param {number} tokenId The tokenId of the token to be removed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserTokenDelete(user: string, tokenId: number, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserTokenDelete.",
                );
            }
            // verify required parameter 'tokenId' is not null or undefined
            if (tokenId === null || tokenId === undefined) {
                throw new RequiredError(
                    "tokenId",
                    "Required parameter tokenId was null or undefined when calling userUserTokenDelete.",
                );
            }
            const localVarPath = `/user/{user}/token`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "DELETE" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (tokenId !== undefined) {
                localVarQueryParameter["tokenId"] = tokenId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Adds a token for a user
         * @param {string} user user login name
         * @param {string} purpose Purpose of the token. Not checked. Should contain either \&quot;password_reset\&quot; or \&quot;oauth\&quot;
         * @param {string} [value] Value of the token - by default generated by this call
         * @param {string} [reason] Free text explain where the token will be used (URL or others). Should be set for oauth, not needed for others
         * @param {number} [validity] Validity of the token in hours - if not set, doesn&#x27;t expire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserTokenPost(
            user: string,
            purpose: string,
            value?: string,
            reason?: string,
            validity?: number,
            options: any = {},
        ): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError(
                    "user",
                    "Required parameter user was null or undefined when calling userUserTokenPost.",
                );
            }
            // verify required parameter 'purpose' is not null or undefined
            if (purpose === null || purpose === undefined) {
                throw new RequiredError(
                    "purpose",
                    "Required parameter purpose was null or undefined when calling userUserTokenPost.",
                );
            }
            const localVarPath = `/user/{user}/token`.replace(`{${"user"}}`, encodeURIComponent(String(user)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: "POST" }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue =
                    typeof configuration.apiKey === "function"
                        ? configuration.apiKey("Authorization")
                        : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            // authentication BasicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] =
                    "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            if (value !== undefined) {
                localVarQueryParameter["value"] = value;
            }

            if (purpose !== undefined) {
                localVarQueryParameter["purpose"] = purpose;
            }

            if (reason !== undefined) {
                localVarQueryParameter["reason"] = reason;
            }

            if (validity !== undefined) {
                localVarQueryParameter["validity"] = validity;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Asks for the difference between A and B html exerpts, and produce the B html with annotations
         * @param {string} [arg] json object with the arguments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCompareHtmlPost(
            arg?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<HtmlCompareResult> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allCompareHtmlPost(arg, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Returns all info about a date
         * @param {string} [date] (optional) an input date formatted as iso8601. If not present, current date/time is used
         * @param {string} [dateformat] (optional) a date formatter. If not present, current date format is used
         * @param {string} [timeformat] (optional) a date-time formatter. If not present, current date/time format is used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allDateGet(
            date?: string,
            dateformat?: string,
            timeformat?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<GetDateAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allDateGet(
                date,
                dateformat,
                timeformat,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have the right key to download the file. Valid from version 2.1
         * @summary Retrieve one customer file. The fileno is a simple fileId. This request returns the actual file
         * @param {number} fileno file number
         * @param {string} key The key of the file
         * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFileFilenoGet(
            fileno: number,
            key: string,
            disposition?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allFileFilenoGet(
                fileno,
                key,
                disposition,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Retrieve list of all customer-wide files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFileGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetProjectFileListAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allFileGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Creates a new customer-wide file - the file should be uploaded as payload. Its mime type should be sent through the HTTP protocol.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFilePost(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AddFileAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allFilePost(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Retrieve license status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allLicenseGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LicenseStatus> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allLicenseGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Adds a log entry (server side).
         * @param {string} message Message to log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allLogPost(message: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allLogPost(message, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.4
         * @summary Update matrix instance log level.
         * @param {LogLevel} [body] Payload containing the log level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allLoglevelPut(body?: LogLevel, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allLoglevelPut(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.5
         * @summary Add metrics entry.
         * @param {Metric} [body] Payload containing the metric data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allMetricsPut(body?: Metric, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allMetricsPut(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Monitoring object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allMonitorGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetMonitorAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allMonitorGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.2
         * @summary The OpenAPI 3.0 definition of our REST API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allOpenapiGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allOpenapiGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Lists all reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allReportsGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetReportsAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allReportsGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Sends an email. Non-optional parameters are sent as a POST JSON payload.
         * @param {SendmailParam} [body] Necessary information to send a mail
         * @param {number} [system] (optional) if set to 1 makes it a system email (not sent by the actual user)
         * @param {number} [noreply] (optional) if set to 1 makes it a no-reply email (not sent by the actual user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSendmailPost(
            body?: SendmailParam,
            system?: number,
            noreply?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allSendmailPost(
                body,
                system,
                noreply,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Creates a service desk issue. The parameters are sent as a POST JSON payload.
         * @param {ServiceDeskParam} [body] Necessary information to send a mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServicedeskPost(
            body?: ServiceDeskParam,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allServicedeskPost(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all settings of a customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSettingGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetSettingAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allSettingGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds or changes a customer setting. If the value is empty, the setting will be deleted.
         * @param {string} key setting key
         * @param {string} value value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSettingPost(
            key: string,
            value: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allSettingPost(key, value, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get instance status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allStatusGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ServerStatus> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allStatusGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Returns all accepted time zones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTimezoneGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allTimezoneGet(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
         * @summary Get all todos for the current user, for all projects
         * @param {number} [includeDone] (optional) set to 1 to include done todos and todo&#x27;s created by the user
         * @param {number} [includeFuture] (optional) set to 1 to include future todos as well (defaults to 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTodoGet(
            includeDone?: number,
            includeFuture?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<GetTodosAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allTodoGet(
                includeDone,
                includeFuture,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary WebHook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allWebhookPost(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).allWebhookPost(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.2
         * @summary Retrieves the group list
         * @param {number} [details] (optional) -  if set to 1 returns all details -- in this case user needs to be ADMIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGet(details?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetGroupListAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).groupGet(details, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Removes a group
         * @param {string} groupId group Id
         * @param {string} confirm Needs to be yes for the method to be executed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdDelete(
            groupId: string,
            confirm: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).groupGroupIdDelete(
                groupId,
                confirm,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.2
         * @summary Retrieves details of a group
         * @param {string} groupId group Id
         * @param {number} [details] (optional) -  if set to 1 returns all details -- in this case user needs to be ADMIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdGet(
            groupId: string,
            details?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<GroupType> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).groupGroupIdGet(
                groupId,
                details,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Adds a group to a project (or removes it)
         * @param {string} groupId group Id
         * @param {string} project Project short label
         * @param {number} [permission] Specify the (new) permission for that group in that project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdProjectProjectPost(
            groupId: string,
            project: string,
            permission?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).groupGroupIdProjectProjectPost(
                groupId,
                project,
                permission,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Renames a group
         * @param {string} groupId group Id
         * @param {string} newName The new group name. Cannot be one of the existing. Must start with &#x27;group.&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdRenamePut(
            groupId: string,
            newName: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).groupGroupIdRenamePut(
                groupId,
                newName,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.2
         * @summary Adds a user to a group
         * @param {string} groupId group Id
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdUserUserPut(
            groupId: string,
            user: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).groupGroupIdUserUserPut(
                groupId,
                user,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Sets all users of a group (replacing potential former content)
         * @param {string} groupId group Id
         * @param {string} users List of all users members of that group, commas-separated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdUserlistPut(
            groupId: string,
            users: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).groupGroupIdUserlistPut(
                groupId,
                users,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Removes a user from a group
         * @param {string} groupName group name
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupNameUserUserDelete(
            groupName: string,
            user: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).groupGroupNameUserUserDelete(
                groupName,
                user,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Creates a new group
         * @param {string} groupLabel The name of the group to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupPost(groupLabel: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).groupPost(groupLabel, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.3
         * @summary Merge branch into mainline. First project is the mainline, second is the branch. The payload must contain a json object with a list of actions to perform.
         * @param {string} mainproject mainproject
         * @param {string} branchproject branchproject
         * @param {string} reason The reason why the user is doing this
         * @param {MergeParam} [body] Actions to perform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainprojectMergeBranchprojectPost(
            mainproject: string,
            branchproject: string,
            reason: string,
            body?: MergeParam,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).mainprojectMergeBranchprojectPost(
                mainproject,
                branchproject,
                reason,
                body,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have QMS viewer access (or higher) to the project. Valid from version 2.2
         * @summary Retrieves all accesses in a project (list of groups and users who have access)
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectAccessGet(
            project: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<GetAccessAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectAccessGet(project, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Retrieves all changes in a project
         * @param {string} project Project short label
         * @param {number} [startAt] (optional) Pagination -  starts the audit after N records
         * @param {number} [maxResults] (optional) Pagination -  Retrieve N results per page
         * @param {string} [deleteOnly] (optional) if set to yes, only returns actions of type delete
         * @param {string} [tech] (optional) if set to yes, returns the underneath changes
         * @param {number} [auditIdMin] (optional) sets a minimum ID for audits, as returned by GET calendar
         * @param {number} [auditIdMax] (optional) sets a maximum ID for audits
         * @param {number} [noReport] (optional) set to 1 to avoid having reports
         * @param {number} [noImport] (optional) set to 1 to avoid having imports
         * @param {string} [include] (optional) set to a list of actions to include (delete,undelete,add,edit,...)
         * @param {number} [resolveRef] (optional) set to 1 to resolve item IDs into refs
         * @param {string} [itemRef] (optional) restrict the audit to only those mentionning this item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectAuditGet(
            project: string,
            startAt?: number,
            maxResults?: number,
            deleteOnly?: string,
            tech?: string,
            auditIdMin?: number,
            auditIdMax?: number,
            noReport?: number,
            noImport?: number,
            include?: string,
            resolveRef?: number,
            itemRef?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<TrimAuditList> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectAuditGet(
                project,
                startAt,
                maxResults,
                deleteOnly,
                tech,
                auditIdMin,
                auditIdMax,
                noReport,
                noImport,
                include,
                resolveRef,
                itemRef,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.3
         * @summary Launches a server-side branch or clone - needs the 'merge' module if actual branching
         * @param {string} project Project short label
         * @param {string} label Branch project label
         * @param {string} shortLabel Branch project short label
         * @param {number} keepPermissions 1 or 0. Defaults to 0 (with 0 the project doesn&#x27;t have any permission after branching)
         * @param {number} keepContent 1 or 0. Defaults to 1. 0 only works without branch and without history
         * @param {number} [branch] (optional) Set to 1 to branch (default), 0 to just copy/clone
         * @param {number} [history] (optional) Set to 1 to branch or copy with history, defaults to 0
         * @param {string} [tagToCreate] (optional) specify a tag (by default auto-generated)
         * @param {string} [branchInThePastTag] (optional) specify a tag to branch in the past (needs history&#x3D;1)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectBranchPost(
            project: string,
            label: string,
            shortLabel: string,
            keepPermissions: number,
            keepContent: number,
            branch?: number,
            history?: number,
            tagToCreate?: string,
            branchInThePastTag?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectBranchPost(
                project,
                label,
                shortLabel,
                keepPermissions,
                keepContent,
                branch,
                history,
                tagToCreate,
                branchInThePastTag,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all dates at which a project has been modified
         * @param {string} project Project short label
         * @param {string} [deleteOnly] (optional) if set to yes, only report actions of type delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCalendarGet(
            project: string,
            deleteOnly?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CalendarType>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCalendarGet(
                project,
                deleteOnly,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Removes (inactivate) a category. Will fail on REPORT and FOLDER categories
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategoryDelete(
            project: string,
            category: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCatCategoryDelete(
                project,
                category,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get details of a category
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {string} [filter] (optional) specify a filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategoryGet(
            project: string,
            category: string,
            filter?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<CategoryFull> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCatCategoryGet(
                project,
                category,
                filter,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Modifies a categorie's labels, and fix the project's settings to reflect that change, OR modifies a category's order.
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {number} order The new order (for reordering)
         * @param {string} shortLabel The new short label for that category (for renaming)
         * @param {string} label The new long label for that category (for renaming)
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategoryPut(
            project: string,
            category: string,
            order: number,
            shortLabel: string,
            label: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCatCategoryPut(
                project,
                category,
                order,
                shortLabel,
                label,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all settings of a category
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategorySettingGet(
            project: string,
            category: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<GetSettingAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCatCategorySettingGet(
                project,
                category,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds or changes a category setting. If the value is empty, the setting will be deleted
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {string} key setting key
         * @param {string} value value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategorySettingPost(
            project: string,
            category: string,
            key: string,
            value: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCatCategorySettingPost(
                project,
                category,
                key,
                value,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all categories of a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatGet(
            project: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<GetProjectStructAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCatGet(project, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds a fields in a category
         * @param {string} project Project short label
         * @param {string} label Field label
         * @param {string} category Category short label
         * @param {string} fieldType Type of field
         * @param {string} fieldParam Parameter for the field
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatPost(
            project: string,
            label: string,
            category: string,
            fieldType: string,
            fieldParam: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCatPost(
                project,
                label,
                category,
                fieldType,
                fieldParam,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Clones a project
         * @param {string} project Project short label
         * @param {string} label Project label
         * @param {string} shortLabel Project short label
         * @param {number} keepHistory 1 or 0. Defaults to 0
         * @param {number} keepContent 1 or 0. Defaults to 0 (only the REPORT part is kept, make sense only if keepHistory is 0)
         * @param {number} keepPermissions 1 or 0. Defaults to 0 (with 0 the project doesn&#x27;t have any permission after cloning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectClonePost(
            project: string,
            label: string,
            shortLabel: string,
            keepHistory: number,
            keepContent: number,
            keepPermissions: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectClonePost(
                project,
                label,
                shortLabel,
                keepHistory,
                keepContent,
                keepPermissions,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Asks for the difference between 2 signed documents, as a Word document. The job ID is returned as answer
         * @param {string} project Project short label
         * @param {string} signitem1 SIGN-xx for the first SIGN document to compare
         * @param {string} signitem2 SIGN-xx for the 2nd SIGN document to compare
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCompareSignitem1Signitem2Post(
            project: string,
            signitem1: string,
            signitem2: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCompareSignitem1Signitem2Post(
                project,
                signitem1,
                signitem2,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a project's schema
         * @param {string} [excludeCategories] (optional) comma-separated list of categories to exclude, like DOC,SIGN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectConfigcheckGet(
            excludeCategories?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectConfigcheckGet(
                excludeCategories,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.2
         * @summary Copy items from a folder to another one
         * @param {string} project Project short label
         * @param {string} itemOrFolder Item reference (XXX-nn) or folder (F-XXX-nn)
         * @param {string} targetFolder Reference of the target folder (F-categ-serial)
         * @param {string} reason The reason why the user is doing this
         * @param {string} [targetProject] (optional) project to copy into (by default, same project)
         * @param {number} [copyLabels] (optional) 0 or 1. Defaults to 0
         * @param {string} [map] (optional) mapN&#x3D;M -  map field N in source to field M in target
         * @param {string} [ignoreLabels] (optional) can contain a comma-delimited list of labels NOT to copy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCopyItemOrFolderPost(
            project: string,
            itemOrFolder: string,
            targetFolder: string,
            reason: string,
            targetProject?: string,
            copyLabels?: number,
            map?: string,
            ignoreLabels?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<CopyItemAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCopyItemOrFolderPost(
                project,
                itemOrFolder,
                targetFolder,
                reason,
                targetProject,
                copyLabels,
                map,
                ignoreLabels,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get cross project links
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCrossprojectlinkGet(
            project: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CrossProjectLink>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectCrossprojectlinkGet(
                project,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.1
         * @summary Removes completely a project (only used for unit testing). This is an actual DELETE in the database.
         * @param {string} project Project short label
         * @param {string} confirm Needs to be yes for the method to be executed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectDelete(
            project: string,
            confirm: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectDelete(
                project,
                confirm,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Converts an excel file (xls, xlsx) into a XML version that we send straight back as an XML payload.
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectExcelxmlPost(project: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectExcelxmlPost(project, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Executes UC or TC into XTC items
         * @param {string} project Project short label
         * @param {ExecuteParam} [body] There must be a JSON as a payload. It includes all parameters AND the reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectExecutePost(
            project: string,
            body?: ExecuteParam,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<FolderAnswer> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectExecutePost(
                project,
                body,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Asks for an export of some items. The job ID is returned as answer
         * @param {string} project Project short label
         * @param {string} itemList Mandatory list of items to export.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectExportGet(
            project: string,
            itemList: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<ExportItemsAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectExportGet(
                project,
                itemList,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Removes (inactivate) a field.
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {number} field The field number (like field&#x3D;502)
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFieldCategoryDelete(
            project: string,
            category: string,
            field: number,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectFieldCategoryDelete(
                project,
                category,
                field,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get 1 field of an item. {item} has the form CATEG-number.
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} field Mandatory. Field number (faster) OR field label
         * @param {string} [format] Optional. Format for the return. Can be text, json, html, xml or xslt. Defaults to html
         * @param {number} [download] Optional. 1 to have in download, 0 as direct result. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFieldItemGet(
            project: string,
            item: string,
            field: string,
            format?: string,
            download?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectFieldItemGet(
                project,
                item,
                field,
                format,
                download,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Modifies a field's label and parameter OR modifies a field's order.
         * @param {string} project Project short label
         * @param {number} field The field number (like field&#x3D;502)
         * @param {string} label The new label (for renaming)
         * @param {string} fieldParam The new parameter (for renaming)
         * @param {number} order The new order (for reordering)
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFieldPut(
            project: string,
            field: number,
            label: string,
            fieldParam: string,
            order: number,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectFieldPut(
                project,
                field,
                label,
                fieldParam,
                order,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have the right key to download the file. Valid from version 2.1
         * @summary Retrieve one project file. The fileno is a simple fileId. This request returns the actual file
         * @param {string} project Project short label
         * @param {number} fileno file number
         * @param {string} key The key of the file
         * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFileFilenoGet(
            project: string,
            fileno: number,
            key: string,
            disposition?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<ArrayBuffer> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectFileFilenoGet(
                project,
                fileno,
                key,
                disposition,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.arrayBuffer();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Retrieve list of all files owned by a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFileGet(
            project: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<GetProjectFileListAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectFileGet(project, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Creates a new file - the file should be uploaded as payload (or through the url argument as an alternative). It's mime type should be sent through the HTTP protocol.
         * @param {string} project Project short label
         * @param {string} [url] Optional argument -  the file could also come from an external URL. In this case there will be an error if we can&#x27;t retrieve it on the server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFilePost(
            project: string,
            url?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<AddFileAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectFilePost(project, url, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.1
         * @summary Creates a new folder
         * @param {string} project Project short label
         * @param {string} parent Reference of the parent folder in the form F-CATEG-serial (example -  F-SPEC-17)
         * @param {string} label folder label
         * @param {string} reason The reason why the user is doing this
         * @param {string} [fxField] (optional) Add one of each of these to set folder&#x27;s fields. fx is followed by the field ID (a number)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFolderPost(
            project: string,
            parent: string,
            label: string,
            reason: string,
            fxField?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<AddItemAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectFolderPost(
                project,
                parent,
                label,
                reason,
                fxField,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get list of project info -  users, settings, categories
         * @param {string} project Project short label
         * @param {number} [adminUI] (optional) set to adminUI&#x3D;1 to have this project data even if you are not assigned to, as an admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectGet(
            project: string,
            adminUI?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<ProjectInfo> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectGet(project, adminUI, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Hides a project
         * @param {string} project Project short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHidePut(
            project: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectHidePut(
                project,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.2
         * @summary Launches a server-side hook
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} hook name of the hook
         * @param {string} [body] Payload for the hook, treated as a string.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHookItemPost(
            project: string,
            item: string,
            hook: string,
            body?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectHookItemPost(
                project,
                item,
                hook,
                body,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Cleans up an input html blob according to the current html cleanup rules. The blob is passed in the POST payload. The payload must be a json object with {\"htmlToClean\" - \"x\"}
         * @param {string} project Project short label
         * @param {GetHmlBlobInput} [body] Payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHtmlCleanupBlobPost(
            project: string,
            body?: GetHmlBlobInput,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GetHtmlBlob>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectHtmlCleanupBlobPost(
                project,
                body,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the list of items that would be changed if we applied html cleanup. You can pass a cleanup setting in the payload of the POST. If it's not there we take the customer (global) setting and force the cleanup to true
         * @param {string} project Project short label
         * @param {CleanupSetting} [body] Cleanup setting (optional)
         * @param {string} [categories] (optional) list of comma-delimited categories to go through, all by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHtmlCleanupTestPost(
            project: string,
            body?: CleanupSetting,
            categories?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<HtmlTestCleanup>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectHtmlCleanupTestPost(
                project,
                body,
                categories,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - ?. Valid from version 2.1
         * @summary Removes an import
         * @param {string} project Project short label
         * @param {string} id id
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectImportIdDelete(
            project: string,
            id: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectImportIdDelete(
                project,
                id,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Imports some items into a project
         * @param {string} project Project short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectImportPost(
            project: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectImportPost(
                project,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
         * @summary Get the history of a import in a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectImportinfoGet(
            project: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LabelHistory>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectImportinfoGet(project, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get details of a folder. {folder} has the form F-CATEG-number[-vN].
         * @param {string} project Project short label
         * @param {string} folder Folder reference (F-XXX-nn)
         * @param {number} [history] (optional) set history&#x3D;1 to retrieve list of all versions
         * @param {string} [filter] (optional) specify a filter
         * @param {string} [children] (optional) set to yes if you need the children as well (recursively).
         * @param {string} [atDate] (optional) retrieves the item at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z. Not compatible with the version query -vN
         * @param {number} [fields] (optional) set fields&#x3D;1 to retrieve list of all fields, even the empty ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemFolderGet(
            project: string,
            folder: string,
            history?: number,
            filter?: string,
            children?: string,
            atDate?: string,
            fields?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<TrimFolder> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectItemFolderGet(
                project,
                folder,
                history,
                filter,
                children,
                atDate,
                fields,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Removes (inactivate) an item (or a folder). Item has the form (F-)CATEG-number. Will fail on non-empty folders
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} confirm Needs to be yes for the method to be executed IF it is a non-empty folder
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemDelete(
            project: string,
            item: string,
            confirm: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectItemItemDelete(
                project,
                item,
                confirm,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get details of an item. {item} has the form CATEG-number[-vN].
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {number} [history] (optional) set history&#x3D;1 to retrieve list of all versions
         * @param {number} [fields] (optional) set fields&#x3D;1 to retrieve list of all fields, even the empty ones
         * @param {string} [filter] (optional) specify a filter
         * @param {string} [atDate] (optional) retrieves the item at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z. Not compatible with the version query -vN
         * @param {number} [withTree] (optional) retrieves the context tree if set to 1, in the field contextTree. Exclusive to filter and atDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemGet(
            project: string,
            item: string,
            history?: number,
            fields?: number,
            filter?: string,
            atDate?: string,
            withTree?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<TrimItem> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectItemItemGet(
                project,
                item,
                history,
                fields,
                filter,
                atDate,
                withTree,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Restores an item. Item has the form CATEG-number
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} reason The reason why the user is doing this
         * @param {number} [at] (optional) If set, specifies that the item should be restored as it was in that version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemPost(
            project: string,
            item: string,
            reason: string,
            at?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<UndeleteAnswer> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectItemItemPost(
                project,
                item,
                reason,
                at,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Modifies an item or a folder. Item has the form CATEG-number, folders -  F-CATEG-number
         * @param {ItemItemBody} body
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemPut(
            body: ItemItemBody,
            project: string,
            item: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<TrimItem> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectItemItemPut(
                body,
                project,
                item,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.1
         * @summary Adds an item in a folder
         * @param {ProjectItemBody} body
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemPost(
            body: ProjectItemBody,
            project: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<AddItemAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectItemPost(
                body,
                project,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - ?. Valid from version 2.1
         * @summary Removes (inactivate) a link between 2 items. Items are in the form CATEG-number
         * @param {string} project Project short label
         * @param {string} upitem Item reference (XXX-nn) for the UP item
         * @param {string} downitem Item reference (XXX-nn) for the DOWN item
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemlinkUpitemDownitemDelete(
            project: string,
            upitem: string,
            downitem: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectItemlinkUpitemDownitemDelete(
                project,
                upitem,
                downitem,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Adds a link between 2 items. Both items are in the form CATEG-number
         * @param {string} project Project short label
         * @param {string} upitem Item reference (XXX-nn) for the UP item
         * @param {string} downitem Item reference (XXX-nn) for the DOWN item
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemlinkUpitemDownitemPost(
            project: string,
            upitem: string,
            downitem: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectItemlinkUpitemDownitemPost(
                project,
                upitem,
                downitem,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get the list of items that are detailed in a DOC/SIGN item.
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {number} [detailed] Optional. When set to 1 adds a secondaryItems list in the answer. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemlistItemGet(
            project: string,
            item: string,
            detailed?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<GetItemListAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectItemlistItemGet(
                project,
                item,
                detailed,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Retrieve list of all jobs in a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobGet(project: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JobsWithUrl> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectJobGet(project, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.3
         * @summary Aborts a job.
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobDelete(
            project: string,
            job: number,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectJobJobDelete(
                project,
                job,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a job file. The job part is the jobID (a number) and the file is the fileID (a number)
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {number} fileno file number
         * @param {string} [mode] (optional) set to mode&#x3D;direct to get the output in the response output instead of as a download file. This assumes the file is HTML
         * @param {string} [format] (optional) set to format&#x3D;json to get a json output instead of XML
         * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobFilenoGet(
            project: string,
            job: number,
            fileno: number,
            mode?: string,
            format?: string,
            disposition?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<ArrayBuffer> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectJobJobFilenoGet(
                project,
                job,
                fileno,
                mode,
                format,
                disposition,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.arrayBuffer();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a job status, including generated files. The variable part is the jobID (a number)
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobGet(
            project: string,
            job: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<JobsStatusWithUrl> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectJobJobGet(
                project,
                job,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.2
         * @summary Sets the progress of a job
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {number} progress progress (0 to 100, 200 for error)
         * @param {string} [status] (optional( status text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobPost(
            project: string,
            job: number,
            progress: number,
            status?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectJobJobPost(
                project,
                job,
                progress,
                status,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the label history of a project -  list of all label changes for all items
         * @param {string} project Project short label
         * @param {string} [itemRef] (optional) ask for just one item (the return structure is still an array in that case)
         * @param {string} [from] (optional) date from
         * @param {string} [to] (optional) date to - works only if you only specified a from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectLabelhistoryGet(
            project: string,
            itemRef?: string,
            from?: string,
            to?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LabelHistory>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectLabelhistoryGet(
                project,
                itemRef,
                from,
                to,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the merge history of a project - needs the 'merge' module
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMergehistoryGet(
            project: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<MergeHistory>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectMergehistoryGet(
                project,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the merge information - needs the 'merge' module
         * @param {string} project Project short label
         * @param {string} [excludeCategories] (optional) comma-delimited list of categories to exclude
         * @param {string} [fromDate] (optional) date from which we consider the merges. ISO8601 format -- this parameter was introduced in v 2.3.4
         * @param {number} [push] (optional) set to 1 if you inquire about a push, not a merge -- this parameter was introduced in v 2.3.4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMergeinfoGet(
            project: string,
            excludeCategories?: string,
            fromDate?: string,
            push?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<MergeInfo>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectMergeinfoGet(
                project,
                excludeCategories,
                fromDate,
                push,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Imports some folders from a project to another as a module. Only available is you have the compose module licensed
         * @param {string} project Project short label
         * @param {string} mode Import mode -  can be include or copy
         * @param {string} sourceProject Source project
         * @param {string} sourceSelection A selection of folders and items to import
         * @param {string} reason The reason why the user is doing this
         * @param {string} [update] Update mode -  can be simple, update or rebase. If not defined, simple assumed
         * @param {string} [oldSourceProject] Old source project (if update&#x3D;rebase
         * @param {string} [lockLabel] An optional label that this operation will set on all items
         * @param {string} [itemParentMode] Default &#x27;orphan&#x27;. Specify &#x27;preserve&#x27; to include all parent folders to the root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectModuleimportPost(
            project: string,
            mode: string,
            sourceProject: string,
            sourceSelection: string,
            reason: string,
            update?: string,
            oldSourceProject?: string,
            lockLabel?: string,
            itemParentMode?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectModuleimportPost(
                project,
                mode,
                sourceProject,
                sourceSelection,
                reason,
                update,
                oldSourceProject,
                lockLabel,
                itemParentMode,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Move items into this folder
         * @param {string} project Project short label
         * @param {string} folder Folder reference (F-XXX-nn)
         * @param {string} reason The reason why the user is doing this
         * @param {string} [items] List of items to move in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMoveinFolderPost(
            project: string,
            folder: string,
            reason: string,
            items?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectMoveinFolderPost(
                project,
                folder,
                reason,
                items,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Use POST verb instead. Find items based on a search string in one project
         * @param {string} project Project short label
         * @param {string} id search id. Used by MatrixJira js to match queries with answers. Is returned in the output structure
         * @param {string} [search] search term
         * @param {string} [filter] (optional) applies a filter, can be negative
         * @param {string} [fieldsOut] (optional) comma-delimited list of fields to return -  101,102 - or * for all
         * @param {number} [labels] (optional) set to 1 to return labels in the output
         * @param {number} [treeOrder] (optional) set to 1 to return items in tree order (otherwise it&#x27;s project,category,serial)
         * @param {string} [links] (optional) set to up,down to return up and down items, or only up or only down
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedleGet(
            project: string,
            id: string,
            search?: string,
            filter?: string,
            fieldsOut?: string,
            labels?: number,
            treeOrder?: number,
            links?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<TrimNeedle> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectNeedleGet(
                project,
                id,
                search,
                filter,
                fieldsOut,
                labels,
                treeOrder,
                links,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
         * @summary Find items based on a search string in one project
         * @param {ProjectNeedleBody} body
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedlePost(
            body: ProjectNeedleBody,
            project: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<TrimNeedle> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectNeedlePost(
                body,
                project,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Find item ids based on a search string in one project
         * @param {string} project Project short label
         * @param {string} search search term
         * @param {string} [filter] (optional) applies a filter, can be negative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedleminimalGet(
            project: string,
            search: string,
            filter?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectNeedleminimalGet(
                project,
                search,
                filter,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
         * @summary Find item ids based on a search string in one project
         * @param {ProjectNeedleminimalBody} body
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedleminimalPost(
            body: ProjectNeedleminimalBody,
            project: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectNeedleminimalPost(
                body,
                project,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds a category to a project
         * @param {string} project Project short label
         * @param {string} label Category label
         * @param {string} shortLabel Category short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectPost(
            project: string,
            label: string,
            shortLabel: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectPost(
                project,
                label,
                shortLabel,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Publishes an item. Item has the form PUB-nnn
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} reason reason for the publication
         * @param {string} [trainingFor] (optional) list of items for which we need to add training. If list is not there, all trainings will be generated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectPublishItemPost(
            project: string,
            item: string,
            reason: string,
            trainingFor?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectPublishItemPost(
                project,
                item,
                reason,
                trainingFor,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have QMS viewer access (or higher) to the project. Valid from version 2.3
         * @summary Find a string in the QMS published items
         * @param {string} project Project short label
         * @param {string} [search] (optional) search term. Return an empty array on PUB &lt; 2.3.1 and et the list of all pub if not specified.
         * @param {string} [pubItem] (optional) PUB-x item if you want to search in another than the last one for that project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectQmsfindGet(
            project: string,
            search?: string,
            pubItem?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectQmsfindGet(
                project,
                search,
                pubItem,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) for the reports, read/write for the signed reports. Valid from version 2.1
         * @summary Asks for a new report. The job ID is returned as answer. {report} can be REPORT-n, DOC-n, SIGN-n or a report name.To follow the progress of the job, the GET /{project}/job/{jobid} can be called
         * @param {string} project Project short label
         * @param {string} report name of the report
         * @param {string} isSignedReport If set to true, means the report needs to generate a signed record
         * @param {string} includeSignatures List of comma separated users who need to sign
         * @param {string} newTitle New title for the SIGN- item that is generated (only valid for isSignedReport)
         * @param {string} copyFields List of from-to fields (123,456),(124,457) that we can use to generate the fields in the SIGN record (only valid for isSignedReport)
         * @param {string} [itemList] (optional) list of items to use in the report. By default all categories are used
         * @param {string} [url] (optional) url to generate in the filter
         * @param {string} [resturl] (optional) REST url to generate in the filter
         * @param {string} [format] (optional) format -  html (default), pdf, docx, odt, xml, zipdocx, zippdf or package (from 2.2), or mf (since 2.3)
         * @param {string} [filter] (optional) specify a comma-delimited filter list. Can be negative filters (with minus before)
         * @param {number} [useOld] (optional) ask to use the old report engine (pre 1.11) if set to 1.
         * @param {string} [atDate] (optional) generates the report at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z
         * @param {string} [reportNameOverride] (optional) Allow to override the reportName of the provided document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectReportReportPost(
            project: string,
            report: string,
            isSignedReport: string,
            includeSignatures: string,
            newTitle: string,
            copyFields: string,
            itemList?: string,
            url?: string,
            resturl?: string,
            format?: string,
            filter?: string,
            useOld?: number,
            atDate?: string,
            reportNameOverride?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<CreateReportJobAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectReportReportPost(
                project,
                report,
                isSignedReport,
                includeSignatures,
                newTitle,
                copyFields,
                itemList,
                url,
                resturl,
                format,
                filter,
                useOld,
                atDate,
                reportNameOverride,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a project's schema
         * @param {string} project Project short label
         * @param {number} [simple] (optional) set to simple&#x3D;1 to have a simpler output (no fields, round shape)
         * @param {string} [excludeCategories] (optional) comma-separated list of categories to exclude, like DOC,SIGN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSchemaGet(
            project: string,
            simple?: number,
            excludeCategories?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectSchemaGet(
                project,
                simple,
                excludeCategories,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Get all settings of a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSettingGet(
            project: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<GetProjectSettingAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectSettingGet(project, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Adds or changes a project setting. If the value is empty, the setting will be deleted.
         * @param {string} project Project short label
         * @param {string} key setting key
         * @param {string} value value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSettingPost(
            project: string,
            key: string,
            value: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectSettingPost(
                project,
                key,
                value,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Signs an item. Item has the form SIGN-nnn
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} password signature password - the user who is signing is the one who is logged in
         * @param {string} [acceptComments] (optional) adds an acceptance comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSignItemPost(
            project: string,
            item: string,
            password: string,
            acceptComments?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<SignItemAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectSignItemPost(
                project,
                item,
                password,
                acceptComments,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Edit the signature parts
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} rejectSign The reason why the user is rejecting the signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSignItemPut(
            project: string,
            item: string,
            rejectSign: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectSignItemPut(
                project,
                item,
                rejectSign,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Asks for a new report. The job ID is returned as answer
         * @param {string} project Project short label
         * @param {string} [url] (optional) url to generate in the filter
         * @param {string} [resturl] (optional) REST url to generate in the filter
         * @param {string} [format] (optional) format -  html (default), pdf, docx, odt, xml, zipdocx or zippdf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSignedreportSIGNNPost(
            project: string,
            url?: string,
            resturl?: string,
            format?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectSignedreportSIGNNPost(
                project,
                url,
                resturl,
                format,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Get all tags of a project. Works on any project if user is admin
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTagGet(project: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Tag>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectTagGet(project, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Adds a tag to a project
         * @param {string} project Project short label
         * @param {string} label Tag label. Must be unique within a project
         * @param {number} auditId Id of the audit this tag is based on
         * @param {string} type Type of tag (default -  tag)
         * @param {string} comments Free optional comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTagPost(
            project: string,
            label: string,
            auditId: number,
            type: string,
            comments: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectTagPost(
                project,
                label,
                auditId,
                type,
                comments,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
         * @summary Get all todos for the current user, for oneproject
         * @param {string} project Project short label
         * @param {string} [itemRef] (optional) set to an item to have all todos linked to an item, regardless of the user
         * @param {number} [includeDone] (optional) set to 1 to include done todos and todo&#x27;s created by the user
         * @param {number} [includeAllUsers] (optional) set to 1 to include all todos for all users
         * @param {number} [includeFuture] (optional) set to 1 to include future todos as well (defaults to 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTodoGet(
            project: string,
            itemRef?: string,
            includeDone?: number,
            includeAllUsers?: number,
            includeFuture?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<GetTodosAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectTodoGet(
                project,
                itemRef,
                includeDone,
                includeAllUsers,
                includeFuture,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
         * @summary Creates a todo on an item (note that you only need read access for this POST method) for you or others
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} text The todo reason
         * @param {number} [fieldId] (optional) If set, specifies that the todo is related to that field (review, ...)
         * @param {string} [logins] (optional) If set, a list of user logins or groups to which these todo apply
         * @param {string} [todoType] (optional) The todo type -  &#x27;user&#x27; by default
         * @param {string} [atDate] (optional) a date in the future for reminders
         * @param {number} [auto] (optional) set to 1 to create an auto-notification (0 by default)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTodoItemPost(
            project: string,
            item: string,
            text: string,
            fieldId?: number,
            logins?: string,
            todoType?: string,
            atDate?: string,
            auto?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectTodoItemPost(
                project,
                item,
                text,
                fieldId,
                logins,
                todoType,
                atDate,
                auto,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.2
         * @summary Removes (mark as done) a todo.
         * @param {string} project Project short label
         * @param {string} todoid todoid
         * @param {string} hardDelete Set to yes to actually remove the record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTodoTodoidDelete(
            project: string,
            todoid: string,
            hardDelete: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectTodoTodoidDelete(
                project,
                todoid,
                hardDelete,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Touches (set to same date) an item or folder
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} reason The reason why the user is doing this
         * @param {number} [nbLayers] (optional) Number of layers -- 1 by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTouchItemPut(
            project: string,
            item: string,
            reason: string,
            nbLayers?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectTouchItemPut(
                project,
                item,
                reason,
                nbLayers,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get full tree
         * @param {string} project Project short label
         * @param {string} [fancy] (optional) returns a fancy tree
         * @param {string} [filter] (optional) applies a filter
         * @param {string} [atDate] (optional) generates the tree at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTreeGet(
            project: string,
            fancy?: string,
            filter?: string,
            atDate?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<FancyFolder>> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectTreeGet(
                project,
                fancy,
                filter,
                atDate,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Unhides a project.
         * @param {string} project Project short label
         * @param {string} newShort The new project short name to use
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectUnhidePut(
            project: string,
            newShort: string,
            reason: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectUnhidePut(
                project,
                newShort,
                reason,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Converts a word document to an HTML, with images pointing to uploaded files on the server
         * @param {string} project Project short label
         * @param {string} reason The reason why the user is doing this
         * @param {number} [fileNo] If specified, means that the conversion is from an already uploaded file. Otherwise the file must be uploaded as body of this call
         * @param {string} [targetDocumentFolder] target document folder (in this case creates a document)
         * @param {number} [useAsField] set to 1 to have this docx used as a field. In this case the return value is the html equivalent, with some meta
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectWordconvertPost(
            project: string,
            reason: string,
            fileNo?: number,
            targetDocumentFolder?: string,
            useAsField?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).projectWordconvertPost(
                project,
                reason,
                fileNo,
                targetDocumentFolder,
                useAsField,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Get list of all projects, all settings and current user, all todos and JIRA meta create object
         * @param {number} [adminUI] (optional) set to adminUI&#x3D;1 to have all projects even the ones you are not assigned to, as an admin
         * @param {string} [output] (optional) comma-delimited list of requested output fields. Returns all fields if parameter is not present
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootGet(
            adminUI?: number,
            output?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<ListProjectAndSettings> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).rootGet(adminUI, output, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Creates a new project. Either the full project is sent as XML payload, or the label and shortLabel are given. If uploading data for a whole project, label and shortLabel are optional but overwrite the XML content if present. Branching can be done with an audit report as payload, and branch* must be defined in that case
         * @param {string} label Project label
         * @param {string} shortLabel Project short label
         * @param {string} [overwrite] Must be set to yes if you&#x27;re overwriting an existing project
         * @param {string} [importUsers] Must be set to yes if you want to import users. false by default
         * @param {string} [branchLabel] Must be set to branch (optional)
         * @param {string} [branchTag] Must be set to branch, and match a tag in the audit export (optional)
         * @param {string} [branchComment] Comment for the branch (optional)
         * @param {string} [branchBaseProjectLabel] Label of the base Project (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootPost(
            label: string,
            shortLabel: string,
            overwrite?: string,
            importUsers?: string,
            branchLabel?: string,
            branchTag?: string,
            branchComment?: string,
            branchBaseProjectLabel?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).rootPost(
                label,
                shortLabel,
                overwrite,
                importUsers,
                branchLabel,
                branchTag,
                branchComment,
                branchBaseProjectLabel,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Retrieves the user list
         * @param {string} details (optional) -  if set to 1 returns all details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGet(details: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetUserListAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userGet(details, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Creates a new user. Arguments are either a set of arguments or json
         * @param {string} login User login name
         * @param {string} email User email
         * @param {string} password User password in clear
         * @param {string} json A json struct with login, email, password, first, last, signatureImage(int), signaturePassword, admin(int)
         * @param {string} [first] User first name (optional)
         * @param {string} [last] User last name (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPost(
            login: string,
            email: string,
            password: string,
            json: string,
            first?: string,
            last?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userPost(
                login,
                email,
                password,
                json,
                first,
                last,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Retrieves all actions of a user
         * @param {string} user user login name
         * @param {number} [startAt] (optional) Pagination -  starts the audit after N records
         * @param {number} [maxResults] (optional) Pagination -  Retrieve N results per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserAuditGet(
            user: string,
            startAt?: number,
            maxResults?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<TrimAuditList> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserAuditGet(
                user,
                startAt,
                maxResults,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Check a user's password
         * @param {string} user user login name
         * @param {string} password Asks for a check of the password1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserCheckGet(
            user: string,
            password: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<CheckPasswordAck> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserCheckGet(
                user,
                password,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Check a user's password
         * @param {string} user user login name
         * @param {string} password Asks for a check of the password1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserCheckPost(
            user: string,
            password: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserCheckPost(
                user,
                password,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.1
         * @summary Removes a user completely.
         * @param {string} user user login name
         * @param {string} confirm Needs to be yes for the method to be executed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserDelete(
            user: string,
            confirm: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserDelete(user, confirm, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Retrieves all projects a user has access to
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserDetailsGet(user: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDetails> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserDetailsGet(user, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Retrieves full details of a user
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserGet(user: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserType> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserGet(user, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Login
         * @param {string} user user login name
         * @param {string} password password in clear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserLoginPost(
            user: string,
            password: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserLoginPost(
                user,
                password,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Logout
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserLogoutPost(user: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserLogoutPost(user, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Sets a new password for an account that has a password_reset token in place (the {user} in the URL doesn't matter)
         * @param {string} user user login name
         * @param {string} token password_reset token
         * @param {string} password New password to use from now on
         * @param {string} [signaturePassword] (optional) New password to use from now on for signatures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserPasswordResetPost(
            user: string,
            token: string,
            password: string,
            signaturePassword?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserPasswordResetPost(
                user,
                token,
                password,
                signaturePassword,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds a user to a project
         * @param {string} user user login name
         * @param {string} project Project short label
         * @param {number} permission 0 for no access, 1 for readonly, 2 for read/write (default), 3 for admin, 4 for visitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserProjectPost(
            user: string,
            project: string,
            permission: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserProjectPost(
                user,
                project,
                permission,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Edits the user permissions in a project. If permission is 0, it means the user has no longer access (but we retain its records for audit purposes)
         * @param {string} user user login name
         * @param {string} project Project short label
         * @param {number} permission 0 for no access, 1 for readonly, 2 for read/write (default), 3 for admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserProjectPut(
            user: string,
            project: string,
            permission: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserProjectPut(
                user,
                project,
                permission,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Edits the user details. Arguments are all separated or a single json argument. Regular users can only change their signature and passwords.
         * @param {string} user user login name
         * @param {string} email User new email
         * @param {string} password User new password in clear
         * @param {string} json A json struct with login, email, password, first, last, signatureImage(int), signaturePassword, admin(int)
         * @param {string} [first] User first name (optional)
         * @param {string} [last] User last name (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserPut(
            user: string,
            email: string,
            password: string,
            json: string,
            first?: string,
            last?: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserPut(
                user,
                email,
                password,
                json,
                first,
                last,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Renames a user login
         * @param {string} user user login name
         * @param {string} newLogin The new login name. Cannot be one of the existing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserRenamePut(
            user: string,
            newLogin: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserRenamePut(
                user,
                newLogin,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Adds or deletes a user setting.
         * @param {string} user user login name
         * @param {string} key Name of the setting
         * @param {string} value Value of the setting. If empty, deletes the setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserSettingPost(
            user: string,
            key: string,
            value: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserSettingPost(
                user,
                key,
                value,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Sets the new status of the user. Can be normal,blocked or deleted
         * @param {string} user user login name
         * @param {string} status Can be normal,blocked or deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserStatusPut(
            user: string,
            status: string,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserStatusPut(
                user,
                status,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Removes a user token
         * @param {string} user user login name
         * @param {number} tokenId The tokenId of the token to be removed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserTokenDelete(
            user: string,
            tokenId: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserTokenDelete(
                user,
                tokenId,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Adds a token for a user
         * @param {string} user user login name
         * @param {string} purpose Purpose of the token. Not checked. Should contain either \&quot;password_reset\&quot; or \&quot;oauth\&quot;
         * @param {string} [value] Value of the token - by default generated by this call
         * @param {string} [reason] Free text explain where the token will be used (URL or others). Should be set for oauth, not needed for others
         * @param {number} [validity] Validity of the token in hours - if not set, doesn&#x27;t expire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserTokenPost(
            user: string,
            purpose: string,
            value?: string,
            reason?: string,
            validity?: number,
            options?: any,
        ): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).userUserTokenPost(
                user,
                purpose,
                value,
                reason,
                validity,
                options,
            );
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    };
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Asks for the difference between A and B html exerpts, and produce the B html with annotations
         * @param {string} [arg] json object with the arguments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCompareHtmlPost(arg?: string, options?: any) {
            return DefaultApiFp(configuration).allCompareHtmlPost(arg, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Returns all info about a date
         * @param {string} [date] (optional) an input date formatted as iso8601. If not present, current date/time is used
         * @param {string} [dateformat] (optional) a date formatter. If not present, current date format is used
         * @param {string} [timeformat] (optional) a date-time formatter. If not present, current date/time format is used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allDateGet(date?: string, dateformat?: string, timeformat?: string, options?: any) {
            return DefaultApiFp(configuration).allDateGet(date, dateformat, timeformat, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have the right key to download the file. Valid from version 2.1
         * @summary Retrieve one customer file. The fileno is a simple fileId. This request returns the actual file
         * @param {number} fileno file number
         * @param {string} key The key of the file
         * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFileFilenoGet(fileno: number, key: string, disposition?: string, options?: any) {
            return DefaultApiFp(configuration).allFileFilenoGet(fileno, key, disposition, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Retrieve list of all customer-wide files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFileGet(options?: any) {
            return DefaultApiFp(configuration).allFileGet(options)(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Creates a new customer-wide file - the file should be uploaded as payload. Its mime type should be sent through the HTTP protocol.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allFilePost(options?: any) {
            return DefaultApiFp(configuration).allFilePost(options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Retrieve license status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allLicenseGet(options?: any) {
            return DefaultApiFp(configuration).allLicenseGet(options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Adds a log entry (server side).
         * @param {string} message Message to log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allLogPost(message: string, options?: any) {
            return DefaultApiFp(configuration).allLogPost(message, options)(fetch, basePath);
        },
        /**
         * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.4
         * @summary Update matrix instance log level.
         * @param {LogLevel} [body] Payload containing the log level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allLoglevelPut(body?: LogLevel, options?: any) {
            return DefaultApiFp(configuration).allLoglevelPut(body, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.5
         * @summary Add metrics entry.
         * @param {Metric} [body] Payload containing the metric data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allMetricsPut(body?: Metric, options?: any) {
            return DefaultApiFp(configuration).allMetricsPut(body, options)(fetch, basePath);
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Monitoring object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allMonitorGet(options?: any) {
            return DefaultApiFp(configuration).allMonitorGet(options)(fetch, basePath);
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.2
         * @summary The OpenAPI 3.0 definition of our REST API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allOpenapiGet(options?: any) {
            return DefaultApiFp(configuration).allOpenapiGet(options)(fetch, basePath);
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Lists all reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allReportsGet(options?: any) {
            return DefaultApiFp(configuration).allReportsGet(options)(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Sends an email. Non-optional parameters are sent as a POST JSON payload.
         * @param {SendmailParam} [body] Necessary information to send a mail
         * @param {number} [system] (optional) if set to 1 makes it a system email (not sent by the actual user)
         * @param {number} [noreply] (optional) if set to 1 makes it a no-reply email (not sent by the actual user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSendmailPost(body?: SendmailParam, system?: number, noreply?: number, options?: any) {
            return DefaultApiFp(configuration).allSendmailPost(body, system, noreply, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Creates a service desk issue. The parameters are sent as a POST JSON payload.
         * @param {ServiceDeskParam} [body] Necessary information to send a mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServicedeskPost(body?: ServiceDeskParam, options?: any) {
            return DefaultApiFp(configuration).allServicedeskPost(body, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all settings of a customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSettingGet(options?: any) {
            return DefaultApiFp(configuration).allSettingGet(options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds or changes a customer setting. If the value is empty, the setting will be deleted.
         * @param {string} key setting key
         * @param {string} value value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSettingPost(key: string, value: string, options?: any) {
            return DefaultApiFp(configuration).allSettingPost(key, value, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get instance status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allStatusGet(options?: any) {
            return DefaultApiFp(configuration).allStatusGet(options)(fetch, basePath);
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Returns all accepted time zones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTimezoneGet(options?: any) {
            return DefaultApiFp(configuration).allTimezoneGet(options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
         * @summary Get all todos for the current user, for all projects
         * @param {number} [includeDone] (optional) set to 1 to include done todos and todo&#x27;s created by the user
         * @param {number} [includeFuture] (optional) set to 1 to include future todos as well (defaults to 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTodoGet(includeDone?: number, includeFuture?: number, options?: any) {
            return DefaultApiFp(configuration).allTodoGet(includeDone, includeFuture, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary WebHook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allWebhookPost(options?: any) {
            return DefaultApiFp(configuration).allWebhookPost(options)(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.2
         * @summary Retrieves the group list
         * @param {number} [details] (optional) -  if set to 1 returns all details -- in this case user needs to be ADMIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGet(details?: number, options?: any) {
            return DefaultApiFp(configuration).groupGet(details, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Removes a group
         * @param {string} groupId group Id
         * @param {string} confirm Needs to be yes for the method to be executed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdDelete(groupId: string, confirm: string, options?: any) {
            return DefaultApiFp(configuration).groupGroupIdDelete(groupId, confirm, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.2
         * @summary Retrieves details of a group
         * @param {string} groupId group Id
         * @param {number} [details] (optional) -  if set to 1 returns all details -- in this case user needs to be ADMIN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdGet(groupId: string, details?: number, options?: any) {
            return DefaultApiFp(configuration).groupGroupIdGet(groupId, details, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Adds a group to a project (or removes it)
         * @param {string} groupId group Id
         * @param {string} project Project short label
         * @param {number} [permission] Specify the (new) permission for that group in that project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdProjectProjectPost(groupId: string, project: string, permission?: number, options?: any) {
            return DefaultApiFp(configuration).groupGroupIdProjectProjectPost(
                groupId,
                project,
                permission,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Renames a group
         * @param {string} groupId group Id
         * @param {string} newName The new group name. Cannot be one of the existing. Must start with &#x27;group.&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdRenamePut(groupId: string, newName: string, options?: any) {
            return DefaultApiFp(configuration).groupGroupIdRenamePut(groupId, newName, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.2
         * @summary Adds a user to a group
         * @param {string} groupId group Id
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdUserUserPut(groupId: string, user: string, options?: any) {
            return DefaultApiFp(configuration).groupGroupIdUserUserPut(groupId, user, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Sets all users of a group (replacing potential former content)
         * @param {string} groupId group Id
         * @param {string} users List of all users members of that group, commas-separated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupIdUserlistPut(groupId: string, users: string, options?: any) {
            return DefaultApiFp(configuration).groupGroupIdUserlistPut(groupId, users, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Removes a user from a group
         * @param {string} groupName group name
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupGroupNameUserUserDelete(groupName: string, user: string, options?: any) {
            return DefaultApiFp(configuration).groupGroupNameUserUserDelete(groupName, user, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Creates a new group
         * @param {string} groupLabel The name of the group to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupPost(groupLabel: string, options?: any) {
            return DefaultApiFp(configuration).groupPost(groupLabel, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.3
         * @summary Merge branch into mainline. First project is the mainline, second is the branch. The payload must contain a json object with a list of actions to perform.
         * @param {string} mainproject mainproject
         * @param {string} branchproject branchproject
         * @param {string} reason The reason why the user is doing this
         * @param {MergeParam} [body] Actions to perform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainprojectMergeBranchprojectPost(
            mainproject: string,
            branchproject: string,
            reason: string,
            body?: MergeParam,
            options?: any,
        ) {
            return DefaultApiFp(configuration).mainprojectMergeBranchprojectPost(
                mainproject,
                branchproject,
                reason,
                body,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have QMS viewer access (or higher) to the project. Valid from version 2.2
         * @summary Retrieves all accesses in a project (list of groups and users who have access)
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectAccessGet(project: string, options?: any) {
            return DefaultApiFp(configuration).projectAccessGet(project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Retrieves all changes in a project
         * @param {string} project Project short label
         * @param {number} [startAt] (optional) Pagination -  starts the audit after N records
         * @param {number} [maxResults] (optional) Pagination -  Retrieve N results per page
         * @param {string} [deleteOnly] (optional) if set to yes, only returns actions of type delete
         * @param {string} [tech] (optional) if set to yes, returns the underneath changes
         * @param {number} [auditIdMin] (optional) sets a minimum ID for audits, as returned by GET calendar
         * @param {number} [auditIdMax] (optional) sets a maximum ID for audits
         * @param {number} [noReport] (optional) set to 1 to avoid having reports
         * @param {number} [noImport] (optional) set to 1 to avoid having imports
         * @param {string} [include] (optional) set to a list of actions to include (delete,undelete,add,edit,...)
         * @param {number} [resolveRef] (optional) set to 1 to resolve item IDs into refs
         * @param {string} [itemRef] (optional) restrict the audit to only those mentionning this item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectAuditGet(
            project: string,
            startAt?: number,
            maxResults?: number,
            deleteOnly?: string,
            tech?: string,
            auditIdMin?: number,
            auditIdMax?: number,
            noReport?: number,
            noImport?: number,
            include?: string,
            resolveRef?: number,
            itemRef?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectAuditGet(
                project,
                startAt,
                maxResults,
                deleteOnly,
                tech,
                auditIdMin,
                auditIdMax,
                noReport,
                noImport,
                include,
                resolveRef,
                itemRef,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.3
         * @summary Launches a server-side branch or clone - needs the 'merge' module if actual branching
         * @param {string} project Project short label
         * @param {string} label Branch project label
         * @param {string} shortLabel Branch project short label
         * @param {number} keepPermissions 1 or 0. Defaults to 0 (with 0 the project doesn&#x27;t have any permission after branching)
         * @param {number} keepContent 1 or 0. Defaults to 1. 0 only works without branch and without history
         * @param {number} [branch] (optional) Set to 1 to branch (default), 0 to just copy/clone
         * @param {number} [history] (optional) Set to 1 to branch or copy with history, defaults to 0
         * @param {string} [tagToCreate] (optional) specify a tag (by default auto-generated)
         * @param {string} [branchInThePastTag] (optional) specify a tag to branch in the past (needs history&#x3D;1)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectBranchPost(
            project: string,
            label: string,
            shortLabel: string,
            keepPermissions: number,
            keepContent: number,
            branch?: number,
            history?: number,
            tagToCreate?: string,
            branchInThePastTag?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectBranchPost(
                project,
                label,
                shortLabel,
                keepPermissions,
                keepContent,
                branch,
                history,
                tagToCreate,
                branchInThePastTag,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all dates at which a project has been modified
         * @param {string} project Project short label
         * @param {string} [deleteOnly] (optional) if set to yes, only report actions of type delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCalendarGet(project: string, deleteOnly?: string, options?: any) {
            return DefaultApiFp(configuration).projectCalendarGet(project, deleteOnly, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Removes (inactivate) a category. Will fail on REPORT and FOLDER categories
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategoryDelete(project: string, category: string, reason: string, options?: any) {
            return DefaultApiFp(configuration).projectCatCategoryDelete(
                project,
                category,
                reason,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get details of a category
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {string} [filter] (optional) specify a filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategoryGet(project: string, category: string, filter?: string, options?: any) {
            return DefaultApiFp(configuration).projectCatCategoryGet(
                project,
                category,
                filter,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Modifies a categorie's labels, and fix the project's settings to reflect that change, OR modifies a category's order.
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {number} order The new order (for reordering)
         * @param {string} shortLabel The new short label for that category (for renaming)
         * @param {string} label The new long label for that category (for renaming)
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategoryPut(
            project: string,
            category: string,
            order: number,
            shortLabel: string,
            label: string,
            reason: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectCatCategoryPut(
                project,
                category,
                order,
                shortLabel,
                label,
                reason,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all settings of a category
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategorySettingGet(project: string, category: string, options?: any) {
            return DefaultApiFp(configuration).projectCatCategorySettingGet(
                project,
                category,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds or changes a category setting. If the value is empty, the setting will be deleted
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {string} key setting key
         * @param {string} value value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatCategorySettingPost(project: string, category: string, key: string, value: string, options?: any) {
            return DefaultApiFp(configuration).projectCatCategorySettingPost(
                project,
                category,
                key,
                value,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get all categories of a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatGet(project: string, options?: any) {
            return DefaultApiFp(configuration).projectCatGet(project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds a fields in a category
         * @param {string} project Project short label
         * @param {string} label Field label
         * @param {string} category Category short label
         * @param {string} fieldType Type of field
         * @param {string} fieldParam Parameter for the field
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCatPost(
            project: string,
            label: string,
            category: string,
            fieldType: string,
            fieldParam: string,
            reason: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectCatPost(
                project,
                label,
                category,
                fieldType,
                fieldParam,
                reason,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Clones a project
         * @param {string} project Project short label
         * @param {string} label Project label
         * @param {string} shortLabel Project short label
         * @param {number} keepHistory 1 or 0. Defaults to 0
         * @param {number} keepContent 1 or 0. Defaults to 0 (only the REPORT part is kept, make sense only if keepHistory is 0)
         * @param {number} keepPermissions 1 or 0. Defaults to 0 (with 0 the project doesn&#x27;t have any permission after cloning)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectClonePost(
            project: string,
            label: string,
            shortLabel: string,
            keepHistory: number,
            keepContent: number,
            keepPermissions: number,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectClonePost(
                project,
                label,
                shortLabel,
                keepHistory,
                keepContent,
                keepPermissions,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Asks for the difference between 2 signed documents, as a Word document. The job ID is returned as answer
         * @param {string} project Project short label
         * @param {string} signitem1 SIGN-xx for the first SIGN document to compare
         * @param {string} signitem2 SIGN-xx for the 2nd SIGN document to compare
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCompareSignitem1Signitem2Post(project: string, signitem1: string, signitem2: string, options?: any) {
            return DefaultApiFp(configuration).projectCompareSignitem1Signitem2Post(
                project,
                signitem1,
                signitem2,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a project's schema
         * @param {string} [excludeCategories] (optional) comma-separated list of categories to exclude, like DOC,SIGN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectConfigcheckGet(excludeCategories?: string, options?: any) {
            return DefaultApiFp(configuration).projectConfigcheckGet(excludeCategories, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.2
         * @summary Copy items from a folder to another one
         * @param {string} project Project short label
         * @param {string} itemOrFolder Item reference (XXX-nn) or folder (F-XXX-nn)
         * @param {string} targetFolder Reference of the target folder (F-categ-serial)
         * @param {string} reason The reason why the user is doing this
         * @param {string} [targetProject] (optional) project to copy into (by default, same project)
         * @param {number} [copyLabels] (optional) 0 or 1. Defaults to 0
         * @param {string} [map] (optional) mapN&#x3D;M -  map field N in source to field M in target
         * @param {string} [ignoreLabels] (optional) can contain a comma-delimited list of labels NOT to copy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCopyItemOrFolderPost(
            project: string,
            itemOrFolder: string,
            targetFolder: string,
            reason: string,
            targetProject?: string,
            copyLabels?: number,
            map?: string,
            ignoreLabels?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectCopyItemOrFolderPost(
                project,
                itemOrFolder,
                targetFolder,
                reason,
                targetProject,
                copyLabels,
                map,
                ignoreLabels,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get cross project links
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectCrossprojectlinkGet(project: string, options?: any) {
            return DefaultApiFp(configuration).projectCrossprojectlinkGet(project, options)(fetch, basePath);
        },
        /**
         * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.1
         * @summary Removes completely a project (only used for unit testing). This is an actual DELETE in the database.
         * @param {string} project Project short label
         * @param {string} confirm Needs to be yes for the method to be executed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectDelete(project: string, confirm: string, options?: any) {
            return DefaultApiFp(configuration).projectDelete(project, confirm, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Converts an excel file (xls, xlsx) into a XML version that we send straight back as an XML payload.
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectExcelxmlPost(project: string, options?: any) {
            return DefaultApiFp(configuration).projectExcelxmlPost(project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Executes UC or TC into XTC items
         * @param {string} project Project short label
         * @param {ExecuteParam} [body] There must be a JSON as a payload. It includes all parameters AND the reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectExecutePost(project: string, body?: ExecuteParam, options?: any) {
            return DefaultApiFp(configuration).projectExecutePost(project, body, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Asks for an export of some items. The job ID is returned as answer
         * @param {string} project Project short label
         * @param {string} itemList Mandatory list of items to export.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectExportGet(project: string, itemList: string, options?: any) {
            return DefaultApiFp(configuration).projectExportGet(project, itemList, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Removes (inactivate) a field.
         * @param {string} project Project short label
         * @param {string} category Category short label
         * @param {number} field The field number (like field&#x3D;502)
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFieldCategoryDelete(project: string, category: string, field: number, reason: string, options?: any) {
            return DefaultApiFp(configuration).projectFieldCategoryDelete(
                project,
                category,
                field,
                reason,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get 1 field of an item. {item} has the form CATEG-number.
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} field Mandatory. Field number (faster) OR field label
         * @param {string} [format] Optional. Format for the return. Can be text, json, html, xml or xslt. Defaults to html
         * @param {number} [download] Optional. 1 to have in download, 0 as direct result. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFieldItemGet(
            project: string,
            item: string,
            field: string,
            format?: string,
            download?: number,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectFieldItemGet(
                project,
                item,
                field,
                format,
                download,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Modifies a field's label and parameter OR modifies a field's order.
         * @param {string} project Project short label
         * @param {number} field The field number (like field&#x3D;502)
         * @param {string} label The new label (for renaming)
         * @param {string} fieldParam The new parameter (for renaming)
         * @param {number} order The new order (for reordering)
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFieldPut(
            project: string,
            field: number,
            label: string,
            fieldParam: string,
            order: number,
            reason: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectFieldPut(
                project,
                field,
                label,
                fieldParam,
                order,
                reason,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have the right key to download the file. Valid from version 2.1
         * @summary Retrieve one project file. The fileno is a simple fileId. This request returns the actual file
         * @param {string} project Project short label
         * @param {number} fileno file number
         * @param {string} key The key of the file
         * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFileFilenoGet(project: string, fileno: number, key: string, disposition?: string, options?: any) {
            return DefaultApiFp(configuration).projectFileFilenoGet(
                project,
                fileno,
                key,
                disposition,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Retrieve list of all files owned by a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFileGet(project: string, options?: any) {
            return DefaultApiFp(configuration).projectFileGet(project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Creates a new file - the file should be uploaded as payload (or through the url argument as an alternative). It's mime type should be sent through the HTTP protocol.
         * @param {string} project Project short label
         * @param {string} [url] Optional argument -  the file could also come from an external URL. In this case there will be an error if we can&#x27;t retrieve it on the server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFilePost(project: string, url?: string, options?: any) {
            return DefaultApiFp(configuration).projectFilePost(project, url, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.1
         * @summary Creates a new folder
         * @param {string} project Project short label
         * @param {string} parent Reference of the parent folder in the form F-CATEG-serial (example -  F-SPEC-17)
         * @param {string} label folder label
         * @param {string} reason The reason why the user is doing this
         * @param {string} [fxField] (optional) Add one of each of these to set folder&#x27;s fields. fx is followed by the field ID (a number)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFolderPost(
            project: string,
            parent: string,
            label: string,
            reason: string,
            fxField?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectFolderPost(
                project,
                parent,
                label,
                reason,
                fxField,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get list of project info -  users, settings, categories
         * @param {string} project Project short label
         * @param {number} [adminUI] (optional) set to adminUI&#x3D;1 to have this project data even if you are not assigned to, as an admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectGet(project: string, adminUI?: number, options?: any) {
            return DefaultApiFp(configuration).projectGet(project, adminUI, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Hides a project
         * @param {string} project Project short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHidePut(project: string, reason: string, options?: any) {
            return DefaultApiFp(configuration).projectHidePut(project, reason, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.2
         * @summary Launches a server-side hook
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} hook name of the hook
         * @param {string} [body] Payload for the hook, treated as a string.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHookItemPost(project: string, item: string, hook: string, body?: string, options?: any) {
            return DefaultApiFp(configuration).projectHookItemPost(project, item, hook, body, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Cleans up an input html blob according to the current html cleanup rules. The blob is passed in the POST payload. The payload must be a json object with {\"htmlToClean\" - \"x\"}
         * @param {string} project Project short label
         * @param {GetHmlBlobInput} [body] Payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHtmlCleanupBlobPost(project: string, body?: GetHmlBlobInput, options?: any) {
            return DefaultApiFp(configuration).projectHtmlCleanupBlobPost(project, body, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the list of items that would be changed if we applied html cleanup. You can pass a cleanup setting in the payload of the POST. If it's not there we take the customer (global) setting and force the cleanup to true
         * @param {string} project Project short label
         * @param {CleanupSetting} [body] Cleanup setting (optional)
         * @param {string} [categories] (optional) list of comma-delimited categories to go through, all by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectHtmlCleanupTestPost(project: string, body?: CleanupSetting, categories?: string, options?: any) {
            return DefaultApiFp(configuration).projectHtmlCleanupTestPost(
                project,
                body,
                categories,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - ?. Valid from version 2.1
         * @summary Removes an import
         * @param {string} project Project short label
         * @param {string} id id
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectImportIdDelete(project: string, id: string, reason: string, options?: any) {
            return DefaultApiFp(configuration).projectImportIdDelete(project, id, reason, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Imports some items into a project
         * @param {string} project Project short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectImportPost(project: string, reason: string, options?: any) {
            return DefaultApiFp(configuration).projectImportPost(project, reason, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
         * @summary Get the history of a import in a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectImportinfoGet(project: string, options?: any) {
            return DefaultApiFp(configuration).projectImportinfoGet(project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get details of a folder. {folder} has the form F-CATEG-number[-vN].
         * @param {string} project Project short label
         * @param {string} folder Folder reference (F-XXX-nn)
         * @param {number} [history] (optional) set history&#x3D;1 to retrieve list of all versions
         * @param {string} [filter] (optional) specify a filter
         * @param {string} [children] (optional) set to yes if you need the children as well (recursively).
         * @param {string} [atDate] (optional) retrieves the item at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z. Not compatible with the version query -vN
         * @param {number} [fields] (optional) set fields&#x3D;1 to retrieve list of all fields, even the empty ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemFolderGet(
            project: string,
            folder: string,
            history?: number,
            filter?: string,
            children?: string,
            atDate?: string,
            fields?: number,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectItemFolderGet(
                project,
                folder,
                history,
                filter,
                children,
                atDate,
                fields,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Removes (inactivate) an item (or a folder). Item has the form (F-)CATEG-number. Will fail on non-empty folders
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} confirm Needs to be yes for the method to be executed IF it is a non-empty folder
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemDelete(project: string, item: string, confirm: string, reason: string, options?: any) {
            return DefaultApiFp(configuration).projectItemItemDelete(
                project,
                item,
                confirm,
                reason,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get details of an item. {item} has the form CATEG-number[-vN].
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {number} [history] (optional) set history&#x3D;1 to retrieve list of all versions
         * @param {number} [fields] (optional) set fields&#x3D;1 to retrieve list of all fields, even the empty ones
         * @param {string} [filter] (optional) specify a filter
         * @param {string} [atDate] (optional) retrieves the item at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z. Not compatible with the version query -vN
         * @param {number} [withTree] (optional) retrieves the context tree if set to 1, in the field contextTree. Exclusive to filter and atDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemGet(
            project: string,
            item: string,
            history?: number,
            fields?: number,
            filter?: string,
            atDate?: string,
            withTree?: number,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectItemItemGet(
                project,
                item,
                history,
                fields,
                filter,
                atDate,
                withTree,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Restores an item. Item has the form CATEG-number
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} reason The reason why the user is doing this
         * @param {number} [at] (optional) If set, specifies that the item should be restored as it was in that version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemPost(project: string, item: string, reason: string, at?: number, options?: any) {
            return DefaultApiFp(configuration).projectItemItemPost(project, item, reason, at, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Modifies an item or a folder. Item has the form CATEG-number, folders -  F-CATEG-number
         * @param {ItemItemBody} body
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemItemPut(body: ItemItemBody, project: string, item: string, options?: any) {
            return DefaultApiFp(configuration).projectItemItemPut(body, project, item, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.1
         * @summary Adds an item in a folder
         * @param {ProjectItemBody} body
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemPost(body: ProjectItemBody, project: string, options?: any) {
            return DefaultApiFp(configuration).projectItemPost(body, project, options)(fetch, basePath);
        },
        /**
         * Permissions - ?. Valid from version 2.1
         * @summary Removes (inactivate) a link between 2 items. Items are in the form CATEG-number
         * @param {string} project Project short label
         * @param {string} upitem Item reference (XXX-nn) for the UP item
         * @param {string} downitem Item reference (XXX-nn) for the DOWN item
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemlinkUpitemDownitemDelete(
            project: string,
            upitem: string,
            downitem: string,
            reason: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectItemlinkUpitemDownitemDelete(
                project,
                upitem,
                downitem,
                reason,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Adds a link between 2 items. Both items are in the form CATEG-number
         * @param {string} project Project short label
         * @param {string} upitem Item reference (XXX-nn) for the UP item
         * @param {string} downitem Item reference (XXX-nn) for the DOWN item
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemlinkUpitemDownitemPost(
            project: string,
            upitem: string,
            downitem: string,
            reason: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectItemlinkUpitemDownitemPost(
                project,
                upitem,
                downitem,
                reason,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get the list of items that are detailed in a DOC/SIGN item.
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {number} [detailed] Optional. When set to 1 adds a secondaryItems list in the answer. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectItemlistItemGet(project: string, item: string, detailed?: number, options?: any) {
            return DefaultApiFp(configuration).projectItemlistItemGet(
                project,
                item,
                detailed,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Retrieve list of all jobs in a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobGet(project: string, options?: any) {
            return DefaultApiFp(configuration).projectJobGet(project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.3
         * @summary Aborts a job.
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobDelete(project: string, job: number, reason: string, options?: any) {
            return DefaultApiFp(configuration).projectJobJobDelete(project, job, reason, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a job file. The job part is the jobID (a number) and the file is the fileID (a number)
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {number} fileno file number
         * @param {string} [mode] (optional) set to mode&#x3D;direct to get the output in the response output instead of as a download file. This assumes the file is HTML
         * @param {string} [format] (optional) set to format&#x3D;json to get a json output instead of XML
         * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobFilenoGet(
            project: string,
            job: number,
            fileno: number,
            mode?: string,
            format?: string,
            disposition?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectJobJobFilenoGet(
                project,
                job,
                fileno,
                mode,
                format,
                disposition,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a job status, including generated files. The variable part is the jobID (a number)
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobGet(project: string, job: number, options?: any) {
            return DefaultApiFp(configuration).projectJobJobGet(project, job, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.2
         * @summary Sets the progress of a job
         * @param {string} project Project short label
         * @param {number} job job number
         * @param {number} progress progress (0 to 100, 200 for error)
         * @param {string} [status] (optional( status text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectJobJobPost(project: string, job: number, progress: number, status?: string, options?: any) {
            return DefaultApiFp(configuration).projectJobJobPost(
                project,
                job,
                progress,
                status,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the label history of a project -  list of all label changes for all items
         * @param {string} project Project short label
         * @param {string} [itemRef] (optional) ask for just one item (the return structure is still an array in that case)
         * @param {string} [from] (optional) date from
         * @param {string} [to] (optional) date to - works only if you only specified a from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectLabelhistoryGet(project: string, itemRef?: string, from?: string, to?: string, options?: any) {
            return DefaultApiFp(configuration).projectLabelhistoryGet(
                project,
                itemRef,
                from,
                to,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the merge history of a project - needs the 'merge' module
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMergehistoryGet(project: string, options?: any) {
            return DefaultApiFp(configuration).projectMergehistoryGet(project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
         * @summary Get the merge information - needs the 'merge' module
         * @param {string} project Project short label
         * @param {string} [excludeCategories] (optional) comma-delimited list of categories to exclude
         * @param {string} [fromDate] (optional) date from which we consider the merges. ISO8601 format -- this parameter was introduced in v 2.3.4
         * @param {number} [push] (optional) set to 1 if you inquire about a push, not a merge -- this parameter was introduced in v 2.3.4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMergeinfoGet(
            project: string,
            excludeCategories?: string,
            fromDate?: string,
            push?: number,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectMergeinfoGet(
                project,
                excludeCategories,
                fromDate,
                push,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Imports some folders from a project to another as a module. Only available is you have the compose module licensed
         * @param {string} project Project short label
         * @param {string} mode Import mode -  can be include or copy
         * @param {string} sourceProject Source project
         * @param {string} sourceSelection A selection of folders and items to import
         * @param {string} reason The reason why the user is doing this
         * @param {string} [update] Update mode -  can be simple, update or rebase. If not defined, simple assumed
         * @param {string} [oldSourceProject] Old source project (if update&#x3D;rebase
         * @param {string} [lockLabel] An optional label that this operation will set on all items
         * @param {string} [itemParentMode] Default &#x27;orphan&#x27;. Specify &#x27;preserve&#x27; to include all parent folders to the root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectModuleimportPost(
            project: string,
            mode: string,
            sourceProject: string,
            sourceSelection: string,
            reason: string,
            update?: string,
            oldSourceProject?: string,
            lockLabel?: string,
            itemParentMode?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectModuleimportPost(
                project,
                mode,
                sourceProject,
                sourceSelection,
                reason,
                update,
                oldSourceProject,
                lockLabel,
                itemParentMode,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Move items into this folder
         * @param {string} project Project short label
         * @param {string} folder Folder reference (F-XXX-nn)
         * @param {string} reason The reason why the user is doing this
         * @param {string} [items] List of items to move in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMoveinFolderPost(project: string, folder: string, reason: string, items?: string, options?: any) {
            return DefaultApiFp(configuration).projectMoveinFolderPost(
                project,
                folder,
                reason,
                items,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Use POST verb instead. Find items based on a search string in one project
         * @param {string} project Project short label
         * @param {string} id search id. Used by MatrixJira js to match queries with answers. Is returned in the output structure
         * @param {string} [search] search term
         * @param {string} [filter] (optional) applies a filter, can be negative
         * @param {string} [fieldsOut] (optional) comma-delimited list of fields to return -  101,102 - or * for all
         * @param {number} [labels] (optional) set to 1 to return labels in the output
         * @param {number} [treeOrder] (optional) set to 1 to return items in tree order (otherwise it&#x27;s project,category,serial)
         * @param {string} [links] (optional) set to up,down to return up and down items, or only up or only down
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedleGet(
            project: string,
            id: string,
            search?: string,
            filter?: string,
            fieldsOut?: string,
            labels?: number,
            treeOrder?: number,
            links?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectNeedleGet(
                project,
                id,
                search,
                filter,
                fieldsOut,
                labels,
                treeOrder,
                links,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
         * @summary Find items based on a search string in one project
         * @param {ProjectNeedleBody} body
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedlePost(body: ProjectNeedleBody, project: string, options?: any) {
            return DefaultApiFp(configuration).projectNeedlePost(body, project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Find item ids based on a search string in one project
         * @param {string} project Project short label
         * @param {string} search search term
         * @param {string} [filter] (optional) applies a filter, can be negative
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedleminimalGet(project: string, search: string, filter?: string, options?: any) {
            return DefaultApiFp(configuration).projectNeedleminimalGet(
                project,
                search,
                filter,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
         * @summary Find item ids based on a search string in one project
         * @param {ProjectNeedleminimalBody} body
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectNeedleminimalPost(body: ProjectNeedleminimalBody, project: string, options?: any) {
            return DefaultApiFp(configuration).projectNeedleminimalPost(body, project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds a category to a project
         * @param {string} project Project short label
         * @param {string} label Category label
         * @param {string} shortLabel Category short label
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectPost(project: string, label: string, shortLabel: string, reason: string, options?: any) {
            return DefaultApiFp(configuration).projectPost(
                project,
                label,
                shortLabel,
                reason,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Publishes an item. Item has the form PUB-nnn
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} reason reason for the publication
         * @param {string} [trainingFor] (optional) list of items for which we need to add training. If list is not there, all trainings will be generated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectPublishItemPost(project: string, item: string, reason: string, trainingFor?: string, options?: any) {
            return DefaultApiFp(configuration).projectPublishItemPost(
                project,
                item,
                reason,
                trainingFor,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have QMS viewer access (or higher) to the project. Valid from version 2.3
         * @summary Find a string in the QMS published items
         * @param {string} project Project short label
         * @param {string} [search] (optional) search term. Return an empty array on PUB &lt; 2.3.1 and et the list of all pub if not specified.
         * @param {string} [pubItem] (optional) PUB-x item if you want to search in another than the last one for that project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectQmsfindGet(project: string, search?: string, pubItem?: string, options?: any) {
            return DefaultApiFp(configuration).projectQmsfindGet(project, search, pubItem, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) for the reports, read/write for the signed reports. Valid from version 2.1
         * @summary Asks for a new report. The job ID is returned as answer. {report} can be REPORT-n, DOC-n, SIGN-n or a report name.To follow the progress of the job, the GET /{project}/job/{jobid} can be called
         * @param {string} project Project short label
         * @param {string} report name of the report
         * @param {string} isSignedReport If set to true, means the report needs to generate a signed record
         * @param {string} includeSignatures List of comma separated users who need to sign
         * @param {string} newTitle New title for the SIGN- item that is generated (only valid for isSignedReport)
         * @param {string} copyFields List of from-to fields (123,456),(124,457) that we can use to generate the fields in the SIGN record (only valid for isSignedReport)
         * @param {string} [itemList] (optional) list of items to use in the report. By default all categories are used
         * @param {string} [url] (optional) url to generate in the filter
         * @param {string} [resturl] (optional) REST url to generate in the filter
         * @param {string} [format] (optional) format -  html (default), pdf, docx, odt, xml, zipdocx, zippdf or package (from 2.2), or mf (since 2.3)
         * @param {string} [filter] (optional) specify a comma-delimited filter list. Can be negative filters (with minus before)
         * @param {number} [useOld] (optional) ask to use the old report engine (pre 1.11) if set to 1.
         * @param {string} [atDate] (optional) generates the report at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z
         * @param {string} [reportNameOverride] (optional) Allow to override the reportName of the provided document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectReportReportPost(
            project: string,
            report: string,
            isSignedReport: string,
            includeSignatures: string,
            newTitle: string,
            copyFields: string,
            itemList?: string,
            url?: string,
            resturl?: string,
            format?: string,
            filter?: string,
            useOld?: number,
            atDate?: string,
            reportNameOverride?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectReportReportPost(
                project,
                report,
                isSignedReport,
                includeSignatures,
                newTitle,
                copyFields,
                itemList,
                url,
                resturl,
                format,
                filter,
                useOld,
                atDate,
                reportNameOverride,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get a project's schema
         * @param {string} project Project short label
         * @param {number} [simple] (optional) set to simple&#x3D;1 to have a simpler output (no fields, round shape)
         * @param {string} [excludeCategories] (optional) comma-separated list of categories to exclude, like DOC,SIGN
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSchemaGet(project: string, simple?: number, excludeCategories?: string, options?: any) {
            return DefaultApiFp(configuration).projectSchemaGet(
                project,
                simple,
                excludeCategories,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Get all settings of a project
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSettingGet(project: string, options?: any) {
            return DefaultApiFp(configuration).projectSettingGet(project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Adds or changes a project setting. If the value is empty, the setting will be deleted.
         * @param {string} project Project short label
         * @param {string} key setting key
         * @param {string} value value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSettingPost(project: string, key: string, value: string, options?: any) {
            return DefaultApiFp(configuration).projectSettingPost(project, key, value, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Signs an item. Item has the form SIGN-nnn
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} password signature password - the user who is signing is the one who is logged in
         * @param {string} [acceptComments] (optional) adds an acceptance comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSignItemPost(project: string, item: string, password: string, acceptComments?: string, options?: any) {
            return DefaultApiFp(configuration).projectSignItemPost(
                project,
                item,
                password,
                acceptComments,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Edit the signature parts
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} rejectSign The reason why the user is rejecting the signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSignItemPut(project: string, item: string, rejectSign: string, options?: any) {
            return DefaultApiFp(configuration).projectSignItemPut(project, item, rejectSign, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Asks for a new report. The job ID is returned as answer
         * @param {string} project Project short label
         * @param {string} [url] (optional) url to generate in the filter
         * @param {string} [resturl] (optional) REST url to generate in the filter
         * @param {string} [format] (optional) format -  html (default), pdf, docx, odt, xml, zipdocx or zippdf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSignedreportSIGNNPost(project: string, url?: string, resturl?: string, format?: string, options?: any) {
            return DefaultApiFp(configuration).projectSignedreportSIGNNPost(
                project,
                url,
                resturl,
                format,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Get all tags of a project. Works on any project if user is admin
         * @param {string} project Project short label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTagGet(project: string, options?: any) {
            return DefaultApiFp(configuration).projectTagGet(project, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Adds a tag to a project
         * @param {string} project Project short label
         * @param {string} label Tag label. Must be unique within a project
         * @param {number} auditId Id of the audit this tag is based on
         * @param {string} type Type of tag (default -  tag)
         * @param {string} comments Free optional comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTagPost(project: string, label: string, auditId: number, type: string, comments: string, options?: any) {
            return DefaultApiFp(configuration).projectTagPost(
                project,
                label,
                auditId,
                type,
                comments,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
         * @summary Get all todos for the current user, for oneproject
         * @param {string} project Project short label
         * @param {string} [itemRef] (optional) set to an item to have all todos linked to an item, regardless of the user
         * @param {number} [includeDone] (optional) set to 1 to include done todos and todo&#x27;s created by the user
         * @param {number} [includeAllUsers] (optional) set to 1 to include all todos for all users
         * @param {number} [includeFuture] (optional) set to 1 to include future todos as well (defaults to 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTodoGet(
            project: string,
            itemRef?: string,
            includeDone?: number,
            includeAllUsers?: number,
            includeFuture?: number,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectTodoGet(
                project,
                itemRef,
                includeDone,
                includeAllUsers,
                includeFuture,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
         * @summary Creates a todo on an item (note that you only need read access for this POST method) for you or others
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} text The todo reason
         * @param {number} [fieldId] (optional) If set, specifies that the todo is related to that field (review, ...)
         * @param {string} [logins] (optional) If set, a list of user logins or groups to which these todo apply
         * @param {string} [todoType] (optional) The todo type -  &#x27;user&#x27; by default
         * @param {string} [atDate] (optional) a date in the future for reminders
         * @param {number} [auto] (optional) set to 1 to create an auto-notification (0 by default)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTodoItemPost(
            project: string,
            item: string,
            text: string,
            fieldId?: number,
            logins?: string,
            todoType?: string,
            atDate?: string,
            auto?: number,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectTodoItemPost(
                project,
                item,
                text,
                fieldId,
                logins,
                todoType,
                atDate,
                auto,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.2
         * @summary Removes (mark as done) a todo.
         * @param {string} project Project short label
         * @param {string} todoid todoid
         * @param {string} hardDelete Set to yes to actually remove the record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTodoTodoidDelete(project: string, todoid: string, hardDelete: string, options?: any) {
            return DefaultApiFp(configuration).projectTodoTodoidDelete(
                project,
                todoid,
                hardDelete,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Touches (set to same date) an item or folder
         * @param {string} project Project short label
         * @param {string} item Item reference (XXX-nn)
         * @param {string} reason The reason why the user is doing this
         * @param {number} [nbLayers] (optional) Number of layers -- 1 by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTouchItemPut(project: string, item: string, reason: string, nbLayers?: number, options?: any) {
            return DefaultApiFp(configuration).projectTouchItemPut(
                project,
                item,
                reason,
                nbLayers,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
         * @summary Get full tree
         * @param {string} project Project short label
         * @param {string} [fancy] (optional) returns a fancy tree
         * @param {string} [filter] (optional) applies a filter
         * @param {string} [atDate] (optional) generates the tree at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTreeGet(project: string, fancy?: string, filter?: string, atDate?: string, options?: any) {
            return DefaultApiFp(configuration).projectTreeGet(project, fancy, filter, atDate, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Unhides a project.
         * @param {string} project Project short label
         * @param {string} newShort The new project short name to use
         * @param {string} reason The reason why the user is doing this
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectUnhidePut(project: string, newShort: string, reason: string, options?: any) {
            return DefaultApiFp(configuration).projectUnhidePut(project, newShort, reason, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have read/write access to the project. Valid from version 2.1
         * @summary Converts a word document to an HTML, with images pointing to uploaded files on the server
         * @param {string} project Project short label
         * @param {string} reason The reason why the user is doing this
         * @param {number} [fileNo] If specified, means that the conversion is from an already uploaded file. Otherwise the file must be uploaded as body of this call
         * @param {string} [targetDocumentFolder] target document folder (in this case creates a document)
         * @param {number} [useAsField] set to 1 to have this docx used as a field. In this case the return value is the html equivalent, with some meta
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectWordconvertPost(
            project: string,
            reason: string,
            fileNo?: number,
            targetDocumentFolder?: string,
            useAsField?: number,
            options?: any,
        ) {
            return DefaultApiFp(configuration).projectWordconvertPost(
                project,
                reason,
                fileNo,
                targetDocumentFolder,
                useAsField,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Get list of all projects, all settings and current user, all todos and JIRA meta create object
         * @param {number} [adminUI] (optional) set to adminUI&#x3D;1 to have all projects even the ones you are not assigned to, as an admin
         * @param {string} [output] (optional) comma-delimited list of requested output fields. Returns all fields if parameter is not present
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootGet(adminUI?: number, output?: string, options?: any) {
            return DefaultApiFp(configuration).rootGet(adminUI, output, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Creates a new project. Either the full project is sent as XML payload, or the label and shortLabel are given. If uploading data for a whole project, label and shortLabel are optional but overwrite the XML content if present. Branching can be done with an audit report as payload, and branch* must be defined in that case
         * @param {string} label Project label
         * @param {string} shortLabel Project short label
         * @param {string} [overwrite] Must be set to yes if you&#x27;re overwriting an existing project
         * @param {string} [importUsers] Must be set to yes if you want to import users. false by default
         * @param {string} [branchLabel] Must be set to branch (optional)
         * @param {string} [branchTag] Must be set to branch, and match a tag in the audit export (optional)
         * @param {string} [branchComment] Comment for the branch (optional)
         * @param {string} [branchBaseProjectLabel] Label of the base Project (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootPost(
            label: string,
            shortLabel: string,
            overwrite?: string,
            importUsers?: string,
            branchLabel?: string,
            branchTag?: string,
            branchComment?: string,
            branchBaseProjectLabel?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).rootPost(
                label,
                shortLabel,
                overwrite,
                importUsers,
                branchLabel,
                branchTag,
                branchComment,
                branchBaseProjectLabel,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Retrieves the user list
         * @param {string} details (optional) -  if set to 1 returns all details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGet(details: string, options?: any) {
            return DefaultApiFp(configuration).userGet(details, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Creates a new user. Arguments are either a set of arguments or json
         * @param {string} login User login name
         * @param {string} email User email
         * @param {string} password User password in clear
         * @param {string} json A json struct with login, email, password, first, last, signatureImage(int), signaturePassword, admin(int)
         * @param {string} [first] User first name (optional)
         * @param {string} [last] User last name (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPost(
            login: string,
            email: string,
            password: string,
            json: string,
            first?: string,
            last?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).userPost(
                login,
                email,
                password,
                json,
                first,
                last,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Retrieves all actions of a user
         * @param {string} user user login name
         * @param {number} [startAt] (optional) Pagination -  starts the audit after N records
         * @param {number} [maxResults] (optional) Pagination -  Retrieve N results per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserAuditGet(user: string, startAt?: number, maxResults?: number, options?: any) {
            return DefaultApiFp(configuration).userUserAuditGet(user, startAt, maxResults, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Check a user's password
         * @param {string} user user login name
         * @param {string} password Asks for a check of the password1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserCheckGet(user: string, password: string, options?: any) {
            return DefaultApiFp(configuration).userUserCheckGet(user, password, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Check a user's password
         * @param {string} user user login name
         * @param {string} password Asks for a check of the password1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserCheckPost(user: string, password: string, options?: any) {
            return DefaultApiFp(configuration).userUserCheckPost(user, password, options)(fetch, basePath);
        },
        /**
         * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.1
         * @summary Removes a user completely.
         * @param {string} user user login name
         * @param {string} confirm Needs to be yes for the method to be executed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserDelete(user: string, confirm: string, options?: any) {
            return DefaultApiFp(configuration).userUserDelete(user, confirm, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
         * @summary Retrieves all projects a user has access to
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserDetailsGet(user: string, options?: any) {
            return DefaultApiFp(configuration).userUserDetailsGet(user, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Retrieves full details of a user
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserGet(user: string, options?: any) {
            return DefaultApiFp(configuration).userUserGet(user, options)(fetch, basePath);
        },
        /**
         * Permissions - No permissions needed. Valid from version 2.1
         * @summary Login
         * @param {string} user user login name
         * @param {string} password password in clear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserLoginPost(user: string, password: string, options?: any) {
            return DefaultApiFp(configuration).userUserLoginPost(user, password, options)(fetch, basePath);
        },
        /**
         * Permissions - Must have a valid authentication. Valid from version 2.1
         * @summary Logout
         * @param {string} user user login name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserLogoutPost(user: string, options?: any) {
            return DefaultApiFp(configuration).userUserLogoutPost(user, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Sets a new password for an account that has a password_reset token in place (the {user} in the URL doesn't matter)
         * @param {string} user user login name
         * @param {string} token password_reset token
         * @param {string} password New password to use from now on
         * @param {string} [signaturePassword] (optional) New password to use from now on for signatures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserPasswordResetPost(
            user: string,
            token: string,
            password: string,
            signaturePassword?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).userUserPasswordResetPost(
                user,
                token,
                password,
                signaturePassword,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Adds a user to a project
         * @param {string} user user login name
         * @param {string} project Project short label
         * @param {number} permission 0 for no access, 1 for readonly, 2 for read/write (default), 3 for admin, 4 for visitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserProjectPost(user: string, project: string, permission: number, options?: any) {
            return DefaultApiFp(configuration).userUserProjectPost(user, project, permission, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Edits the user permissions in a project. If permission is 0, it means the user has no longer access (but we retain its records for audit purposes)
         * @param {string} user user login name
         * @param {string} project Project short label
         * @param {number} permission 0 for no access, 1 for readonly, 2 for read/write (default), 3 for admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserProjectPut(user: string, project: string, permission: number, options?: any) {
            return DefaultApiFp(configuration).userUserProjectPut(user, project, permission, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Edits the user details. Arguments are all separated or a single json argument. Regular users can only change their signature and passwords.
         * @param {string} user user login name
         * @param {string} email User new email
         * @param {string} password User new password in clear
         * @param {string} json A json struct with login, email, password, first, last, signatureImage(int), signaturePassword, admin(int)
         * @param {string} [first] User first name (optional)
         * @param {string} [last] User last name (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserPut(
            user: string,
            email: string,
            password: string,
            json: string,
            first?: string,
            last?: string,
            options?: any,
        ) {
            return DefaultApiFp(configuration).userUserPut(
                user,
                email,
                password,
                json,
                first,
                last,
                options,
            )(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.2
         * @summary Renames a user login
         * @param {string} user user login name
         * @param {string} newLogin The new login name. Cannot be one of the existing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserRenamePut(user: string, newLogin: string, options?: any) {
            return DefaultApiFp(configuration).userUserRenamePut(user, newLogin, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Adds or deletes a user setting.
         * @param {string} user user login name
         * @param {string} key Name of the setting
         * @param {string} value Value of the setting. If empty, deletes the setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserSettingPost(user: string, key: string, value: string, options?: any) {
            return DefaultApiFp(configuration).userUserSettingPost(user, key, value, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin. Valid from version 2.1
         * @summary Sets the new status of the user. Can be normal,blocked or deleted
         * @param {string} user user login name
         * @param {string} status Can be normal,blocked or deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserStatusPut(user: string, status: string, options?: any) {
            return DefaultApiFp(configuration).userUserStatusPut(user, status, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Removes a user token
         * @param {string} user user login name
         * @param {number} tokenId The tokenId of the token to be removed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserTokenDelete(user: string, tokenId: number, options?: any) {
            return DefaultApiFp(configuration).userUserTokenDelete(user, tokenId, options)(fetch, basePath);
        },
        /**
         * Permissions - Must be admin or the user. Valid from version 2.1
         * @summary Adds a token for a user
         * @param {string} user user login name
         * @param {string} purpose Purpose of the token. Not checked. Should contain either \&quot;password_reset\&quot; or \&quot;oauth\&quot;
         * @param {string} [value] Value of the token - by default generated by this call
         * @param {string} [reason] Free text explain where the token will be used (URL or others). Should be set for oauth, not needed for others
         * @param {number} [validity] Validity of the token in hours - if not set, doesn&#x27;t expire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUserTokenPost(
            user: string,
            purpose: string,
            value?: string,
            reason?: string,
            validity?: number,
            options?: any,
        ) {
            return DefaultApiFp(configuration).userUserTokenPost(
                user,
                purpose,
                value,
                reason,
                validity,
                options,
            )(fetch, basePath);
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Permissions - No permissions needed. Valid from version 2.1
     * @summary Asks for the difference between A and B html exerpts, and produce the B html with annotations
     * @param {string} [arg] json object with the arguments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allCompareHtmlPost(arg?: string, options?: any) {
        return DefaultApiFp(this.configuration).allCompareHtmlPost(arg, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.1
     * @summary Returns all info about a date
     * @param {string} [date] (optional) an input date formatted as iso8601. If not present, current date/time is used
     * @param {string} [dateformat] (optional) a date formatter. If not present, current date format is used
     * @param {string} [timeformat] (optional) a date-time formatter. If not present, current date/time format is used
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allDateGet(date?: string, dateformat?: string, timeformat?: string, options?: any) {
        return DefaultApiFp(this.configuration).allDateGet(
            date,
            dateformat,
            timeformat,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have the right key to download the file. Valid from version 2.1
     * @summary Retrieve one customer file. The fileno is a simple fileId. This request returns the actual file
     * @param {number} fileno file number
     * @param {string} key The key of the file
     * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allFileFilenoGet(fileno: number, key: string, disposition?: string, options?: any) {
        return DefaultApiFp(this.configuration).allFileFilenoGet(
            fileno,
            key,
            disposition,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Retrieve list of all customer-wide files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allFileGet(options?: any) {
        return DefaultApiFp(this.configuration).allFileGet(options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.1
     * @summary Creates a new customer-wide file - the file should be uploaded as payload. Its mime type should be sent through the HTTP protocol.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allFilePost(options?: any) {
        return DefaultApiFp(this.configuration).allFilePost(options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Retrieve license status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allLicenseGet(options?: any) {
        return DefaultApiFp(this.configuration).allLicenseGet(options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Adds a log entry (server side).
     * @param {string} message Message to log
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allLogPost(message: string, options?: any) {
        return DefaultApiFp(this.configuration).allLogPost(message, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.4
     * @summary Update matrix instance log level.
     * @param {LogLevel} [body] Payload containing the log level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allLoglevelPut(body?: LogLevel, options?: any) {
        return DefaultApiFp(this.configuration).allLoglevelPut(body, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.5
     * @summary Add metrics entry.
     * @param {Metric} [body] Payload containing the metric data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allMetricsPut(body?: Metric, options?: any) {
        return DefaultApiFp(this.configuration).allMetricsPut(body, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - No permissions needed. Valid from version 2.1
     * @summary Monitoring object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allMonitorGet(options?: any) {
        return DefaultApiFp(this.configuration).allMonitorGet(options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - No permissions needed. Valid from version 2.2
     * @summary The OpenAPI 3.0 definition of our REST API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allOpenapiGet(options?: any) {
        return DefaultApiFp(this.configuration).allOpenapiGet(options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - No permissions needed. Valid from version 2.1
     * @summary Lists all reports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allReportsGet(options?: any) {
        return DefaultApiFp(this.configuration).allReportsGet(options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.1
     * @summary Sends an email. Non-optional parameters are sent as a POST JSON payload.
     * @param {SendmailParam} [body] Necessary information to send a mail
     * @param {number} [system] (optional) if set to 1 makes it a system email (not sent by the actual user)
     * @param {number} [noreply] (optional) if set to 1 makes it a no-reply email (not sent by the actual user)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allSendmailPost(body?: SendmailParam, system?: number, noreply?: number, options?: any) {
        return DefaultApiFp(this.configuration).allSendmailPost(
            body,
            system,
            noreply,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.1
     * @summary Creates a service desk issue. The parameters are sent as a POST JSON payload.
     * @param {ServiceDeskParam} [body] Necessary information to send a mail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allServicedeskPost(body?: ServiceDeskParam, options?: any) {
        return DefaultApiFp(this.configuration).allServicedeskPost(body, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get all settings of a customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allSettingGet(options?: any) {
        return DefaultApiFp(this.configuration).allSettingGet(options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Adds or changes a customer setting. If the value is empty, the setting will be deleted.
     * @param {string} key setting key
     * @param {string} value value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allSettingPost(key: string, value: string, options?: any) {
        return DefaultApiFp(this.configuration).allSettingPost(key, value, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get instance status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allStatusGet(options?: any) {
        return DefaultApiFp(this.configuration).allStatusGet(options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - No permissions needed. Valid from version 2.1
     * @summary Returns all accepted time zones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allTimezoneGet(options?: any) {
        return DefaultApiFp(this.configuration).allTimezoneGet(options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
     * @summary Get all todos for the current user, for all projects
     * @param {number} [includeDone] (optional) set to 1 to include done todos and todo&#x27;s created by the user
     * @param {number} [includeFuture] (optional) set to 1 to include future todos as well (defaults to 0)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allTodoGet(includeDone?: number, includeFuture?: number, options?: any) {
        return DefaultApiFp(this.configuration).allTodoGet(
            includeDone,
            includeFuture,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary WebHook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public allWebhookPost(options?: any) {
        return DefaultApiFp(this.configuration).allWebhookPost(options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.2
     * @summary Retrieves the group list
     * @param {number} [details] (optional) -  if set to 1 returns all details -- in this case user needs to be ADMIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public groupGet(details?: number, options?: any) {
        return DefaultApiFp(this.configuration).groupGet(details, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.2
     * @summary Removes a group
     * @param {string} groupId group Id
     * @param {string} confirm Needs to be yes for the method to be executed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public groupGroupIdDelete(groupId: string, confirm: string, options?: any) {
        return DefaultApiFp(this.configuration).groupGroupIdDelete(
            groupId,
            confirm,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.2
     * @summary Retrieves details of a group
     * @param {string} groupId group Id
     * @param {number} [details] (optional) -  if set to 1 returns all details -- in this case user needs to be ADMIN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public groupGroupIdGet(groupId: string, details?: number, options?: any) {
        return DefaultApiFp(this.configuration).groupGroupIdGet(groupId, details, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.2
     * @summary Adds a group to a project (or removes it)
     * @param {string} groupId group Id
     * @param {string} project Project short label
     * @param {number} [permission] Specify the (new) permission for that group in that project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public groupGroupIdProjectProjectPost(groupId: string, project: string, permission?: number, options?: any) {
        return DefaultApiFp(this.configuration).groupGroupIdProjectProjectPost(
            groupId,
            project,
            permission,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.2
     * @summary Renames a group
     * @param {string} groupId group Id
     * @param {string} newName The new group name. Cannot be one of the existing. Must start with &#x27;group.&#x27;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public groupGroupIdRenamePut(groupId: string, newName: string, options?: any) {
        return DefaultApiFp(this.configuration).groupGroupIdRenamePut(
            groupId,
            newName,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin or the user. Valid from version 2.2
     * @summary Adds a user to a group
     * @param {string} groupId group Id
     * @param {string} user user login name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public groupGroupIdUserUserPut(groupId: string, user: string, options?: any) {
        return DefaultApiFp(this.configuration).groupGroupIdUserUserPut(
            groupId,
            user,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.2
     * @summary Sets all users of a group (replacing potential former content)
     * @param {string} groupId group Id
     * @param {string} users List of all users members of that group, commas-separated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public groupGroupIdUserlistPut(groupId: string, users: string, options?: any) {
        return DefaultApiFp(this.configuration).groupGroupIdUserlistPut(
            groupId,
            users,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.2
     * @summary Removes a user from a group
     * @param {string} groupName group name
     * @param {string} user user login name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public groupGroupNameUserUserDelete(groupName: string, user: string, options?: any) {
        return DefaultApiFp(this.configuration).groupGroupNameUserUserDelete(
            groupName,
            user,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.2
     * @summary Creates a new group
     * @param {string} groupLabel The name of the group to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public groupPost(groupLabel: string, options?: any) {
        return DefaultApiFp(this.configuration).groupPost(groupLabel, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.3
     * @summary Merge branch into mainline. First project is the mainline, second is the branch. The payload must contain a json object with a list of actions to perform.
     * @param {string} mainproject mainproject
     * @param {string} branchproject branchproject
     * @param {string} reason The reason why the user is doing this
     * @param {MergeParam} [body] Actions to perform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public mainprojectMergeBranchprojectPost(
        mainproject: string,
        branchproject: string,
        reason: string,
        body?: MergeParam,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).mainprojectMergeBranchprojectPost(
            mainproject,
            branchproject,
            reason,
            body,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have QMS viewer access (or higher) to the project. Valid from version 2.2
     * @summary Retrieves all accesses in a project (list of groups and users who have access)
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectAccessGet(project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectAccessGet(project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Retrieves all changes in a project
     * @param {string} project Project short label
     * @param {number} [startAt] (optional) Pagination -  starts the audit after N records
     * @param {number} [maxResults] (optional) Pagination -  Retrieve N results per page
     * @param {string} [deleteOnly] (optional) if set to yes, only returns actions of type delete
     * @param {string} [tech] (optional) if set to yes, returns the underneath changes
     * @param {number} [auditIdMin] (optional) sets a minimum ID for audits, as returned by GET calendar
     * @param {number} [auditIdMax] (optional) sets a maximum ID for audits
     * @param {number} [noReport] (optional) set to 1 to avoid having reports
     * @param {number} [noImport] (optional) set to 1 to avoid having imports
     * @param {string} [include] (optional) set to a list of actions to include (delete,undelete,add,edit,...)
     * @param {number} [resolveRef] (optional) set to 1 to resolve item IDs into refs
     * @param {string} [itemRef] (optional) restrict the audit to only those mentionning this item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectAuditGet(
        project: string,
        startAt?: number,
        maxResults?: number,
        deleteOnly?: string,
        tech?: string,
        auditIdMin?: number,
        auditIdMax?: number,
        noReport?: number,
        noImport?: number,
        include?: string,
        resolveRef?: number,
        itemRef?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectAuditGet(
            project,
            startAt,
            maxResults,
            deleteOnly,
            tech,
            auditIdMin,
            auditIdMax,
            noReport,
            noImport,
            include,
            resolveRef,
            itemRef,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.3
     * @summary Launches a server-side branch or clone - needs the 'merge' module if actual branching
     * @param {string} project Project short label
     * @param {string} label Branch project label
     * @param {string} shortLabel Branch project short label
     * @param {number} keepPermissions 1 or 0. Defaults to 0 (with 0 the project doesn&#x27;t have any permission after branching)
     * @param {number} keepContent 1 or 0. Defaults to 1. 0 only works without branch and without history
     * @param {number} [branch] (optional) Set to 1 to branch (default), 0 to just copy/clone
     * @param {number} [history] (optional) Set to 1 to branch or copy with history, defaults to 0
     * @param {string} [tagToCreate] (optional) specify a tag (by default auto-generated)
     * @param {string} [branchInThePastTag] (optional) specify a tag to branch in the past (needs history&#x3D;1)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectBranchPost(
        project: string,
        label: string,
        shortLabel: string,
        keepPermissions: number,
        keepContent: number,
        branch?: number,
        history?: number,
        tagToCreate?: string,
        branchInThePastTag?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectBranchPost(
            project,
            label,
            shortLabel,
            keepPermissions,
            keepContent,
            branch,
            history,
            tagToCreate,
            branchInThePastTag,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get all dates at which a project has been modified
     * @param {string} project Project short label
     * @param {string} [deleteOnly] (optional) if set to yes, only report actions of type delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCalendarGet(project: string, deleteOnly?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectCalendarGet(
            project,
            deleteOnly,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Removes (inactivate) a category. Will fail on REPORT and FOLDER categories
     * @param {string} project Project short label
     * @param {string} category Category short label
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCatCategoryDelete(project: string, category: string, reason: string, options?: any) {
        return DefaultApiFp(this.configuration).projectCatCategoryDelete(
            project,
            category,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get details of a category
     * @param {string} project Project short label
     * @param {string} category Category short label
     * @param {string} [filter] (optional) specify a filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCatCategoryGet(project: string, category: string, filter?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectCatCategoryGet(
            project,
            category,
            filter,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Modifies a categorie's labels, and fix the project's settings to reflect that change, OR modifies a category's order.
     * @param {string} project Project short label
     * @param {string} category Category short label
     * @param {number} order The new order (for reordering)
     * @param {string} shortLabel The new short label for that category (for renaming)
     * @param {string} label The new long label for that category (for renaming)
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCatCategoryPut(
        project: string,
        category: string,
        order: number,
        shortLabel: string,
        label: string,
        reason: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectCatCategoryPut(
            project,
            category,
            order,
            shortLabel,
            label,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get all settings of a category
     * @param {string} project Project short label
     * @param {string} category Category short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCatCategorySettingGet(project: string, category: string, options?: any) {
        return DefaultApiFp(this.configuration).projectCatCategorySettingGet(
            project,
            category,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Adds or changes a category setting. If the value is empty, the setting will be deleted
     * @param {string} project Project short label
     * @param {string} category Category short label
     * @param {string} key setting key
     * @param {string} value value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCatCategorySettingPost(project: string, category: string, key: string, value: string, options?: any) {
        return DefaultApiFp(this.configuration).projectCatCategorySettingPost(
            project,
            category,
            key,
            value,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get all categories of a project
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCatGet(project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectCatGet(project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Adds a fields in a category
     * @param {string} project Project short label
     * @param {string} label Field label
     * @param {string} category Category short label
     * @param {string} fieldType Type of field
     * @param {string} fieldParam Parameter for the field
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCatPost(
        project: string,
        label: string,
        category: string,
        fieldType: string,
        fieldParam: string,
        reason: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectCatPost(
            project,
            label,
            category,
            fieldType,
            fieldParam,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Clones a project
     * @param {string} project Project short label
     * @param {string} label Project label
     * @param {string} shortLabel Project short label
     * @param {number} keepHistory 1 or 0. Defaults to 0
     * @param {number} keepContent 1 or 0. Defaults to 0 (only the REPORT part is kept, make sense only if keepHistory is 0)
     * @param {number} keepPermissions 1 or 0. Defaults to 0 (with 0 the project doesn&#x27;t have any permission after cloning)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectClonePost(
        project: string,
        label: string,
        shortLabel: string,
        keepHistory: number,
        keepContent: number,
        keepPermissions: number,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectClonePost(
            project,
            label,
            shortLabel,
            keepHistory,
            keepContent,
            keepPermissions,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Asks for the difference between 2 signed documents, as a Word document. The job ID is returned as answer
     * @param {string} project Project short label
     * @param {string} signitem1 SIGN-xx for the first SIGN document to compare
     * @param {string} signitem2 SIGN-xx for the 2nd SIGN document to compare
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCompareSignitem1Signitem2Post(project: string, signitem1: string, signitem2: string, options?: any) {
        return DefaultApiFp(this.configuration).projectCompareSignitem1Signitem2Post(
            project,
            signitem1,
            signitem2,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get a project's schema
     * @param {string} [excludeCategories] (optional) comma-separated list of categories to exclude, like DOC,SIGN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectConfigcheckGet(excludeCategories?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectConfigcheckGet(excludeCategories, options)(
            this.fetch,
            this.basePath,
        );
    }

    /**
     * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.2
     * @summary Copy items from a folder to another one
     * @param {string} project Project short label
     * @param {string} itemOrFolder Item reference (XXX-nn) or folder (F-XXX-nn)
     * @param {string} targetFolder Reference of the target folder (F-categ-serial)
     * @param {string} reason The reason why the user is doing this
     * @param {string} [targetProject] (optional) project to copy into (by default, same project)
     * @param {number} [copyLabels] (optional) 0 or 1. Defaults to 0
     * @param {string} [map] (optional) mapN&#x3D;M -  map field N in source to field M in target
     * @param {string} [ignoreLabels] (optional) can contain a comma-delimited list of labels NOT to copy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCopyItemOrFolderPost(
        project: string,
        itemOrFolder: string,
        targetFolder: string,
        reason: string,
        targetProject?: string,
        copyLabels?: number,
        map?: string,
        ignoreLabels?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectCopyItemOrFolderPost(
            project,
            itemOrFolder,
            targetFolder,
            reason,
            targetProject,
            copyLabels,
            map,
            ignoreLabels,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get cross project links
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectCrossprojectlinkGet(project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectCrossprojectlinkGet(project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.1
     * @summary Removes completely a project (only used for unit testing). This is an actual DELETE in the database.
     * @param {string} project Project short label
     * @param {string} confirm Needs to be yes for the method to be executed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectDelete(project: string, confirm: string, options?: any) {
        return DefaultApiFp(this.configuration).projectDelete(project, confirm, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Converts an excel file (xls, xlsx) into a XML version that we send straight back as an XML payload.
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectExcelxmlPost(project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectExcelxmlPost(project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Executes UC or TC into XTC items
     * @param {string} project Project short label
     * @param {ExecuteParam} [body] There must be a JSON as a payload. It includes all parameters AND the reason
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectExecutePost(project: string, body?: ExecuteParam, options?: any) {
        return DefaultApiFp(this.configuration).projectExecutePost(project, body, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Asks for an export of some items. The job ID is returned as answer
     * @param {string} project Project short label
     * @param {string} itemList Mandatory list of items to export.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectExportGet(project: string, itemList: string, options?: any) {
        return DefaultApiFp(this.configuration).projectExportGet(project, itemList, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Removes (inactivate) a field.
     * @param {string} project Project short label
     * @param {string} category Category short label
     * @param {number} field The field number (like field&#x3D;502)
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectFieldCategoryDelete(project: string, category: string, field: number, reason: string, options?: any) {
        return DefaultApiFp(this.configuration).projectFieldCategoryDelete(
            project,
            category,
            field,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get 1 field of an item. {item} has the form CATEG-number.
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {string} field Mandatory. Field number (faster) OR field label
     * @param {string} [format] Optional. Format for the return. Can be text, json, html, xml or xslt. Defaults to html
     * @param {number} [download] Optional. 1 to have in download, 0 as direct result. Defaults to 0.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectFieldItemGet(
        project: string,
        item: string,
        field: string,
        format?: string,
        download?: number,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectFieldItemGet(
            project,
            item,
            field,
            format,
            download,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Modifies a field's label and parameter OR modifies a field's order.
     * @param {string} project Project short label
     * @param {number} field The field number (like field&#x3D;502)
     * @param {string} label The new label (for renaming)
     * @param {string} fieldParam The new parameter (for renaming)
     * @param {number} order The new order (for reordering)
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectFieldPut(
        project: string,
        field: number,
        label: string,
        fieldParam: string,
        order: number,
        reason: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectFieldPut(
            project,
            field,
            label,
            fieldParam,
            order,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have the right key to download the file. Valid from version 2.1
     * @summary Retrieve one project file. The fileno is a simple fileId. This request returns the actual file
     * @param {string} project Project short label
     * @param {number} fileno file number
     * @param {string} key The key of the file
     * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectFileFilenoGet(project: string, fileno: number, key: string, disposition?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectFileFilenoGet(
            project,
            fileno,
            key,
            disposition,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.1
     * @summary Retrieve list of all files owned by a project
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectFileGet(project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectFileGet(project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Creates a new file - the file should be uploaded as payload (or through the url argument as an alternative). It's mime type should be sent through the HTTP protocol.
     * @param {string} project Project short label
     * @param {string} [url] Optional argument -  the file could also come from an external URL. In this case there will be an error if we can&#x27;t retrieve it on the server
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectFilePost(project: string, url?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectFilePost(project, url, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.1
     * @summary Creates a new folder
     * @param {string} project Project short label
     * @param {string} parent Reference of the parent folder in the form F-CATEG-serial (example -  F-SPEC-17)
     * @param {string} label folder label
     * @param {string} reason The reason why the user is doing this
     * @param {string} [fxField] (optional) Add one of each of these to set folder&#x27;s fields. fx is followed by the field ID (a number)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectFolderPost(
        project: string,
        parent: string,
        label: string,
        reason: string,
        fxField?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectFolderPost(
            project,
            parent,
            label,
            reason,
            fxField,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get list of project info -  users, settings, categories
     * @param {string} project Project short label
     * @param {number} [adminUI] (optional) set to adminUI&#x3D;1 to have this project data even if you are not assigned to, as an admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectGet(project: string, adminUI?: number, options?: any) {
        return DefaultApiFp(this.configuration).projectGet(project, adminUI, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.2
     * @summary Hides a project
     * @param {string} project Project short label
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectHidePut(project: string, reason: string, options?: any) {
        return DefaultApiFp(this.configuration).projectHidePut(project, reason, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.2
     * @summary Launches a server-side hook
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {string} hook name of the hook
     * @param {string} [body] Payload for the hook, treated as a string.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectHookItemPost(project: string, item: string, hook: string, body?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectHookItemPost(
            project,
            item,
            hook,
            body,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
     * @summary Cleans up an input html blob according to the current html cleanup rules. The blob is passed in the POST payload. The payload must be a json object with {\"htmlToClean\" - \"x\"}
     * @param {string} project Project short label
     * @param {GetHmlBlobInput} [body] Payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectHtmlCleanupBlobPost(project: string, body?: GetHmlBlobInput, options?: any) {
        return DefaultApiFp(this.configuration).projectHtmlCleanupBlobPost(
            project,
            body,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
     * @summary Get the list of items that would be changed if we applied html cleanup. You can pass a cleanup setting in the payload of the POST. If it's not there we take the customer (global) setting and force the cleanup to true
     * @param {string} project Project short label
     * @param {CleanupSetting} [body] Cleanup setting (optional)
     * @param {string} [categories] (optional) list of comma-delimited categories to go through, all by default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectHtmlCleanupTestPost(project: string, body?: CleanupSetting, categories?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectHtmlCleanupTestPost(
            project,
            body,
            categories,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - ?. Valid from version 2.1
     * @summary Removes an import
     * @param {string} project Project short label
     * @param {string} id id
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectImportIdDelete(project: string, id: string, reason: string, options?: any) {
        return DefaultApiFp(this.configuration).projectImportIdDelete(
            project,
            id,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Imports some items into a project
     * @param {string} project Project short label
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectImportPost(project: string, reason: string, options?: any) {
        return DefaultApiFp(this.configuration).projectImportPost(project, reason, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
     * @summary Get the history of a import in a project
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectImportinfoGet(project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectImportinfoGet(project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get details of a folder. {folder} has the form F-CATEG-number[-vN].
     * @param {string} project Project short label
     * @param {string} folder Folder reference (F-XXX-nn)
     * @param {number} [history] (optional) set history&#x3D;1 to retrieve list of all versions
     * @param {string} [filter] (optional) specify a filter
     * @param {string} [children] (optional) set to yes if you need the children as well (recursively).
     * @param {string} [atDate] (optional) retrieves the item at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z. Not compatible with the version query -vN
     * @param {number} [fields] (optional) set fields&#x3D;1 to retrieve list of all fields, even the empty ones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectItemFolderGet(
        project: string,
        folder: string,
        history?: number,
        filter?: string,
        children?: string,
        atDate?: string,
        fields?: number,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectItemFolderGet(
            project,
            folder,
            history,
            filter,
            children,
            atDate,
            fields,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Removes (inactivate) an item (or a folder). Item has the form (F-)CATEG-number. Will fail on non-empty folders
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {string} confirm Needs to be yes for the method to be executed IF it is a non-empty folder
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectItemItemDelete(project: string, item: string, confirm: string, reason: string, options?: any) {
        return DefaultApiFp(this.configuration).projectItemItemDelete(
            project,
            item,
            confirm,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get details of an item. {item} has the form CATEG-number[-vN].
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {number} [history] (optional) set history&#x3D;1 to retrieve list of all versions
     * @param {number} [fields] (optional) set fields&#x3D;1 to retrieve list of all fields, even the empty ones
     * @param {string} [filter] (optional) specify a filter
     * @param {string} [atDate] (optional) retrieves the item at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z. Not compatible with the version query -vN
     * @param {number} [withTree] (optional) retrieves the context tree if set to 1, in the field contextTree. Exclusive to filter and atDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectItemItemGet(
        project: string,
        item: string,
        history?: number,
        fields?: number,
        filter?: string,
        atDate?: string,
        withTree?: number,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectItemItemGet(
            project,
            item,
            history,
            fields,
            filter,
            atDate,
            withTree,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Restores an item. Item has the form CATEG-number
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {string} reason The reason why the user is doing this
     * @param {number} [at] (optional) If set, specifies that the item should be restored as it was in that version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectItemItemPost(project: string, item: string, reason: string, at?: number, options?: any) {
        return DefaultApiFp(this.configuration).projectItemItemPost(
            project,
            item,
            reason,
            at,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Modifies an item or a folder. Item has the form CATEG-number, folders -  F-CATEG-number
     * @param {ItemItemBody} body
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectItemItemPut(body: ItemItemBody, project: string, item: string, options?: any) {
        return DefaultApiFp(this.configuration).projectItemItemPut(
            body,
            project,
            item,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project - admins can impersonate. Valid from version 2.1
     * @summary Adds an item in a folder
     * @param {ProjectItemBody} body
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectItemPost(body: ProjectItemBody, project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectItemPost(body, project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - ?. Valid from version 2.1
     * @summary Removes (inactivate) a link between 2 items. Items are in the form CATEG-number
     * @param {string} project Project short label
     * @param {string} upitem Item reference (XXX-nn) for the UP item
     * @param {string} downitem Item reference (XXX-nn) for the DOWN item
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectItemlinkUpitemDownitemDelete(
        project: string,
        upitem: string,
        downitem: string,
        reason: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectItemlinkUpitemDownitemDelete(
            project,
            upitem,
            downitem,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Adds a link between 2 items. Both items are in the form CATEG-number
     * @param {string} project Project short label
     * @param {string} upitem Item reference (XXX-nn) for the UP item
     * @param {string} downitem Item reference (XXX-nn) for the DOWN item
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectItemlinkUpitemDownitemPost(
        project: string,
        upitem: string,
        downitem: string,
        reason: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectItemlinkUpitemDownitemPost(
            project,
            upitem,
            downitem,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get the list of items that are detailed in a DOC/SIGN item.
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {number} [detailed] Optional. When set to 1 adds a secondaryItems list in the answer. Defaults to 0.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectItemlistItemGet(project: string, item: string, detailed?: number, options?: any) {
        return DefaultApiFp(this.configuration).projectItemlistItemGet(
            project,
            item,
            detailed,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.1
     * @summary Retrieve list of all jobs in a project
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectJobGet(project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectJobGet(project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.3
     * @summary Aborts a job.
     * @param {string} project Project short label
     * @param {number} job job number
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectJobJobDelete(project: string, job: number, reason: string, options?: any) {
        return DefaultApiFp(this.configuration).projectJobJobDelete(
            project,
            job,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get a job file. The job part is the jobID (a number) and the file is the fileID (a number)
     * @param {string} project Project short label
     * @param {number} job job number
     * @param {number} fileno file number
     * @param {string} [mode] (optional) set to mode&#x3D;direct to get the output in the response output instead of as a download file. This assumes the file is HTML
     * @param {string} [format] (optional) set to format&#x3D;json to get a json output instead of XML
     * @param {string} [disposition] (optional, from version 2.3) set to disposition&#x3D;inline to ask the server to send the disposition to &#x27;inline&#x27; instead of &#x27;attachment&#x27;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectJobJobFilenoGet(
        project: string,
        job: number,
        fileno: number,
        mode?: string,
        format?: string,
        disposition?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectJobJobFilenoGet(
            project,
            job,
            fileno,
            mode,
            format,
            disposition,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get a job status, including generated files. The variable part is the jobID (a number)
     * @param {string} project Project short label
     * @param {number} job job number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectJobJobGet(project: string, job: number, options?: any) {
        return DefaultApiFp(this.configuration).projectJobJobGet(project, job, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.2
     * @summary Sets the progress of a job
     * @param {string} project Project short label
     * @param {number} job job number
     * @param {number} progress progress (0 to 100, 200 for error)
     * @param {string} [status] (optional( status text
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectJobJobPost(project: string, job: number, progress: number, status?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectJobJobPost(
            project,
            job,
            progress,
            status,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
     * @summary Get the label history of a project -  list of all label changes for all items
     * @param {string} project Project short label
     * @param {string} [itemRef] (optional) ask for just one item (the return structure is still an array in that case)
     * @param {string} [from] (optional) date from
     * @param {string} [to] (optional) date to - works only if you only specified a from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectLabelhistoryGet(project: string, itemRef?: string, from?: string, to?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectLabelhistoryGet(
            project,
            itemRef,
            from,
            to,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
     * @summary Get the merge history of a project - needs the 'merge' module
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectMergehistoryGet(project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectMergehistoryGet(project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.3
     * @summary Get the merge information - needs the 'merge' module
     * @param {string} project Project short label
     * @param {string} [excludeCategories] (optional) comma-delimited list of categories to exclude
     * @param {string} [fromDate] (optional) date from which we consider the merges. ISO8601 format -- this parameter was introduced in v 2.3.4
     * @param {number} [push] (optional) set to 1 if you inquire about a push, not a merge -- this parameter was introduced in v 2.3.4
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectMergeinfoGet(
        project: string,
        excludeCategories?: string,
        fromDate?: string,
        push?: number,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectMergeinfoGet(
            project,
            excludeCategories,
            fromDate,
            push,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Imports some folders from a project to another as a module. Only available is you have the compose module licensed
     * @param {string} project Project short label
     * @param {string} mode Import mode -  can be include or copy
     * @param {string} sourceProject Source project
     * @param {string} sourceSelection A selection of folders and items to import
     * @param {string} reason The reason why the user is doing this
     * @param {string} [update] Update mode -  can be simple, update or rebase. If not defined, simple assumed
     * @param {string} [oldSourceProject] Old source project (if update&#x3D;rebase
     * @param {string} [lockLabel] An optional label that this operation will set on all items
     * @param {string} [itemParentMode] Default &#x27;orphan&#x27;. Specify &#x27;preserve&#x27; to include all parent folders to the root
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectModuleimportPost(
        project: string,
        mode: string,
        sourceProject: string,
        sourceSelection: string,
        reason: string,
        update?: string,
        oldSourceProject?: string,
        lockLabel?: string,
        itemParentMode?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectModuleimportPost(
            project,
            mode,
            sourceProject,
            sourceSelection,
            reason,
            update,
            oldSourceProject,
            lockLabel,
            itemParentMode,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Move items into this folder
     * @param {string} project Project short label
     * @param {string} folder Folder reference (F-XXX-nn)
     * @param {string} reason The reason why the user is doing this
     * @param {string} [items] List of items to move in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectMoveinFolderPost(project: string, folder: string, reason: string, items?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectMoveinFolderPost(
            project,
            folder,
            reason,
            items,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Use POST verb instead. Find items based on a search string in one project
     * @param {string} project Project short label
     * @param {string} id search id. Used by MatrixJira js to match queries with answers. Is returned in the output structure
     * @param {string} [search] search term
     * @param {string} [filter] (optional) applies a filter, can be negative
     * @param {string} [fieldsOut] (optional) comma-delimited list of fields to return -  101,102 - or * for all
     * @param {number} [labels] (optional) set to 1 to return labels in the output
     * @param {number} [treeOrder] (optional) set to 1 to return items in tree order (otherwise it&#x27;s project,category,serial)
     * @param {string} [links] (optional) set to up,down to return up and down items, or only up or only down
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectNeedleGet(
        project: string,
        id: string,
        search?: string,
        filter?: string,
        fieldsOut?: string,
        labels?: number,
        treeOrder?: number,
        links?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectNeedleGet(
            project,
            id,
            search,
            filter,
            fieldsOut,
            labels,
            treeOrder,
            links,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
     * @summary Find items based on a search string in one project
     * @param {ProjectNeedleBody} body
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectNeedlePost(body: ProjectNeedleBody, project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectNeedlePost(body, project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Find item ids based on a search string in one project
     * @param {string} project Project short label
     * @param {string} search search term
     * @param {string} [filter] (optional) applies a filter, can be negative
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectNeedleminimalGet(project: string, search: string, filter?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectNeedleminimalGet(
            project,
            search,
            filter,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.4
     * @summary Find item ids based on a search string in one project
     * @param {ProjectNeedleminimalBody} body
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectNeedleminimalPost(body: ProjectNeedleminimalBody, project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectNeedleminimalPost(
            body,
            project,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Adds a category to a project
     * @param {string} project Project short label
     * @param {string} label Category label
     * @param {string} shortLabel Category short label
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectPost(project: string, label: string, shortLabel: string, reason: string, options?: any) {
        return DefaultApiFp(this.configuration).projectPost(
            project,
            label,
            shortLabel,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Publishes an item. Item has the form PUB-nnn
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {string} reason reason for the publication
     * @param {string} [trainingFor] (optional) list of items for which we need to add training. If list is not there, all trainings will be generated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectPublishItemPost(project: string, item: string, reason: string, trainingFor?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectPublishItemPost(
            project,
            item,
            reason,
            trainingFor,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have QMS viewer access (or higher) to the project. Valid from version 2.3
     * @summary Find a string in the QMS published items
     * @param {string} project Project short label
     * @param {string} [search] (optional) search term. Return an empty array on PUB &lt; 2.3.1 and et the list of all pub if not specified.
     * @param {string} [pubItem] (optional) PUB-x item if you want to search in another than the last one for that project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectQmsfindGet(project: string, search?: string, pubItem?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectQmsfindGet(
            project,
            search,
            pubItem,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) for the reports, read/write for the signed reports. Valid from version 2.1
     * @summary Asks for a new report. The job ID is returned as answer. {report} can be REPORT-n, DOC-n, SIGN-n or a report name.To follow the progress of the job, the GET /{project}/job/{jobid} can be called
     * @param {string} project Project short label
     * @param {string} report name of the report
     * @param {string} isSignedReport If set to true, means the report needs to generate a signed record
     * @param {string} includeSignatures List of comma separated users who need to sign
     * @param {string} newTitle New title for the SIGN- item that is generated (only valid for isSignedReport)
     * @param {string} copyFields List of from-to fields (123,456),(124,457) that we can use to generate the fields in the SIGN record (only valid for isSignedReport)
     * @param {string} [itemList] (optional) list of items to use in the report. By default all categories are used
     * @param {string} [url] (optional) url to generate in the filter
     * @param {string} [resturl] (optional) REST url to generate in the filter
     * @param {string} [format] (optional) format -  html (default), pdf, docx, odt, xml, zipdocx, zippdf or package (from 2.2), or mf (since 2.3)
     * @param {string} [filter] (optional) specify a comma-delimited filter list. Can be negative filters (with minus before)
     * @param {number} [useOld] (optional) ask to use the old report engine (pre 1.11) if set to 1.
     * @param {string} [atDate] (optional) generates the report at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z
     * @param {string} [reportNameOverride] (optional) Allow to override the reportName of the provided document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectReportReportPost(
        project: string,
        report: string,
        isSignedReport: string,
        includeSignatures: string,
        newTitle: string,
        copyFields: string,
        itemList?: string,
        url?: string,
        resturl?: string,
        format?: string,
        filter?: string,
        useOld?: number,
        atDate?: string,
        reportNameOverride?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectReportReportPost(
            project,
            report,
            isSignedReport,
            includeSignatures,
            newTitle,
            copyFields,
            itemList,
            url,
            resturl,
            format,
            filter,
            useOld,
            atDate,
            reportNameOverride,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get a project's schema
     * @param {string} project Project short label
     * @param {number} [simple] (optional) set to simple&#x3D;1 to have a simpler output (no fields, round shape)
     * @param {string} [excludeCategories] (optional) comma-separated list of categories to exclude, like DOC,SIGN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectSchemaGet(project: string, simple?: number, excludeCategories?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectSchemaGet(
            project,
            simple,
            excludeCategories,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.1
     * @summary Get all settings of a project
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectSettingGet(project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectSettingGet(project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Adds or changes a project setting. If the value is empty, the setting will be deleted.
     * @param {string} project Project short label
     * @param {string} key setting key
     * @param {string} value value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectSettingPost(project: string, key: string, value: string, options?: any) {
        return DefaultApiFp(this.configuration).projectSettingPost(
            project,
            key,
            value,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Signs an item. Item has the form SIGN-nnn
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {string} password signature password - the user who is signing is the one who is logged in
     * @param {string} [acceptComments] (optional) adds an acceptance comment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectSignItemPost(
        project: string,
        item: string,
        password: string,
        acceptComments?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectSignItemPost(
            project,
            item,
            password,
            acceptComments,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Edit the signature parts
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {string} rejectSign The reason why the user is rejecting the signature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectSignItemPut(project: string, item: string, rejectSign: string, options?: any) {
        return DefaultApiFp(this.configuration).projectSignItemPut(
            project,
            item,
            rejectSign,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Asks for a new report. The job ID is returned as answer
     * @param {string} project Project short label
     * @param {string} [url] (optional) url to generate in the filter
     * @param {string} [resturl] (optional) REST url to generate in the filter
     * @param {string} [format] (optional) format -  html (default), pdf, docx, odt, xml, zipdocx or zippdf
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectSignedreportSIGNNPost(
        project: string,
        url?: string,
        resturl?: string,
        format?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectSignedreportSIGNNPost(
            project,
            url,
            resturl,
            format,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.1
     * @summary Get all tags of a project. Works on any project if user is admin
     * @param {string} project Project short label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectTagGet(project: string, options?: any) {
        return DefaultApiFp(this.configuration).projectTagGet(project, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Adds a tag to a project
     * @param {string} project Project short label
     * @param {string} label Tag label. Must be unique within a project
     * @param {number} auditId Id of the audit this tag is based on
     * @param {string} type Type of tag (default -  tag)
     * @param {string} comments Free optional comment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectTagPost(
        project: string,
        label: string,
        auditId: number,
        type: string,
        comments: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectTagPost(
            project,
            label,
            auditId,
            type,
            comments,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
     * @summary Get all todos for the current user, for oneproject
     * @param {string} project Project short label
     * @param {string} [itemRef] (optional) set to an item to have all todos linked to an item, regardless of the user
     * @param {number} [includeDone] (optional) set to 1 to include done todos and todo&#x27;s created by the user
     * @param {number} [includeAllUsers] (optional) set to 1 to include all todos for all users
     * @param {number} [includeFuture] (optional) set to 1 to include future todos as well (defaults to 0)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectTodoGet(
        project: string,
        itemRef?: string,
        includeDone?: number,
        includeAllUsers?: number,
        includeFuture?: number,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectTodoGet(
            project,
            itemRef,
            includeDone,
            includeAllUsers,
            includeFuture,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.2
     * @summary Creates a todo on an item (note that you only need read access for this POST method) for you or others
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {string} text The todo reason
     * @param {number} [fieldId] (optional) If set, specifies that the todo is related to that field (review, ...)
     * @param {string} [logins] (optional) If set, a list of user logins or groups to which these todo apply
     * @param {string} [todoType] (optional) The todo type -  &#x27;user&#x27; by default
     * @param {string} [atDate] (optional) a date in the future for reminders
     * @param {number} [auto] (optional) set to 1 to create an auto-notification (0 by default)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectTodoItemPost(
        project: string,
        item: string,
        text: string,
        fieldId?: number,
        logins?: string,
        todoType?: string,
        atDate?: string,
        auto?: number,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectTodoItemPost(
            project,
            item,
            text,
            fieldId,
            logins,
            todoType,
            atDate,
            auto,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.2
     * @summary Removes (mark as done) a todo.
     * @param {string} project Project short label
     * @param {string} todoid todoid
     * @param {string} hardDelete Set to yes to actually remove the record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectTodoTodoidDelete(project: string, todoid: string, hardDelete: string, options?: any) {
        return DefaultApiFp(this.configuration).projectTodoTodoidDelete(
            project,
            todoid,
            hardDelete,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Touches (set to same date) an item or folder
     * @param {string} project Project short label
     * @param {string} item Item reference (XXX-nn)
     * @param {string} reason The reason why the user is doing this
     * @param {number} [nbLayers] (optional) Number of layers -- 1 by default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectTouchItemPut(project: string, item: string, reason: string, nbLayers?: number, options?: any) {
        return DefaultApiFp(this.configuration).projectTouchItemPut(
            project,
            item,
            reason,
            nbLayers,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read access (or higher) to the project. Valid from version 2.1
     * @summary Get full tree
     * @param {string} project Project short label
     * @param {string} [fancy] (optional) returns a fancy tree
     * @param {string} [filter] (optional) applies a filter
     * @param {string} [atDate] (optional) generates the tree at that date - format is ISO8601 like atDate&#x3D;2018-05-30T14 - 48 - 27.223Z
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectTreeGet(project: string, fancy?: string, filter?: string, atDate?: string, options?: any) {
        return DefaultApiFp(this.configuration).projectTreeGet(
            project,
            fancy,
            filter,
            atDate,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.2
     * @summary Unhides a project.
     * @param {string} project Project short label
     * @param {string} newShort The new project short name to use
     * @param {string} reason The reason why the user is doing this
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectUnhidePut(project: string, newShort: string, reason: string, options?: any) {
        return DefaultApiFp(this.configuration).projectUnhidePut(
            project,
            newShort,
            reason,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have read/write access to the project. Valid from version 2.1
     * @summary Converts a word document to an HTML, with images pointing to uploaded files on the server
     * @param {string} project Project short label
     * @param {string} reason The reason why the user is doing this
     * @param {number} [fileNo] If specified, means that the conversion is from an already uploaded file. Otherwise the file must be uploaded as body of this call
     * @param {string} [targetDocumentFolder] target document folder (in this case creates a document)
     * @param {number} [useAsField] set to 1 to have this docx used as a field. In this case the return value is the html equivalent, with some meta
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public projectWordconvertPost(
        project: string,
        reason: string,
        fileNo?: number,
        targetDocumentFolder?: string,
        useAsField?: number,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).projectWordconvertPost(
            project,
            reason,
            fileNo,
            targetDocumentFolder,
            useAsField,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.1
     * @summary Get list of all projects, all settings and current user, all todos and JIRA meta create object
     * @param {number} [adminUI] (optional) set to adminUI&#x3D;1 to have all projects even the ones you are not assigned to, as an admin
     * @param {string} [output] (optional) comma-delimited list of requested output fields. Returns all fields if parameter is not present
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rootGet(adminUI?: number, output?: string, options?: any) {
        return DefaultApiFp(this.configuration).rootGet(adminUI, output, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Creates a new project. Either the full project is sent as XML payload, or the label and shortLabel are given. If uploading data for a whole project, label and shortLabel are optional but overwrite the XML content if present. Branching can be done with an audit report as payload, and branch* must be defined in that case
     * @param {string} label Project label
     * @param {string} shortLabel Project short label
     * @param {string} [overwrite] Must be set to yes if you&#x27;re overwriting an existing project
     * @param {string} [importUsers] Must be set to yes if you want to import users. false by default
     * @param {string} [branchLabel] Must be set to branch (optional)
     * @param {string} [branchTag] Must be set to branch, and match a tag in the audit export (optional)
     * @param {string} [branchComment] Comment for the branch (optional)
     * @param {string} [branchBaseProjectLabel] Label of the base Project (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rootPost(
        label: string,
        shortLabel: string,
        overwrite?: string,
        importUsers?: string,
        branchLabel?: string,
        branchTag?: string,
        branchComment?: string,
        branchBaseProjectLabel?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).rootPost(
            label,
            shortLabel,
            overwrite,
            importUsers,
            branchLabel,
            branchTag,
            branchComment,
            branchBaseProjectLabel,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin or the user. Valid from version 2.1
     * @summary Retrieves the user list
     * @param {string} details (optional) -  if set to 1 returns all details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userGet(details: string, options?: any) {
        return DefaultApiFp(this.configuration).userGet(details, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Creates a new user. Arguments are either a set of arguments or json
     * @param {string} login User login name
     * @param {string} email User email
     * @param {string} password User password in clear
     * @param {string} json A json struct with login, email, password, first, last, signatureImage(int), signaturePassword, admin(int)
     * @param {string} [first] User first name (optional)
     * @param {string} [last] User last name (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userPost(
        login: string,
        email: string,
        password: string,
        json: string,
        first?: string,
        last?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).userPost(
            login,
            email,
            password,
            json,
            first,
            last,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
     * @summary Retrieves all actions of a user
     * @param {string} user user login name
     * @param {number} [startAt] (optional) Pagination -  starts the audit after N records
     * @param {number} [maxResults] (optional) Pagination -  Retrieve N results per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserAuditGet(user: string, startAt?: number, maxResults?: number, options?: any) {
        return DefaultApiFp(this.configuration).userUserAuditGet(
            user,
            startAt,
            maxResults,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
     * @summary Check a user's password
     * @param {string} user user login name
     * @param {string} password Asks for a check of the password1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserCheckGet(user: string, password: string, options?: any) {
        return DefaultApiFp(this.configuration).userUserCheckGet(user, password, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
     * @summary Check a user's password
     * @param {string} user user login name
     * @param {string} password Asks for a check of the password1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserCheckPost(user: string, password: string, options?: any) {
        return DefaultApiFp(this.configuration).userUserCheckPost(user, password, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Reserved to Matrix Requirements operations. Valid from version 2.1
     * @summary Removes a user completely.
     * @param {string} user user login name
     * @param {string} confirm Needs to be yes for the method to be executed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserDelete(user: string, confirm: string, options?: any) {
        return DefaultApiFp(this.configuration).userUserDelete(user, confirm, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be that user - Matrix operations can impersonate. Valid from version 2.1
     * @summary Retrieves all projects a user has access to
     * @param {string} user user login name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserDetailsGet(user: string, options?: any) {
        return DefaultApiFp(this.configuration).userUserDetailsGet(user, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin or the user. Valid from version 2.1
     * @summary Retrieves full details of a user
     * @param {string} user user login name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserGet(user: string, options?: any) {
        return DefaultApiFp(this.configuration).userUserGet(user, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - No permissions needed. Valid from version 2.1
     * @summary Login
     * @param {string} user user login name
     * @param {string} password password in clear
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserLoginPost(user: string, password: string, options?: any) {
        return DefaultApiFp(this.configuration).userUserLoginPost(user, password, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must have a valid authentication. Valid from version 2.1
     * @summary Logout
     * @param {string} user user login name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserLogoutPost(user: string, options?: any) {
        return DefaultApiFp(this.configuration).userUserLogoutPost(user, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin or the user. Valid from version 2.1
     * @summary Sets a new password for an account that has a password_reset token in place (the {user} in the URL doesn't matter)
     * @param {string} user user login name
     * @param {string} token password_reset token
     * @param {string} password New password to use from now on
     * @param {string} [signaturePassword] (optional) New password to use from now on for signatures
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserPasswordResetPost(
        user: string,
        token: string,
        password: string,
        signaturePassword?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).userUserPasswordResetPost(
            user,
            token,
            password,
            signaturePassword,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Adds a user to a project
     * @param {string} user user login name
     * @param {string} project Project short label
     * @param {number} permission 0 for no access, 1 for readonly, 2 for read/write (default), 3 for admin, 4 for visitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserProjectPost(user: string, project: string, permission: number, options?: any) {
        return DefaultApiFp(this.configuration).userUserProjectPost(
            user,
            project,
            permission,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Edits the user permissions in a project. If permission is 0, it means the user has no longer access (but we retain its records for audit purposes)
     * @param {string} user user login name
     * @param {string} project Project short label
     * @param {number} permission 0 for no access, 1 for readonly, 2 for read/write (default), 3 for admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserProjectPut(user: string, project: string, permission: number, options?: any) {
        return DefaultApiFp(this.configuration).userUserProjectPut(
            user,
            project,
            permission,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin or the user. Valid from version 2.1
     * @summary Edits the user details. Arguments are all separated or a single json argument. Regular users can only change their signature and passwords.
     * @param {string} user user login name
     * @param {string} email User new email
     * @param {string} password User new password in clear
     * @param {string} json A json struct with login, email, password, first, last, signatureImage(int), signaturePassword, admin(int)
     * @param {string} [first] User first name (optional)
     * @param {string} [last] User last name (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserPut(
        user: string,
        email: string,
        password: string,
        json: string,
        first?: string,
        last?: string,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).userUserPut(
            user,
            email,
            password,
            json,
            first,
            last,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.2
     * @summary Renames a user login
     * @param {string} user user login name
     * @param {string} newLogin The new login name. Cannot be one of the existing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserRenamePut(user: string, newLogin: string, options?: any) {
        return DefaultApiFp(this.configuration).userUserRenamePut(user, newLogin, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin or the user. Valid from version 2.1
     * @summary Adds or deletes a user setting.
     * @param {string} user user login name
     * @param {string} key Name of the setting
     * @param {string} value Value of the setting. If empty, deletes the setting.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserSettingPost(user: string, key: string, value: string, options?: any) {
        return DefaultApiFp(this.configuration).userUserSettingPost(
            user,
            key,
            value,
            options,
        )(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin. Valid from version 2.1
     * @summary Sets the new status of the user. Can be normal,blocked or deleted
     * @param {string} user user login name
     * @param {string} status Can be normal,blocked or deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserStatusPut(user: string, status: string, options?: any) {
        return DefaultApiFp(this.configuration).userUserStatusPut(user, status, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin or the user. Valid from version 2.1
     * @summary Removes a user token
     * @param {string} user user login name
     * @param {number} tokenId The tokenId of the token to be removed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserTokenDelete(user: string, tokenId: number, options?: any) {
        return DefaultApiFp(this.configuration).userUserTokenDelete(user, tokenId, options)(this.fetch, this.basePath);
    }

    /**
     * Permissions - Must be admin or the user. Valid from version 2.1
     * @summary Adds a token for a user
     * @param {string} user user login name
     * @param {string} purpose Purpose of the token. Not checked. Should contain either \&quot;password_reset\&quot; or \&quot;oauth\&quot;
     * @param {string} [value] Value of the token - by default generated by this call
     * @param {string} [reason] Free text explain where the token will be used (URL or others). Should be set for oauth, not needed for others
     * @param {number} [validity] Validity of the token in hours - if not set, doesn&#x27;t expire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userUserTokenPost(
        user: string,
        purpose: string,
        value?: string,
        reason?: string,
        validity?: number,
        options?: any,
    ) {
        return DefaultApiFp(this.configuration).userUserTokenPost(
            user,
            purpose,
            value,
            reason,
            validity,
            options,
        )(this.fetch, this.basePath);
    }
}
